export const servicesData = {
  "foreign-company-registration": {
    title: "Incorporation of Foreign Company In India",
    hero: {
      title: "Incorporation of Foreign Company In India",
      description:
        "Under the Companies Act, 2013, a Foreign Company is an entity incorporated outside India (in a foreign country) but has a place of business i.e. a premise that indicates the visible or physical contact with a foreign company in India or carries out business activity in India in any other way.",
      advantages: [
        "Limited Liability Protection",
        "Foreign Direct Investment",
        "Lower Registration Cost",
        "Separate Legal Entity",
        "Less Procedural Compliances",
      ],
      eligibleCriteria: [
        "Minimum Two Persons",
        "DIN of the Person",
        "No Minimum Capital required",
        "DSC of one of the Person",
        "One Partner shall be Indian resident",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction",
          description:
            "Under the Companies Act, 2013, a Foreign Company is an entity incorporated outside India (in a foreign country) but has a place of business i.e. a premise that indicates the visible or physical contact with a foreign company in India or carries out business activity in India in any other way.<br><br> A Foreign Company can be incorporated in India by complying with the provisions of Companies Act, 2013. A person can easily set up a Foreign Company by contacting the best firm for Foreign Company Registration in India. Following are the ways through which one can set up a Foreign Company:",
          content: [
            {
              type: "h4",
              text: "As an Indian Company registered under the Companies Act, 2013",
              bullets: ["Wholly Owned Subsidiary", "Joint Venture"],
            },
            {
              type: "h4",
              text: "As a Foreign Company",
              bullets: [
                "Setting up a Liaison Office",
                "Representative Office or a Project Office or",
                "Branch Office of the foreign company",
              ],
            },
          ],
        },

        {
          title: "Setting Up a Liaison Office or a Representative Office",
          description:
            "Liaison Office is also known as Representative office which is primarily set up for exploring the business environment and also for understanding the business and investment needs and climate of a country in which the parent (company outside India) company wants to diversify or through which the parent company will facilitates its business.",
          content: [
            {
              type: "h5",
              text: "Note: Liaison Office cannot conduct any commercial activities also must use remittance received only from its parent foreign company to carry its activities.",
            },
          ],
        },
        {
          description:
            "The Reserve Bank of India (RBI) prescribes the criteria for setting up a Liaison office or Representative Office in India. If you want any help regarding it then you can follow the following steps or can take help from a professional for Foreign Company Registration in India.",
        },
        {
          content: [
            {
              type: "h5",
              bullets: [
                "It is essential to have a profit-making record in the immediately preceding 3 financial years in the home country, and the net value should be more than USD 50,000.",
                "If the subsidiary does not fulfill the above condition, the parent company must submit an authorization that meets the above conditions.",
                "Specific approval of RBI under FEMA 1999 and Insurance Regulatory and Development Authority (IRDA) is required.",
                "A designated Authorized Dealer Category–I Bank needs to forward an application for establishing an office to the RBI.",
                "The RBI gives the office a unique identification number.",
              ],
            },
          ],
        },

        {
          title: "Project Office",
          content: [
            {
              type: "h5",
              text: "In the event that a foreign company wishes to establish an office and the foreign company has entered into an agreement with an Indian company to carry out a project in India, the prior approval of the RBI is not required if:",
              bullets: [
                "Funded directly from abroad by inward remittance, or",
                "Funded by a bilateral or multilateral international financial institution, or",
                "Authorized by the appropriate authority, or",
                "An Indian company or entity provided that a term loan has been granted for the project by an Indian bank or public financial institution.",
              ],
            },
          ],
        },
        {
          description:
            "Besides that, in case that the above conditions are not met, the foreign entity has to approach the RBI for the approval.",
        },

        {
          title: "Branch Office of The Foreign Company",
          content: [
            {
              type: "h5",
              text: "By opening a branch office, a foreign company can conduct business activity in India with the prior approval of RBI, provided:",
              bullets: [
                "The company should be engaged in manufacturing or trading activities,",
                "Profit in the immediately preceding five financial years is necessary,",
                "The net worth is not less than USD 100,000 in its home country.",
              ],
            },
            {
              type: "h5",
              text: 'Branch Office as stated in section 2(13) of Companies Act, 2013 "office in relation to a company, means any establishment described as such by the company". With help Branch Office foreign companies can conduct their business in India in a full-fledged manner. Branch Offices are allowed to carry the same or substantially the same activities as carried out by their main/parent or group organizations. They can carry out the following activities:-',
              bullets: [
                "Import or Export of goods",
                "Rendering of professional or consultancy services in the India",
                "Carrying or conducting out research work, in which the respective parent company is already engaged.",
                "Promoting technical or the financial collaborations between the Indian companies and parent or overseas group companies",
                "Representing the parent company or overseas group companies in India and acting as the buying/selling agents in India.",
                "Rendering of their services in the Information Technology and the development of software in India",
                "Rendering of their services for technical support to the products supplied by the parent or overseas group companies.",
                "Foreign airline or shipping company.",
                "Foreign Banks",
              ],
            },
            {
              type: "h4",
              text: "Note:",
              bullets: [
                "The Branch Office is not allowed to indulge in carrying out the activities of manufacturing as they are permitted to sub-contract such kind of services to any Indian manufacturer.",
                "The branch offices are allowed to repatriate the profit earned from their branch, net of the applicable tax rates & also subject to the guidelines of Reserve Bank of India.",
                "There is not ownership provided in case of Branch office as it is only the extension of the exiting company in the foreign country.",
              ],
            },
          ],
        },
        {
          title: "Document Required",
          description:
            "The following documents are required to be filed within 30 days of the establishment of its place of business in India for setting up of Liaison Office/Branch Office in India.",

          table: {
            title: "Required Documents",
            headers: ["S. No", "Particulars"],
            rows: [
              [
                "1.",
                "Business Sector of the Company in order to whether RBI Approval is required or not",
              ],
              [
                "2.",
                "Certified True Copy of the charter, statutes or memorandum and articles, of the company and, if the instrument is not in the English language, a certified translation thereof in the English language;",
              ],
              [
                "3.",
                "Complete address of the registered or principal office of the company;",
              ],
              [
                "4.",
                "List of the directors and secretary of the company containing such following particulars",
              ],
              [
                "5.",
                "Name and address of the Authorized Person(s) in India authorized to accept on behalf of the company service of process and any notices or other documents required to be served on the company;",
              ],
              [
                "6.",
                "Full address of the office of the company in India which is deemed to be its principal place of business in India",
              ],
              [
                "7.",
                "Particulars of opening and closing of a place of business in India on earlier occasion or occasions",
              ],
              [
                "8.",
                "The declaration that none of the directors of the company or the Authorized Representative in India has ever been convicted or debarred from the formation of companies and management in India or abroad;",
              ],
            ],
          },
        },
        {
          description:
            "Within a time-span of 30 days of the establishment of place of conduct in India, A foreign company must file an application with the registrar Form FC-1 along with an application fee as prescribed in the Companies (Registration Offices and Fees) Rules, 2014 and the documents needed for the registration by a foreign company under the provisions of section 380 (sub-section 1).<br/><br/>It should be noted that the application must be backed by an attested copy signifying the RBI's (Reserve Bank of India) approval under the Foreign Exchange Management Act or the laws.",
        },
      ],
      faq: [
        {
          question:
            "What are the RBI routes available for availing the investment in the country?",
          answer:
            "The application for investment is considered by the Reserve Bank of India under two routes which are as follows:-<br/><ul><li>Automatic route – foreign Company falls under those sectors where the government has allowed 100 percent of the Foreign Direct Investment.</li></ul><ul><li>Government route – In this route the principal business of the foreign Company falls under those sectors where the government has not allowed 100 percent FDI. Here the applications from the entities falling under this category & the non-government organizations are considered in discussion with the Ministry of Finance, Government of India by the RBI.</li></ul>",
        },
        {
          question:
            "Whether a Branch Office established in India can acquire property?",
          answer:
            "A branch office is allowed to purchase a property in India if that respective asset is used for performing the company's business activities and the other associated operations. A property with a purpose of purpose of renting cannot be purchased by the foreign company.",
        },
        {
          question:
            "What are all those activities that can be carried out by a Branch Office?",
          answer:
            "<ul> <li>Import or Export of goods;</li> </ul> <ul> <li>Rendering of professional or consultancy services in the India;</li> </ul> <ul> <li>Carrying or conducting out research work, in which the respective parent company is already engaged;</li> </ul> <ul> <li>Promoting technical or the financial collaborations between the Indian companies and parent or overseas group companies;</li> </ul> <ul> <li>Representing the parent company or overseas group companies in India and acting as the buying/selling agents in India;</li> </ul> <ul> <li>Rendering of their services in the Information Technology and the development of software in India;</li> </ul> <ul> <li>Rendering of their services for technical support to the products supplied by the parent or overseas group companies;</li> </ul> <ul> <li>Foreign airline or shipping company;</li> </ul> <ul> <li>Foreign Banks</li> </ul>",
        },
        {
          question: "Does a Branch Office is liable to pay tax in India?",
          answer:
            "Yes, a Branch Office shall be required to pay tax in India in accordance with the tax rates as prescribed under the Income Tax Act, 1961. The branch offices are allowed to repatriate the profit earned from their branch, net of the applicable tax rates & also subject to the guidelines of Reserve Bank of India.",
        },
        {
          question:
            "What are the criteria’s under which prior approval from RBI is not required for setting up of a project office?",
          answer:
            "<ul> <li>Funded directly from abroad by inward remittance, or</li> </ul> <ul> <li>Funded by a bilateral or multilateral international financial institution, or</li> </ul> <ul> <li>Authorized by the appropriate authority, or</li> </ul> <ul> <li>An Indian company or entity provided that a term loan has been granted for the project by an Indian bank or public financial institution</li> </ul>",
        },
        {
          question:
            "What is the time period for which registration for operating a liaison office is granted?",
          answer:
            "The initial approval by RBI for operating a liaison office is allowed for a period of three years which can be further extended for another 3 years subject to the compliances made and the permission granted by the Reserve Bank of India. Furthermore, the extension for the same can be applied at least one or two months before the expiry of the initial time period.",
        },
        {
          question:
            "Can a Foreign Insurance Company/ ies /Banks set up a Liaison Office in India?",
          answer:
            "The Foreign Insurance company/ies can establish a Liaison Offices in India only after the approval from the Insurance Regulatory and Development Authority (IRDA). Likewise, the foreign banks can also establish Liaison Offices in India only after obtaining the approval from Department of Banking Regulations (DBR), Reserve Bank of India.",
        },
        {
          question: "Can these Branch Offices remit the profit outside India?",
          answer:
            "The Branch Offices are allowed to remit outside India the profit of the branch net of applicable Indian taxes, on production of the following documents upto the satisfaction of the Authorised Dealer through whom such remittance is effected:<br/><ul><li>A Certified true copy of the audited Balance Sheet and Profit and Loss account for the relevant year;</li><li>A certificate from the Chartered Accountant’s certifying –</li>1. the manner of arriving at the remittable profit<br/>2. that the entire remittable profit has been earned by undertaking the permitted activities<br/>3. that the profit does not include any profit on revaluation of the assets of the branch</ul>",
        },
        {
          question: "Is it possible to declare dividends by the Nidhi Company?",
          answer:
            "Yes a Nidhi Company may declare dividends which shall not exceed 25% or higher as may be approved by Regional Director subject to the fulfillment of certain conditions.",
        },
        {
          question: "Whether Nidhi Companies can issue Preferential Shares?",
          answer:
            "No, a Nidhi Company cannot issue Preferential Shares as prescribed by the Companies Act, 2013.",
        },
        {
          question:
            "What are the requirements to be fulfilled post incorporation by a Nidhi Company?",
          answer:
            "Once the Nidhi Company is registered, it must fulfill the following mentioned requirements:</br><ul> <li>Have at least 200 members/shareholders.</li> </ul> <ul> <li>Minimum Net Owned Fund should be Rs. 10 Lakhs.</li> </ul> <ul> <li>Unencumbered term deposit must be at least 10% of the term deposit.</li> </ul> <ul> <li>The ratio of Net Owned Fund to term deposit should not be less than 1:20.</li> </ul>",
        },
      ],
    },
  },
  /*
  "showcase-content": {
    title: "Showcase All Features",
    hero: {
      title: "Comprehensive Content Showcase",
      description:
        "This page demonstrates every available content structure and styling option within our React and Tailwind CSS setup.",
      advantages: [
        "Illustrates diverse content types",
        "Shows off responsive design",
        "Validates data structure parsing",
        "Highlights dynamic rendering capabilities",
        "Ensures all components work as expected",
      ],
      eligibleCriteria: [
        "Must be a React environment",
        "Tailwind CSS must be configured",
        "servicesData.js must be imported correctly",
        "Browsers supporting modern CSS features",
        "A keen eye for design and detail",
      ],
    },
    content: {
      overviews: [
        {
          title: "Simple Description Overview",
          description:
            "This is a basic paragraph showing how a simple description field works. It supports <b>bold text</b>, <i>italic text</i>, and even <a href='#'>links</a>, by using HTML directly within the string. Line breaks in the data are converted to HTML line breaks. For example, here's another line of text.\n\nAnd one more line to really show the spacing.",
        },
        {
          title: "Structured Content with Various Headings and Bullet Points",
          content: [
            {
              type: "h2",
              text: "Main Section Heading (h2)",
              bullets: [
                "Bullet point 1 under h2",
                "Bullet point 2 under h2 with some <strong>important</strong> text",
                "Bullet point 3 under h2",
              ],
            },
            {
              type: "h3",
              text: "Subsection Heading (h3)",
              bullets: [
                "First item for h3",
                "Second item for h3 with a `code` snippet",
              ],
            },
            {
              type: "h4",
              text: "Smaller Heading (h4)",
              bullets: ["One item here", "Another item here for h4"],
            },
            {
              type: "h5",
              text: "Even Smaller Heading (h5)",
              bullets: ["Final bullet point for h5"],
            },
          ],
        },
        {
          title: "Process Flow Demonstration",
          description:
            "This section showcases a step-by-step process. Each step includes a title and a description. Notice the use of <b>bold HTML</b> within the description for emphasis. This is great for workflows.",
          content: [
            {
              type: "process",
              title: "Our Detailed Showcase Process",
              description:
                "This is a comprehensive process to illustrate data rendering. We can include <span class='text-blue-600 font-bold'>colorful spans</span> here as well.",
              steps: [
                {
                  step: 1,
                  title: "Initiate Showcase",
                  description:
                    "Start by selecting 'Showcase All Features' from the service selector. This loads all dynamic content types.",
                },
                {
                  step: 2,
                  title: "Review Hero Section",
                  description:
                    "Observe the dynamically populated title, description, advantages, and eligible criteria in the hero banner.",
                },
                {
                  step: 3,
                  title: "Explore Overviews",
                  description:
                    "Scroll through the 'Overviews' to see simple descriptions, structured headings with bullets, and the process flow itself.",
                },
                {
                  step: 4,
                  title: "Check Features",
                  description:
                    "Verify that the 'Key Features' section displays all list items with their respective icons and styling.",
                },
                {
                  step: 5,
                  title: "Examine Tables",
                  description:
                    "Inspect the 'Important Tables' section for correct rendering of headers and rows, including any HTML within cells (if present).",
                },
                {
                  step: 6,
                  title: "Test FAQs",
                  description:
                    "Click on each FAQ item to ensure the accordion functionality works, and that HTML content within answers is displayed correctly.",
                },
                {
                  step: 7,
                  title: "Enjoy the Display",
                  description:
                    "Congratulations! You've successfully witnessed all the dynamic content capabilities.",
                },
              ],
            },
          ],
        },
        {
          title: "Overview with Embedded Table",
          description:
            "Sometimes you need a table directly within an overview section to present tabular data relevant to that specific overview's context. This demonstrates how a table can be seamlessly integrated.",
          table: {
            title: "Example Overview Table",
            headers: ["Feature", "Support Level", "Notes"],
            rows: [
              ["Dynamic Text", "Full", "From descriptions and bullets"],
              ["HTML in Strings", "Limited", "Via `dangerouslySetInnerHTML`"],
              ["Lists & Bullets", "Full", "<ul><li>Nested HTML</li></ul>"],
              [
                "Process Steps",
                "Full",
                "Structured array for sequential display",
              ],
              ["Data Tables", "Full", "Separate section or embedded"],
              ["Accordion FAQs", "Full", "Interactive expandable sections"],
            ],
          },
        },
      ],
      features: [
        "Dynamic content loading",
        "HTML rendering in descriptions",
        "Structured headings (h2, h3, h4, h5)",
        "Bulleted lists with custom styling",
        "Numbered process steps with descriptions",
        "Responsive data tables",
        "Interactive FAQ accordions",
        "Centralized data management (servicesData.js)",
        "Clean, maintainable React components",
        "Efficient Tailwind CSS styling",
      ],
      tables: [
        {
          title: "Content Types Supported",
          headers: ["Content Type", "Description", "Example Use"],
          rows: [
            ["Hero Section", "Prominent service introduction", "Top banner"],
            ["Overviews", "Detailed explanations", "Main content blocks"],
            ["Features List", "Key selling points", "Checkmark list"],
            ["Data Tables", "Tabular information", "Documents, rates"],
            ["FAQ Accordion", "Common questions & answers", "Expandable Q&A"],
            [
              "Structured Content",
              "Headings, bullets, processes",
              "Flexible text blocks",
            ],
          ],
        },
        {
          title: "Tailwind CSS Feature Showcase",
          headers: ["Category", "Tailwind Feature", "Benefit"],
          rows: [
            ["Layout", "Flexbox & Grid", "Flexible, responsive arrangements"],
            [
              "Spacing",
              "Padding & Margin utilities",
              "Consistent element spacing",
            ],
            [
              "Typography",
              "Font sizes, weights, colors",
              "Readable and branded text",
            ],
            [
              "Backgrounds",
              "Gradients & solid colors",
              "Visual depth and branding",
            ],
            [
              "Borders/Shadows",
              "Rounded corners, box shadows",
              "Modern UI elements",
            ],
            [
              "Interactivity",
              "Hover, Focus, Transform",
              "Engaging user experience",
            ],
            [
              "Responsiveness",
              "Breakpoints (sm, md, lg)",
              "Adapts to any screen size",
            ],
          ],
        },
      ],
      faq: [
        {
          question: "How does the `TestPage` component work?",
          answer:
            "The `TestPage` component imports data from `servicesData.js` and uses **React hooks** like `useState` to manage which service is currently displayed. It then renders the data dynamically using **JSX** and applies styling with **Tailwind CSS classes**.",
        },
        {
          question: "Can I add more services to `servicesData.js`?",
          answer:
            "Absolutely! Just follow the existing structure for `gst-registration` or `foreign-company-registration` to add new service objects. The `TestPage` is designed to be **data-driven**.",
        },
        {
          question: "What if my content contains HTML?",
          answer:
            "For content like descriptions or FAQ answers that might contain HTML tags (like `<b>`, `<i>`, `<ul>`, `<li>`, `<br/>`), the component uses `dangerouslySetInnerHTML`. Remember, this should only be used with **trusted content** to prevent XSS vulnerabilities. Our `servicesData.js` is considered trusted in this context.",
        },
        {
          question: "How do I add a new content 'type' to overviews?",
          answer:
            "If you need a completely new content structure within `overviews`, you'd first define that structure in `servicesData.js` (e.g., `type: 'image-gallery'`). Then, you'd update the `renderContent` helper function in `TestPage.jsx` with a new conditional block to render that specific type.",
        },
        {
          question: "Why use Tailwind CSS for styling?",
          answer:
            "Tailwind CSS is a **utility-first CSS framework**. It provides low-level utility classes that let you build custom designs directly in your JSX markup. This speeds up development, promotes consistency, and makes styling highly configurable. It's also **highly performant** as it only generates the CSS you actually use.",
        },
      ],
    },
  },*/
  "private-limited-company": {
    title: "Private Limited Company Registration",
    hero: {
      title: "Private Limited Company Registration",
      description:
        "A Private Limited Company is the most relevant and caught on type of business structure in India, suitable for small and medium scale businesses.",
      advantages: [
        "Limited Liability Protection to Director's personal assets",
        "Better image & credibility",
        "Easy to raise funds and loans",
        "Best Mode for Startups",
        "Favorite Business structure for Investors",
      ],
      eligibleCriteria: [
        "Minimum Two Directors",
        "Minimum Two Members",
        "No Minimum Capital Required",
        "Maximum Fifteen Directors",
        "One Director shall be Indian resident",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction",
          description:
            "A Private Limited Company is the most relevant and caught on type of business structure in India, suitable for small and medium scale businesses. However, the total number of members in Private Limited companies cannot exceed the maximum limit of 200.<br><br>Once the registration of such companies is done, a separate legal existence is attained by a business organization which means a registration gives a business – an individual legal identity independent of the company’s directors and shareholders. This implies the continuation of the company’s existence even after the death of any member of the company. This makes the registration of a Private Limited company as an important job. For Private Limited company registration, one must go to professionals or visit MCA online portal.<br><br>Companies Act, 2013 lays down the law for Private Limited companies and the Ministry of Corporate Affairs is the regulatory body for the registration of these companies.",
        },
        {
          title: "Reasons to Register a Private Limited Company",
          content: [
            {
              type: "h2",
              text: "Reasons to Register a Private Limited Company",
              bullets: [
                "Easy Transferability",
                "Limited Liability",
                "Perpetual succession",
                "Improves credibility",
              ],
            },
          ],
        },
        {
          title: "Requirements for Incorporation of a Private Limited Company",
          description:
            "Companies Act, 2013 has listed the following requirements for the incorporation of a Pvt. Ltd. company",
          content: [
            {
              type: "h2",
              text: "Requirements",
              bullets: [
                "Passport size photo",
                "DIN (Director identification no.)if any",
                "DSC (Digital signature certificate) of all directors",
                "Minimum 2 Directors<br>Note– One Director must be Indian Resident",
                "PAN Card<br>Self-attested PAN Card of Members and Directors.",
                "Identity Proof of Directors<br>Self-attested ID proof of Members and Directors- (Anyone out of the following -Valid Passport/Voter ID/Aadhar Card/Valid Driving License)",
                "Address Proof<br>Self attested Address proof of the Members and Directors (Any one out of the following - Bank Statement/ Electricity Bill/ Telephone Bill/ Mobile Bill which and it should be not older than 2 months",
                "Business Address Proof (Rented/Leased)<br>If proposed Registered Office is taken on Lease – NOC from Landlord/Lease Agreement/Utility Bill (Either Electricity Bill or Mobile Bill or Telephone Bill) (Should Not be Older than 2 Months)",
                "Business Address Proof(Owned)<br>If the proposed Registered Office is not taken on Lease – NOC from the Owner of Property/Property Papers (Title Deed)/Utility Bill (Either Electricity Bill or Mobile Bill or Telephone Bill) (Should Not be Older than 2 Months)",
              ],
            },
          ],
        },
        {
          title: "Basic Information Required",
          content: [
            {
              type: "h2",
              text: "Basic Information Required",
              bullets: [
                "Authorized and Paid-up Share Capital of the Proposed Company and Number of Shares Subscribed by Members.<br>Explanation: A Company can be commenced with any amount of capital. There is no need for a minimum capital amount.",
                "Place of Birth and Duration of Stay of Members and Directors at Present Residential Address.",
                "Occupation of Members and Directors.",
                "Proposed Object/Business of the Proposed Company.",
                "Educational Qualification of Members and Directors.",
                "Email IDs and Contact Number of Members and Directors.",
              ],
            },
          ],
        },
        {
          title: "Process of Private Limited Company Registration",
          description:
            "The Ministry of Corporate Affairs vide its notification dated 18th February 2020 effective from 23rd February 2020 has further amended the Companies (Incorporation) Rules, 2014 thereby substituting the old Form INC-32 (SPICe) with web service SPICe+ along with certain other amendments.",
          content: [
            {
              type: "process",
              title: "Step by Step Process",
              description: "", // No specific description for the process itself in the HTML
              steps: [
                {
                  step: 1,
                  title: "An application for Name Reservation.",
                  description:
                    "The first step is to make an application for reservation of name which shall be reserved by using the web services (SPICe+) available at www.mca.gov.in along with the specified fees. Before Applying for the name, kindly check that the name is available on MCA as well as no trademark. Is there no such name under the Class of work you are going to apply.<br>The new integrated form consists of two parts i.e. PART A and Part B. The Name(s) of a company can be reserved in Part A of SPICe+. In case the applicant wants to apply for name, incorporation, and other integrated services together, he can do so together by filling necessary information in Part A and Part B.",
                },
                {
                  step: 2,
                  title: "Fill Part B of SPICe+",
                  description:
                    "The second step is to fill the Part B of SPICe+ for registering the Company. The said form contains various sections that allow you to save and modify information if required.The new integrated form consists of two parts i.e. PART A and Part B. The Name(s) of a company can be reserved in Part A of SPICe+. In case the applicant wants to apply for name, incorporation, and other integrated services together, he can do so together by filling necessary information in Part A and Part B.",
                },
                {
                  step: 3,
                  title: "Convert SPICe+ Form into PDF",
                  description:
                    "The third step is to convert the SPICe+ form into a pdf form in order to affix the DSC.",
                },
                {
                  step: 4,
                  title: "Upload the form on MCA",
                  description:
                    "After affixing the DSC the form is required to upload on the Ministry of Corporate Affairs in accordance with the existing process.",
                },
                {
                  step: 5,
                  title: "Declare the company’s Subscribers & First Directors",
                  description:
                    "Declaration of all Subscribers and first Directors of the company which is currently being filed in Form INC-9 will be automatically generated in pdf format and shall be submitted only through Electronic form in all cases, except in case:<br><br>a) The no. of subscribers and/or directors is more than 20.<br><br>b) Any of the subscribers and/or directors do not have DIN and PAN",
                },
              ],
            },
          ],
        },
        {
          title: "Changes As Per The Amendments Introduced Recently",
          content: [
            {
              type: "h2",

              bullets: [
                "<b>No need to mention SRN</b><br>There is no need to mention SRN for names reserved in Part A of SPICE+ as the same will be automatically displayed while filing Part B after filing of Part A.",
                "<b>Mandatory Registration for ESIC and EPFO</b><br>Registration for ESIC and EPFO has been made mandatory for all new companies that are incorporated w.e.f 23rd February 2020.",
                "<b>Mandatory Registration for Profession Tax</b><br>Registration for Profession Tax is made mandatory for all new companies incorporated in Maharashtra state, w.e.f. 23rd February 2020.",
                "<b>Mandatory Application for opening a bank account</b><br>Application for opening of a bank account is made mandatory for all new companies incorporated w.e.f 23rd February 2020 the same application shall be filed through the AGILE-PRO linked web form.",
                "<b>Declaration of Company’s Subscribers and First Directors in PDF form & e-submission</b><br>Declaration of all Subscribers and First Directors of the Company which is currently being filed in Form INC-9 will be automatically generated in pdf format and shall be submitted only through Electronic form in all cases, except in case:<ul><li>No. of subscribers and/or directors is more than 20.</li><li>Any of the subscribers and/or directors don’t have DIN and PAN.</li></ul>",
                "<b>Mandatory Use of e-MoA (INC-33) & e-AoA (INC-34)</b><br>It is mandatory to use e-MoA (INC-33) and e-AoA (INC-34) in case the number of subscribers is up to 7 and in the following scenarios:<ul><li>Individual subscribers are Indian nationals</li><li>individual subscribers who are foreign nationals only in case they valid DIN and DSC and also submit proof of a valid business visa</li><li>Non-individual subscribers based in India.</li></ul>Physical copies of MoA/AoA must be signed and attached if in case non-individual first subscribers are based outside India or individual foreign subscribers do not possess a valid business visa or any other scenario which are as follow:",
              ],
            },
          ],
          table: {
            title: "Mandatory Use of e-MoA (INC-33) & e-AoA (INC-34) Cases",
            headers: ["S. No.", "Cases", "Forms to be filed"],
            rows: [
              [
                "1.",
                "Non-Individual first subscriber based outside India",
                "SPICe+ (INC-32) with apostille MOA and AOA as attachments",
              ],
              [
                "2.",
                "Non-Individual first subscriber based in India",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "3.",
                "Indian National being Subscriber other than Director",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "4.",
                "Indian National being Subscriber-cum-Director",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "5.",
                "Foreign National being Subscriber other than director having valid DIN",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34) along with Valid Business Visa to be submitted.<br><br>In case Business Visa is not available, apostille MOA and AOA shall be attached and in such cases, e-MOA (INC33) and eAOA (INC-34) are NOT acceptable.",
              ],
              [
                "6.",
                "Foreign National being Subscriber-cum-Director having valid DIN",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34) along with valid Business Visa to be submitted.<br><br>In case Business Visa is not available, apostille MOA and AOA shall be attached and in such cases, e-MOA (INC33) and e-AOA (INC-34) are NOT acceptable.",
              ],
              [
                "7.",
                "Foreign National being Subscriber-cum-Director not having valid DIN",
                "SPICe+ (INC-32) with apostille MOA and apostille AOA as attachments.",
              ],
            ],
          },
          description_after_table:
            "In all the above-mentioned cases, the maximum number of subscribers allowed shall be 7 for filing of SPICe+ form. Wherever the number of subscribers exceeds 7, SPICe+ form shall be filed with MoA and AoA as attachments.",
          final_bullet:
            "<b>Filing of Statutory Return</b><br>Companies newly incorporated through SPICE+ and who have obtained EPFO/ESI number will have to file Statutory Return only if the prescribed threshold limit has been exceeded.",
        },
      ],
      features: [], // No distinct features section found beyond hero advantages
      tables: [], // The table from "Changes As Per The Amendments" is embedded in an overview
      faq: [
        {
          question:
            "Does for the small business, the Private Limited Company registration will be benefited?",
          answer:
            "Yes, for small business it is preferable to register under private limited company registration in India. It provides them the credibility and a image of their business in the eye of financial institution, suppliers & potential clients. It helps the company in obtaining the loans at little compliance from the banks or potential clients while entering into any deal.",
        },
        {
          question: "For how long a name a approved name is valid?",
          answer:
            "An approved name shall be valid for a period of 20 days from the date of approval of such name",
        },
        {
          question:
            "How many Directors and Members are required to form a Private Limited Company?",
          answer:
            "A private limited company must have minimum 2 directors and can have a maximum of 15 directors and a minimum of 2 shareholders are required maximum number of shareholders is 200.",
        },
        {
          question: "Whether a Director or a Shareholder be the same?",
          answer:
            "Yes, a person can become a Director as well as a shareholder and vice versa as a Company is a Separate Legal Entity.",
        },
        {
          question:
            "What are the minimum capital requirement for forming a Private Limited Company ?",
          answer:
            "As per Companies Act, 2013 there is no minimum capital required for incorporating a Private Limited Company but generally people prefer and advised to incorporate the same with a minimum capital of INR. 1 Lacs.",
        },
        {
          question:
            "Can a NRI or a Foreign National be a Director or Shareholder of a Company?",
          answer:
            "Yes, a NRI or a Foreign National can become a shareholder and Director (post obtaining the Director Identification Number). However one Director of the Company should be Indian Resident.",
        },
        {
          question:
            "In how much time the subscription money is to be deposited?",
          answer:
            "A Member who has agreed to subscribe the shares shall be required to deposit the money in the bank account at the earliest and shall file a form for commencement within 180 days from the date of incorporation of the Company.",
        },
        {
          question:
            "Can the amount deposited above be withdrawn from the Bank Account?",
          answer:
            "No, the money deposited cannot be withdrawn but the same can be used by the Company for its official purpose like for paying salary to staff members and employees, other administrative expenses etc.",
        },
        {
          question:
            "Can a Private Limited Company carry multiple business under one style of name?",
          answer:
            "Yes, a Private Limited Company can carry on multiple related business activities if the same is mentioned in the company’s objects which must be approved by the registrar. one cannot operate entirely different business activities like construction and the food company under one name but related activities can be performed.",
        },
      ],
    },
  },
  "public-limited-company-registration": {
    title: "Public Limited Company Registration",
    hero: {
      title: "Public Limited Company Registration",
      description:
        "Govind Sinha & Co. is Leading Online Public Limited Company Registration. Meaning, Characteristics, Benefits, Requirements, Process of Registration.",
      advantages: [
        "Limited Liability Protection",
        "Better image & credibility",
        "Easy to raise funds and loans",
        "Listing on Stock Exchanges",
        "Favorite Business structure for Investors",
      ],
      eligibleCriteria: [
        "Minimum Three Directors",
        "Minimum Seven Members",
        "No Minimum Capital Required",
        "Maximum Fifteen Directors",
        "One Director shall be Indian resident",
      ],
    },
    content: {
      overviews: [
        {
          title: "Meaning of Public Limited Company",
          description:
            "According to the Company Act 2013, a Public Limited Company refers to the company which can offer shares to the public and has defined liability.<br><br>A public limited company can offer its shares to the public either via (IPO) initial public offering or trading platform like the stock market. Everyone is allowed to acquire the shares offered by PLC.<br><br>A Public Limited Company rigidly adheres to the regulations and reveals its accurate financial status to its shareholders.<br><br><h3>Suitability & Popularity</h3>A public company is suitable for medium and large-sized businesses that want to raise equity capital from the public. Due to its various advantages, the public limited company is one of the most popular legal entities among medium and large-size companies in India.",
        },
        {
          title: "Characteristics of Public Limited Company",
          description:
            "To understand the concept of PLC better, let us check its characteristics which are as follows:<br><br>Let us have a look at the benefits of establishing a public limited company.",
          content: [
            {
              type: "h2",
              text: "Characteristics", // Added a heading for clarity
              bullets: [
                "<b>Directors: </b>Under Companies Act, 2013 provisions, a public limited company must have at least 3 directors.",
                "<b>Paid-up capital: </b>no minimum capital is required to form a Public Limited Company",
                "<b>Prospectus</b><br>Under the Companies Act, 2013, a public limited company must issue a prospectus that showcases the company’s business affairs, to the public.",
                "<b>Name</b><br>As per Companies Act, 2013, it is mandatory for all the public companies to end their name with the word “Limited”.",
                "<b>Limited Liability</b><br>Public Limited Company limits the liability of each shareholder by making the owners jointly & severally liable for the business’s debts.",
              ],
            },
          ],
        },
        {
          title: "Benefits of Public Limited Company Registration",
          content: [
            {
              type: "h2",
              text: "Benefits", // Added a heading for clarity
              bullets: [
                "<b>Additional Capital</b><br>Shares offered to the common public in large, allowing everyone to invest in the company, bring additional capital for the company.",
                "<b>Increased Popularity</b><br>Listing on a stock market platform increases the popularity of the PLC’s business among the traders dealing in mutual funds, hedge funds, etc which further opens up avenues for business opportunities for the Company.",
                "<b>Divided Risk</b><br>The risk of the market gets divided with the allotment of shares among the general public in large.",
                "<b>Success and Business Expansion</b><br>Divided risk, increased publicity and additional capital together lead to the opportunities for business expansion & success and investment in new profitable projects.",
              ],
            },
          ],
        },
        {
          title: "Requirements for the Incorporation Public Limited Company",
          description:
            "Companies Act, 2013 has listed the following requirements for the incorporation of a Public Limited company",
          content: [
            {
              type: "h2",
              text: "Requirements", // Added a heading for clarity
              bullets: [
                "<b>Minimum 3 Director and 7 Members: </b><br>Minimum 3 Directors and 7 Members are required to incorporate Public Limited Company.",
                "<b>PAN Card: </b><br>Self-attested PAN Card of Members and Directors.",
                "<b>Identity Proof of Directors: </b><br>Self-attested ID proof of Members and Directors- (Anyone out of the following -Valid Passport/Voter ID/Aadhar Card/Valid Driving License)",
                "<b>Address Proof: </b><br>Self attested Address proof of the Members and Directors (Any one out of the following - Bank Statement/ Electricity Bill/ Telephone Bill/ Mobile Bill which and it should be not older than 2 months",
                "<b>Passport Size Photo</b><br>2-2 Passport Size Colored Photos of Members and Directors.",
                "<b>Business Address Proof (Owned/Rent/Leased): </b><br>NOC from the Owner of Property/Property Papers (Title Deed)/Utility Bill (Either Electricity Bill or Mobile Bill or Telephone Bill) (Should Not be Older than 2 Months)",
              ],
            },
          ],
        },
        {
          title: "Information Required",
          content: [
            {
              type: "h2",
              text: "Information Required", // Added a heading for clarity
              bullets: [
                "Authorized and Paid-up Share Capital of the Proposed Company and Number of Shares Subscribed by Members",
                "Place of Birth and Duration of Stay of Members and Directors at Present Residential Address.",
                "Occupation of Members and Directors.",
                "Proposed Object/Business of the Proposed Company.",
                "Educational Qualification of Members and Directors.",
                "Email IDs and Contact Number of Members and Directors.",
              ],
            },
          ],
        },
        {
          title: "Process of Public Limited Company Registration",
          description:
            "The Ministry of Corporate Affairs vide its notification dated 18th February 2020 effective from 23rd February 2020 has further amended the Companies (Incorporation) Rules, 2014 thereby substituting the old Form INC-32 (SPICe) with web service SPICe+ along with certain other amendments.",
          content: [
            {
              type: "process",
              title: null, // No specific title for the process itself in the HTML
              description: null, // No specific description for the process itself in the HTML
              steps: [
                {
                  step: 1,
                  title: "An application for Name Reservation",
                  description:
                    "The first step is to make an application for reservation of name which shall be reserved by using the web services (SPICe+) available at www.mca.gov.in along with the specified fees. Before Applying for the name, kindly check that the name is available on MCA as well as no trademark. Is there no such name under the Class of work you are going to apply.<br>The same can be checked by clicking on the link below: <a href='https://cagovindsinha.com/services/trademark-registration/'>Trademark Registration</a> <br>The new integrated form consists of two parts i.e. PART A and Part B. The Name(s) of a company can be reserved in Part A of SPICe+. In case the applicant wants to apply for name, incorporation, and other integrated services together, he can do so together by filling necessary information in Part A and Part B.",
                },
                {
                  step: 2,
                  title: "Fill Part B of SPICe+",
                  description:
                    "The second step is to fill the Part B of SPICe+ for registering the Company. The said form contains various sections that allow you to save and modify information if required.",
                },
                {
                  step: 3,
                  title: "Convert SPICe+ Form into PDF",
                  description:
                    "The third step is to convert the SPICe+ form into a pdf format to affix the DSC.",
                },
                {
                  step: 4,
                  title: "Upload the form on MCA",
                  description:
                    "After affixing the DSC the form is required to upload on the Ministry of Corporate Affairs following the existing process.",
                },
                {
                  step: 5,
                  title:
                    "Declaration of the Company’s Directors and Subscribers",
                  description:
                    "Declaration of all Subscribers and first Directors of the company which is currently being filed in Form INC-9 will be automatically generated in pdf format and shall be submitted only through Electronic form in all cases, except in case:<br>•\tThe no. of subscribers and/or directors is more than 20.<br>•\tAny of the subscribers and/or directors do not have DIN and PAN",
                },
              ],
            },
          ],
        },
        {
          title: "Recent Amendments and the Changes",
          content: [
            {
              type: "h2",
              text: "Changes As Per The Amendments Introduced Recently", // Added a heading for clarity
              bullets: [
                "<b>No need to mention SRN</b><br>There is no need to mention SRN for names reserved in Part A of SPICE+ as the same will be automatically displayed while filing Part B after filing of Part A.",
                "<b>Mandatory Registration for ESIC and EPFO</b><br>Registration for ESIC and EPFO has been made mandatory for all new companies that are incorporated w.e.f 23rd February 2020.",
                "<b>Professional Registration for Maharashtra</b><br>Professional registration is mandatory for all new companies established in the State of Maharashtra, w.e.f. February 23, 2020.",
                "<b>Mandatory Application for opening a bank account</b><br>Application for opening of a bank account has become mandatory for all new companies incorporated w.e.f 23rd February 2020 the same application shall be filed through the AGILE-PRO linked web form.",
                "<b>Declaration of Company’s Subscribers and First Directors in PDF form & e-submission</b><br>Declaration of all Subscribers and First Directors of the Company which is currently being filed in Form INC-9 will be automatically generated in pdf format and shall be submitted only through Electronic form in all cases, except in case:<ul><li>The no. of subscribers and/or directors is more than 20.</li><li>Any of the subscribers and/or directors don’t have DIN and PAN.</li></ul>",
                "<b>Mandatory use of e-MoA (INC-33) and e-AoA (INC-34) (in some cases)</b>It is mandatory to use e-MoA (INC-33) and e-AoA (INC-34) in case the number of subscribers is up to 7 and in the following scenarios:<ul><li>Individual subscribers are Indian nationals</li><li>Individual subscribers who are foreign nationals in case they valid DIN and DSC and also submit proof of a valid business visa</li><li>Non-individual subscribers based in India.</li></ul>",
                "<b>Signed Physical Copies of the MoA / AoA (in some cases)</b>Physical copies of the MoA / AoA must be signed and attached if the individuals' first subscribers are located outside India or if the individual outsourcers do not have a valid business practice or any of the following scenarios: -",
              ],
            },
          ],
          table: {
            title: null, // The HTML table doesn't have a specific title in the context
            headers: ["S. No.", "Cases", "Forms to be filed"],
            rows: [
              [
                "1.",
                "Non-Individual first subscriber based outside India",
                "SPICe+ (INC-32) with apostille MOA and AOA as attachments",
              ],
              [
                "2.",
                "Non-Individual first subscriber based in India",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "3.",
                "Indian National being Subscriber other than Director",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "4.",
                "Indian National being Subscriber-cum-Director",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "5.",
                "Foreign National being Subscriber other than director having valid DIN",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34) along with Valid Business Visa to be submitted.<br><br>In case Business Visa is not available, apostille MOA and AOA shall be attached and in such cases, e-MOA (INC33) and eAOA (INC-34) are NOT acceptable.",
              ],
              [
                "6.",
                "Foreign National being Subscriber-cum-Director having valid DIN",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34) along with valid Business Visa to be submitted.<br><br>In case Business Visa is not available, apostille MOA and AOA shall be attached and in such cases, e-MOA (INC33) and e-AOA (INC-34) are NOT acceptable.",
              ],
              [
                "7.",
                "Foreign National being Subscriber-cum-Director not having valid DIN",
                "SPICe+ (INC-32) with apostille MOA and apostille AOA as attachments.",
              ],
            ],
          },
          description_after_table:
            "Note: In all the above-mentioned cases, the maximum number of subscribers allowed shall be 7 for filing of SPICe+ form. Wherever the number of subscribers exceeds 7, SPICe+ form shall be filed with MoA and AoA as attachments.",
          final_bullet:
            "<b>Mandatory Filing of Statutory Return: </b><br>Companies newly incorporated through SPICE+ and who have obtained EPFO/ESI number will have to file Statutory Return only if the prescribed threshold limit has been exceeded.<br><br>A Public limited company gets all the benefits that a Private Limited Company enjoys. Besides, a PLC can have an unrestricted number of members and it can easily transfer the shareholding. Public Limited Registration can be easily and legally accomplished by Public Limited Company Registration Consultants.",
        },
      ],
      features: [], // No distinct features section found beyond hero advantages
      tables: [], // The table from "Recent Amendments" is embedded in an overview
      faq: [
        {
          question:
            "For which type of business, the Public Limited Company registration will be benefited?",
          answer:
            "The Public Limited Company is best suited for the large business operating entities as helps them in availing the loans easily and making them able to reach people at large also It provides them the credibility and a image of their business in the eye of financial institution, suppliers & potential clients.",
        },
        {
          question: "For how long a name a approved name is valid?",
          answer:
            "An approved name shall be valid for a period of 20 days from the date of approval of such name.",
        },
        {
          question:
            "How many Directors and Members are required to form a Private Limited Company?",
          answer:
            "A private limited company must have minimum 3 directors and can have a maximum of 15 directors and a minimum of 7 shareholders are required maximum number of shareholders is no limit.",
        },
        {
          question: "Whether a Director or a Shareholder be the same?",
          answer:
            "Yes, a person can become a Director as well as a shareholder and vice versa as a Company is a Separate Legal Entity.",
        },
        {
          question:
            "What are the minimum capital requirement for forming a Private Limited Company ?",
          answer:
            "As per Companies Act, 2013 there is no minimum capital required for incorporating a Public Limited Company but generally people prefer and advised to incorporate the same with a minimum capital of INR. 5 Lacs.",
        },
        {
          question:
            "Can a NRI or a Foreign National be a Director or Shareholder of a Company?",
          answer:
            "Yes, a NRI or a Foreign National can become a shareholder and Director (post obtaining the Director Identification Number). However one Director of the Company should be Indian Resident.",
        },
        {
          question:
            "In how much time the subscription money is to be deposited?",
          answer:
            "A Member who has agreed to subscribe the shares shall be required to deposit the money in the bank account at the earliest and shall file a form for commencement within 180 days from the date of incorporation of the Company.",
        },
        {
          question:
            "Can the amount deposited above be withdrawn from the Bank Account?",
          answer:
            "No, the money deposited cannot be withdrawn but the same can be used by the Company for its official purpose like for paying salary to staff members and employees, other administrative expenses etc.",
        },
        {
          question:
            "Can a Public Limited Company carry multiple business under one style of name?",
          answer:
            "Yes, a Public Limited Company can carry on multiple related business activities if the same is mentioned in the company’s objects which must be approved by the registrar. one cannot operate entirely different business activities like construction and the food company under one name but related activities can be performed.",
        },
        {
          question:
            "Whether a PAN Card is mandatory for the Indian residential for becoming a member or a Director in the Company?",
          answer:
            "Yes, the Indian nationals are required to have a PAN Card for becoming a Director/Member in a Company and Passport is mandated in case of Foreign Nationals.",
        },
        {
          question:
            "Can a residential address of a person be used as the Registered Office address?",
          answer:
            "Yes, a person can use its residential address as the Registered Office address of the Company as the Companies Act, 2013 doesn’t prohibits the same.",
        },
        {
          question:
            "Can a Public Limited Company issue shares to public at large?",
          answer:
            "Yes, a Public Limited Company can easily issue shares and deal with public at large.",
        },
        {
          question: "How can a Public Limited Company transfer its shares?",
          answer:
            "One can only transfer the shares by complying with the rules & regulations of Companies Act, 2013 and it is necessary for the public Limited company to get the shares in dematerialized form with NSDL/CDSL before transferring the shares or before inducing the capital in the company.",
        },
        {
          question: "What is a Digital Signature Certificate?",
          answer:
            "DSC refers to a Digital Signature Certificate. It is to be obtained from a certifying agency which shall be recognized by the government. Since the registration process is now done online, all the forms with respect to requiring a valid DSC shall be filled online. The cost of obtaining DSC varies from each of the certifying agency.",
        },
        {
          question:
            "What is Memorandum of Association and Articles of Association ?",
          answer:
            "DSC refers to a Digital Signature Certificate. It is to be obtained from a certifying agency which shall be recognized by the government. Since the registration process is now done online, all the forms with respect to requiring a valid DSC shall be filled online. The cost of obtaining DSC varies from each of the certifying agency.",
        },
      ],
    },
  },
  "llp-registration": {
    title: "LLP Registration",
    hero: {
      title: "LLP Registration",
      description:
        "Apply for Online LLP Registration (Limited Liability Partnership) with Govind Sinha & Co. Meaning, Features, Documents Required, Registration Process.",
      advantages: [
        "Limited Liability Protection",
        "No requirement of Audit",
        "Lower Registration Cost",
        "Separate Legal Entity",
        "Less Procedural Compliances",
      ],
      eligibleCriteria: [
        "Minimum Two Partners",
        "DIN of the Partners",
        "No Minimum Capital required",
        "DSC of one of the Partner",
        "One Partner shall be Indian resident",
      ],
    },
    content: {
      overviews: [
        {
          title: "Meaning of LLP",
          description:
            "A limited liability partnership (LLP) is a type of partnership that allows a few or all partners (contingent upon the jurisdiction) to have certain defined liabilities. This signifies the liability of each partner towards the misconduct or negligence of another partner.<br><br>LLP is one of the easiest types of businesses to incorporate & manage and it integrates the advantages of a Partnership Firm and a Company.",
        },
        {
          title: "Key Takeaways",
          content: [
            {
              type: "h2",
              text: "Key Takeaways",
              bullets: [
                "Limited liability partnerships (LLPs) form a partnership design in which each partner has a limited liability proportional to the investment they have made in the business.",
                "LLP disperse the risk among the partners, leverage the individual abilities & competencies and form division of labor pattern",
                "LLP is a common trend among professional businesses such as legal firms, wealth managers and Accounting consultancies.",
              ],
            },
          ],
        },
        {
          title: "Origin of concept",
          description:
            "The concept of a limited liability partnership was introduced in India by the Limited Liability Partnership Act 2008.<br><br>The main reason behind the introduction of Limited Liability Partnership is to furnish such a form of business entity that is less complex in nature, easy to maintain, and pertains limited liability to its owners. Besides, an LLP offers non-rigidity of partnership and restricted liability of a company.",
        },
        {
          title: "Suitability and Popularity",
          description:
            "LLPs are most-popular among the Professionals and Closely held businesses that are family-owned. It is not suitable for those kinds of businesses who have plans to raise equity funds from Venture Capitalist, Angel Investors or Private Equity Funds.",
        },
        {
          title: "Features of LLP Company",
          content: [
            {
              type: "h2",
              text: "Features",
              bullets: [
                "It has a separate legal entity like companies",
                "The liability of each partner is limited to the contribution made by them.",
                "The cost of forming and running LLP is low compared to companies.",
                "Less compliance and regulations",
                "No requirement of minimum capital contribution",
                "Compulsory Audit is required only when the Contribution exceeds 25 lakhs or the Annual Turnover exceeds 40 Lakhs.",
              ],
            },
          ],
        },
        {
          title: "Basic Requirements to Incorporate an LLP",
          content: [
            {
              type: "h2",
              text: "Requirements",
              bullets: [
                "Minimum 2 Designated Partners",
                "Digital Signature of one Designated Partners",
                "DPIN of all the Partners",
                "The Contribution (tangible or intangible property or other benefits to the Limited Liability Partnership)",
                "At least one designated partner is Indian Resident",
              ],
            },
          ],
        },
        {
          title: "Documents Required for LLP Registration",
          description:
            "The LLP Act, 2008 has listed following requirements for incorporation of LLP",
          content: [
            {
              type: "h2",
              text: "For Partners",
              bullets: [
                "PAN Card or Passport (for Foreigners)",
                "Driving license or Aadhar card, residence card or election identity card, or other government-issued identity documents.",
                "Telephone Bill or Bank Statement not older than 3 months",
              ],
            },
            {
              type: "h2",
              text: "Registered Office Proof",
              bullets: [
                "The landlord provide proof of objection to the name on the gas or electricity bill or the property tax receipt or water bill or sales note in order to use the premises as its registered office.",
                "Documentary evidence of any utilities, such as gas, electricity, telephone, etc., clearly indicating the address or document of the premises in the name of the owner (not older than two months).",
              ],
            },
          ],
        },
        {
          title: "Registration Process of Limited Liability Partnership",
          description:
            "The Ministry of Corporate Affairs vides its notification dated 18th February 2020 effective from 23rd February 2020 has further amended the Companies (Incorporation) Rules, 2014 thereby substituting the old Form INC-32 (SPICe) with web service SPICe+ along with certain other amendments.",
          content: [
            {
              type: "process",
              title: null,
              description: null,
              steps: [
                {
                  step: 1,
                  title: "Name Application Through Run On MCA Portal",
                  description:
                    'The first step is to make an application for reservation of name which shall be reserved by using the web services (RUN LLP) available at www.mca.gov.in along with the specified fees. Two proposed LLP names (along with their justification) are applied online via RUN LLP form on the MCA portal.<br><br>Before applying for a name, kindly check that the name is available on MCA as well as no trademark if there is no such name under the Class of work you are going to apply for Click on the below-given link to check: <a href="https://cagovindsinha.com/services/trademark-registration/">Trademark Registration.</a> Once the name is allotted by the Ministry, it is reserved for a period of 20 days from date of approval.',
                },
                {
                  step: 2,
                  title: "Obtaining DSC",
                  description:
                    "Before initiating the process of registration, you must apply for class 2 digital signatures of the designated partners of the proposed LLP. This is due to the fact that all LLP documents are submitted online and must be digitally signed.",
                },
                {
                  step: 3,
                  title: "E-Filing for Registration of LLP",
                  description:
                    "Form FiLLiP is the application form for the incorporation of the LLP. FiLLiP is an integrated form that offers a number of services, namely allotment of DIN, Reservation of Name and Incorporation of LLPs.The application for incorporation of LLP shall be accompanied with documents like subscriber’s sheet, directors KYC, consent form and registered office address proof. The e-form has to be digitally signed by one of the partner of LLP through their DSC and certified by the practicing professional (CA/CS/CWA).",
                },
                {
                  step: 4,
                  title: "Certificate of Incorporation",
                  description:
                    "Once the E-Form FiLLiP is approved by the Ministry, the Certificate of Incorporation is provided via E-mail.",
                },
                {
                  step: 5,
                  title: "Filing of LLP Agreement",
                  description:
                    'The last step is to file a limited liability partnership agreement, The agreement governs the mutual rights & obligations between the partners and between the LLP & its partners. The LLP must be submitted within 30 days of the inclusion of Form 3 and must be printed on stamp paper and should be duly notarized. The rate of stamp duty depends on the state and the capital contribution of the LLP.<br><br>LLP Partnerships is a new and convenient concept that does not require any minimum capital. Besides, the registration cost is reasonable.<br><br>If you wish to commence your business with Limited Liability Partnership, then it is very important to get it registered under <a href="https://en.wikipedia.org/wiki/The_Limited_Liability_Partnership_Act,_2008" target="_blank">Limited liability Partnership Act, 2008</a>.<br><br>One must get its business registered as a Limited Liability Partnership using the legal registration services from professionals who can take on the responsibility for your taxes and commercial compliances.',
                },
              ],
            },
          ],
        },
      ],
      features: [], // No distinct features section found beyond hero advantages
      tables: [], // No distinct tables section found
      faq: [
        {
          question:
            "Who can become Partners to the Limited Liability Partnership?",
          answer:
            "Any individual or body corporate may be a partner in an LLP. However, an individual shall not be capable of becoming a partner of an LLP, if—<ul><li>he has been found to be of unsound mind by a Court of competent jurisdiction and the finding is in force;</li><li>he is an undischarged insolvent; or</li><li>he has applied to be adjudicated as an insolvent and his application is pending.</li></ul>",
        },
        {
          question:
            "What are the documents required for forming an Limited Liability Partnership?",
          answer:
            "<b>For Partners</b><ul><li>PAN Card or Passport (for Foreigners)</li><li>Driving license or Aadhar card, residence card or election identity card, or other government-issued identity documents.</li><li>Telephone Bill or Bank Statement not older than 3 months</li></ul><b>For Registered Office Proof</b><ul><li>The landlord shall not be required to provide proof of objection to the name on the gas or electricity bill or the property tax receipt or water bill or sales note in order to use the premises as its registered office.</li><li>Documentary evidence of any utilities, such as gas, electricity, telephone, etc., clearly indicating the address or document of the premises in the name of the owner (not older than two months).</li></ul>",
        },
        {
          question:
            "What is the minimum capital requirement for incorporating Limited Liability Partnership?",
          answer:
            "There is no minimum capital required for incorporating LLP under LLP Act 2008.",
        },
        {
          question:
            "What are the minimum requirements of becoming a Partner in Limited Liability Partnership ?",
          answer:
            "Any individual or corporate body can be a partner in an Limited Liability Partnership provided that the designated partner (individual) needs to be a major i.e. above the age of 18 years. The Ministry of Corporate Affairs (MCA) has not prohibited on the citizenship or residency of the partner. Thus, any foreign national or the foreign corporate body can be admitted as a partner in Indian LLP with the condition that it must have at least one designated partner should be a resident of India.",
        },
        {
          question:
            "What are the criteria's of getting the accounts of Limited Liability Partnership audited by an auditor?",
          answer:
            "It is not mandatory under the Limited Liability Partnership Act, 2008 to get the accounts audited to a certain limit, hence it is necessary to get them audited when:-<ul><li>When the contribution of the Limited Liability Partnership exceeds Rs.25 Lakhs;</li><li>When the annual turnover of the Limited Liability Partnership exceeds Rs.40 Lakhs.</li></ul>",
        },
        {
          question:
            "Is it possible to convert a Limited Liability Partnership into a Company or Partnership Firm?",
          answer:
            "An Limited Liability Partnership cannot be converted into a Company because of the Acts are separately governed while it is possible to convert an Limited Liability Partnership into a Partnership Firm.",
        },
        {
          question:
            "How much stamp duty is to be paid for drafting of Limited Liability Partnership?",
          answer:
            "The stamp duty is based upon the capital of the LLP and the state in which you are incorporating the LLP.",
        },
        {
          question:
            "Can Foreign National or a NRI become of Designated Partner in a Limited Liability Partnership?",
          answer:
            "Yes Foreign National or a NRI can become designated partners subject to the condition that there must be at least one Indian Designated Partner. There is no restriction on capital sharing ratio.",
        },
      ],
    },
  },
  "nidhi-company-registration": {
    title: "Nidhi Company Registration",
    hero: {
      title: "Nidhi Company",
      description:
        "‘Nidhi’ means a company that aims to increase the sustainability and saving habits of its members, to take deposits, and to lend only to its members for their mutual benefit.",
      advantages: [
        "Limited Liability Protection to Director's personal assets",
        "Accept Deposits and grant loans",
        "Easy Access to Public Funds",
        "Good option for savings",
        "Less Complex Structure than NBFC",
      ],
      eligibleCriteria: [
        "Minimum Three Directors",
        "Minimum Seven Shareholders",
        "Minimum Capital : 10,00,000/-",
        "Maximum Fifteen Directors",
        "One Director shall be Indian resident",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction",
          description:
            "‘Nidhi’ means a company that aims to increase the sustainability and saving habits of its members, to take deposits, and to lend only to its members for their mutual benefit. Only an individual can be a member of a Nidhi company. A corporation or limited partnership cannot become a member of a Nidhi Company. Hence it cannot take deposits from or lend money to any corporate body. A Nidhi Company also provides loans to its members at a lesser rate comparatively than Banks. The company independently still must adhere with the rules and regulations set by the Central Government for regulation of such companies. Govind Sinha & Co. offers Best Nidhi Company Registration in India. Process of Registration, Requirements. Register Your Nidhi Finance Company Today!",
        },
        {
          title: "Basic Conditions For Incorporation Of A Nidhi Company",
          content: [
            {
              type: "h2",
              text: "Core Principles",
              bullets: [
                "<b>Can only act as a Public Company</b><br>The Nidhi Co. that has been incorporated should only act as a Public Company.",
                "<b>Cannot issue Preference Shares</b><br>Preference shares cannot be issued by any Nidhi company to its members at any condition.",
                "<b>Paid-up Share Capital</b><br>Every Nidhi company need to have a paid-up equity share capital for the company, of the amount of Rs. 1000000 (Ten lakhs only)",
                "<b>Inclusions in MOA</b><br>Every Nidhi company should include objects in its MOA other that these objects of receiving deposits from and lending money to its members only for mutual benefit.",
                "<b>Company Name</b><br>All Nidhi companies should end its company name with Nidhi Ltd. Only.",
              ],
            },
          ],
        },
        {
          title: "Requirements: Post-Incorporation (Within 1 Year)",
          description:
            "Every Nidhi company must have the following criteria fulfilled after one year of commencement of its rules:",
          content: [
            {
              type: "h2",
              text: "1. Minimum Members and Net Owned Funds",
              bullets: [
                "<b>Number of Members</b><br>There should not be less than two hundred members in the company.",
                "<b>Net Owned Funds</b><br>The company should have a net owned fund of at least twenty lakh rupees or more.",
                "<b>Term Deposit</b><br>The companies unencumbered term deposit should not be less than 10% of the total outstanding deposit, (likewise specified in rule 14).",
                "<b>Ratio of Net Owned Fund to Company Deposits</b><br>The ratio of the company’s net owned fund to the company deposit should be maximum 1:20.",
              ],
            },
          ],
        },
        {
          title: "Requirements: For Incorporation",
          description:
            "The minimum number of members/subscribers required to register for a Nidhi company are seven members and the minimum number of directors required are only 3 to register for a Nidhi company. Therefore, a member of a Nidhi company is a person who buys and owns shares in a company with share capital. They become members when their name is entered in the register of members. And a director of a Nidhi company is a person who leads or supervises a particular type of business for the company.",
        },
        {
          title: "Documents & Information Required",
          content: [
            {
              type: "h2",
              text: "3. Required Documents Checklist",
              bullets: [
                "Self-attested ID proof of all members/subscribers and directors, which could be a valid passport, voter id, Aadhar card or valid driving license.",
                "Self-attested address proof of all members/subscribers and directors (It should not be older than 2 months), which includes bank statements, electricity bill, telephone bill, mobile bill.",
                "Self-attested PAN Card of all members/subscribers and directors.",
                "2-2 Passport Size Colored Photos of Members/Subscribers and Directors",
                "The documents and information of the registered office is also required.<ul><li>If the registered office is taken on lease, then a NOC from the landlord,lease agreement, utility bill (either electricity bill or mobile bill or telephone bill which is not older than 2 months) is  to be submitted.</li><li>If the registered office is not taken on lease, then a NOC from the owner of the property, property papers, utility bill (either electricity bill or mobile bill or telephone bill which is not older than 2 months) is to be submitted.</li></ul>",
              ],
            },
            {
              type: "h2",
              text: "4. Other Information Required",
              bullets: [
                "The total amount of authorized and paid-up share capital of the proposed company and number of shares subscribed by members.",
                "The place of birth and duration of stay of members and directors at their present residential address.",
                "Occupation of all members and director.",
                "The proposed object/business of the proposed company",
                "Educational qualification of all members and directors.",
                "Email IDs and contact number of all members and directors.",
              ],
            },
          ],
        },
        {
          title: "Process of Registration",
          description:
            "The ministry of Corporate Affairs vides its notification dated 18th February 2020effective from 23rd February 2020 has further amended the companies(incorporation) rules, 2014 thereby substituting the old form INC-32 (SPICe) with web service SPICe+ along with certain other amendments.",
          content: [
            {
              type: "process",
              title: "Registration Process Steps",
              steps: [
                {
                  step: 1,
                  title: "An Application of Name Registration",
                  description:
                    'The first step is to make an application for reservation of name which shall be reserved by using the web services (SPICe+) available at www.mca.gov.in along with the specified fees. Before Applying for the name, kindly check that the name is available on <a href="https://www.mca.gov.in/content/mca/global/en/home.html" target="_blank">MCA</a> as well as no trademark. Is there no such name under the Class of work you are going to apply.<br><br>The same can be checked by clicking on the link below: <a href="https://cagovindsinha.com/services/trademark-registration/">Trademark Registration</a> <br><br>The new integrated form consists of two parts i.e. PART A and Part B. The Name(s) of a company can be reserved in Part A of SPICe+. In case the applicant wants to apply for name, incorporation, and other integrated services together, he can do so together by filling necessary information in Part A and Part B.',
                },
                {
                  step: 2,
                  title: "Fill Part B of SPICe+, MOA, AOA and AGILe Form",
                  description:
                    "The second step is to fill the Part B of SPICe+ for registering the Company. Thesaid form contains various sections that allow you to save and modify the requiredinformation if required. Also you need to fill the MOA and AOA of the company along with AGILe form.",
                },
                {
                  step: 3,
                  title: "Convert SPICe+ Form into PDF",
                  description:
                    "The third step is to convert the SPICe+ form into a pdf format to affix the DSC.",
                },
                {
                  step: 4,
                  title: "Upload the Form on Ministry of Corporate Affairs",
                  description:
                    "After affixing the DSC the form is required to be upload on the Ministry of Corporate Affairs in accordance with the existing process.",
                },
                {
                  step: 5,
                  title:
                    "Declaration of the Companies Directors and Subscribers",
                  description:
                    "Declaration of all subscribers and first directors of the company which is currentlybeing filed in Form INC-9 will be automatically generated in pdf format and shall be submitted only through Electronic form in all cases, except in case:<br>a) The no. of subscribers and/or directors is more than 20.<br>b) Any of the subscribers and/or directors do not have DIN and PAN<br>",
                },
              ],
            },
          ],
        },
        {
          title: "Changes As Per The Amendments Introduced Recently",
          content: [
            {
              type: "h2",
              text: "Amendment Highlights",
              bullets: [
                "<b>No need to mention SRN: </b><br>There is no need to mention SRN for names reserved in Part A of SPICE+ as the same will be automatically displayed while filing Part B after filing of Part A.",
                "<b>Mandatory Registration for ESIC and EPFO: </b><br>Registration for ESIC and EPFO has been made mandatory for all new companies that are incorporated w.e.f 23rd February 2020.",
                "<b>Professional Registration for Maharashtra: </b><br>Registration for Profession Tax is made mandatory for all new companiesincorporated in Maharashtra state, with effect from 23rd February 2020.",
                "<b>Mandatory Application for opening a bank account: </b><br>Application for opening of bank account is made mandatory for all newcompanies incorporated with effect from 23rd February 2020 the sameapplication shall be filed through the form AGILE-PRO linked web form.",
                "<b>Declaration of Company’s Subscribers and First Directors in PDF form & e-submission: </b><br>Declaration of all Subscribers and First Directors of the Company which is currently being filed in Form INC-9 will be automatically generated in pdf format and shall be submitted only through Electronic form in all cases, except in case:<ul><li>The no. of subscribers and/or directors is more than 20.</li><li>Any of the subscribers and/or directors don’t have DIN and PAN.</li></ul>",
                "<b>Mandatory use of e-MoA (INC-33) and e-AoA (INC-34) (in some cases): </b><br>It is mandatory to use e-MoA (INC-33) and e-AoA (INC-34) in case the number of subscribers is up to 7 and in the following scenarios:<ul><li>Individual subscribers are Indian nationals</li><li>Individual subscribers who are foreign nationals in case they valid DIN and DSC and also submit proof of a valid business visa</li><li>Non-individual subscribers based in India.</li></ul>",
                "<b>Signed Physical Copies of the MoA / AoA (in some cases): </b><br>Physical copies of the MoA / AoA must be signed and attached if the individuals' first subscribers are located outside India or if the individual outsourcers do not have a valid business practice or any of the following scenarios: -",
              ],
            },
          ],
          table: {
            title: "Forms Filing Scenarios for MoA/AoA",
            headers: ["S. No.", "Cases", "Forms to be filed"],
            rows: [
              [
                "1.",
                "Non-Individual first subscriber based outside India",
                "SPICe+ (INC-32) with apostille MOA and AOA as attachments",
              ],
              [
                "2.",
                "Non-Individual first subscriber based in India",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "3.",
                "Indian National being Subscriber other than Director",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "4.",
                "Indian National being Subscriber-cum-Director",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "5.",
                "Foreign National being Subscriber other than director having valid DIN",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34) along with Valid Business Visa to be submitted.<br><br>In case Business Visa is not available, apostille MOA and AOA shall be attached and in such cases, e-MOA (INC33) and eAOA (INC-34) are NOT acceptable.",
              ],
              [
                "6.",
                "Foreign National being Subscriber-cum-Director having valid DIN",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34) along with valid Business Visa to be submitted.<br><br>In case Business Visa is not available, apostille MOA and AOA shall be attached and in such cases, e-MOA (INC33) and e-AOA (INC-34) are NOT acceptable.",
              ],
              [
                "7.",
                "Foreign National being Subscriber-cum-Director not having valid DIN",
                "SPICe+ (INC-32) with apostille MOA and apostille AOA as attachments.",
              ],
            ],
          },
          description_after_table:
            "<b>Note: </b>In all the above-mentioned cases, the maximum number of subscribers allowed shall be 7 for filing of SPICe+ form. Wherever the number of subscribers exceeds 7, SPICe+ form shall be filed with MoA and AoA as attachments",
          final_bullet:
            "<b>Mandatory Filing of Statutory Return</b><br>Companies newly incorporated through SPICE+ and who have obtained EPFO/ESI number will have to file Statutory Return only if the prescribed threshold limit has been exceeded.<br>To read more about nidhi company compliances, click on Nidhi Company",
        },
      ],
      faq: [
        {
          question: "With what objects Nidhi Company should be formed?",
          answer:
            "The Public Limited Company is best suited for the large business operating entities as helps them in availing the loans easily and making them able to reach people at large also It provides them the credibility and a image of their business in the eye of financial institution, suppliers & potential clients.",
        },
        {
          question: "Whether a Nidhi Company can provide loan to non members?",
          answer:
            "In case of Nidhi Company there lies a principle of mutual benefit to pool the savings from members and can lend only to the members & never have dealing with Non members.",
        },
        {
          question: "Who can be the members of the Nidhi Company?",
          answer:
            "Members who are only individuals. Bodies Corporate or the Trust can never be admitted as Members.",
        },
        {
          question:
            "Whether Nidhi Companies can engage themselves itself in the business other than mentioned above like (chit fund, hire purchase, Insurance etc)?",
          answer:
            "The Nidhi Companies are not expected to engage themselves in the business like Chit Fund, hire purchase, insurance or in any other business which includes investments in shares or debentures.",
        },
        {
          question:
            "What will be the status of the Nidhi Company after Incorporation?",
          answer:
            "A Nidhi Company incorporated under the Companies Act, 2013 shall be regarded as a Public Limited Company.",
        },
        {
          question: "What is the maximum saving limits?",
          answer:
            "One Member of Nidhi Company shall not have the maximum balance of more than Rs. 1 lakh in a savings account & the maximum rate of interest which is to be paid on any deposits shall not be more than 2% above the rate of interest payable by the nationalized banks, on such deposits.",
        },
        {
          question: "How net owned funds are calculated?",
          answer:
            "Net Owned Fund is equal to Paid up share capital + Free Reserves – Accumulated losses, deferred revenue expenditure, and other intangible assets.",
        },
        {
          question:
            "Is there any requirement to take approvals from the Reserve Bank of India for incorporating Nidhi Company?",
          answer:
            "No, there is no such requirement to obtain any licence or permission from the RBI as the Reserve Bank of India has exempted Nidhi Companies from the applicability of its core provisions.",
        },
        {
          question: "Is it possible to declare dividends by the Nidhi Company?",
          answer:
            "Yes a Nidhi Company may declare dividends which shall not exceed 25% or higher as may be approved by Regional Director subject to the fulfillment of certain conditions.",
        },
        {
          question: "Whether Nidhi Companies can issue Preferential Shares?",
          answer:
            "No, a Nidhi Company cannot issue Preferential Shares as prescribed by the Companies Act, 2013.",
        },
        {
          question:
            "What are the requirements to be fulfilled post incorporation by a Nidhi Company?",
          answer:
            "Once the Nidhi Company is registered, it must fulfill the following mentioned requirements:<ul><li>Have at least 200 members/shareholders.</li><li>Minimum Net Owned Fund should be Rs. 10 Lakhs.</li><li>Unencumbered term deposit must be at least 10% of the term deposit.</li><li>The ratio of Net Owned Fund to term deposit should not be less than 1:20.</li></ul>",
        },
      ],
    },
  },
  "producer-company-registration": {
    title: "Producer Company Registration",
    hero: {
      title: "Producer Company Registration",
      description:
        "A producer company is a legally organised body of farmers and agriculturalists, designed to improve their standard of living, income, and profitability through collective activities.",
      advantages: [
        "Limited Liability Protection",
        "Access to Loans and Credit Facilities",
        "Ideal for Farmers and Agriculturalists",
        "Supports a Wide Range of Agricultural Activities",
        "Allows for a Large Number of Members",
      ],
      eligibleCriteria: [
        "Minimum Five Directors",
        "Minimum Ten Shareholders (Producers)",
        "Minimum Authorized Capital: ₹5,00,000",
        "Maximum Fifteen Directors",
        "At least one Director must be an Indian resident",
      ],
    },
    content: {
      overviews: [
        {
          title: "Meaning of a Producer Company",
          description:
            "A producer company is a legally organised body of mainly farmers and agriculturalists, which was introduced by the government to help raise the standard of living, income and profitability of Indian farmers and agriculturalists. A producer company is formed as a private company itself and is governed under the provision of Companies Act 1956. The company is incorporated with an objective as stated under the law i.e. Production, harvesting or selling as the primary production and related activities. A farmer/agriculturist can incorporate a producer company when they have 10 or more producers and 5 directors with a minimum capital of Rs. 5,00,000/-. Thereafter, there are a few objections stated by the government for producer companies, that can be read under the Section 581B of the Companies Act, 1956.",
        },
        {
          title: "Governing Provisions for a Producer Company",
          description:
            "There is no particular provision for Producer Company under Companies Act, 2013, however, chapter IXA of Companies Act, 1956 administers it.<br/><br/><b>Section 465 of the Companies Act, 2013</b><br/>According to this section, the Companies Act, 1956 and the Registration of Companies (Sikkim) Act,1961 shall not be in force. Under this section, the provisions of Part IX A of the Companies Act, 1956 are pertinent to a Producer Company in a way as if the Companies Act, 1956 has not been abolished until a particular Act is legislated for Producer Companies.",
        },
        {
          title: "Permitted Activities for Producer Companies",
          description:
            "Under the Companies Act, a producer company is allowed to carry on or associate with any of the below-mentioned activities:",
          content: [
            {
              type: "h2",
              text: "Permitted Activities",
              bullets: [
                "Production, processing, harvesting, procurement, pooling, grading, handling, selling, marketing, export of members’ primary produce or import of goods or services for the advantage of members.",
                "Providing training & education, technical & consultancy services, research & development and all other events that promotes Members’ interests.",
                "Production, transmission and dispersion of power, restoration of natural reserves of water & land and their utilisation, preservations and communications associated with elementary produce.",
                "Promoting mutual assistance, welfare measures, financial services, insurance of producers or their primary produce.",
              ],
            },
          ],
        },
        {
          title: "Requirements for Incorporation",
          description:
            "The Companies Act has listed the following requirements for the incorporation of a Producer company.",
          content: [
            {
              type: "h4",
              text: "1. Documents Required",
              bullets: [
                "<b>PAN Card:</b> Self-attested PAN Card of all Members and Directors.",
                "<b>Passport Size Photo:</b> Recent passport-size colored photos of all Members and Directors.",
                "<b>Identity Proof:</b> Self-attested ID proof of Members and Directors (e.g., Valid Passport, Voter ID, Aadhar Card, or a Valid Driving License).",
                "<b>Address Proof:</b> Self-attested address proof of Members and Directors, not older than 2 months (e.g., Bank Statement, Electricity Bill, Telephone Bill).",
                "<b>Business Address Proof:</b> NOC from the property owner, property papers (Title Deed), and a recent utility bill (not older than 2 months).",
                "<b>Agriculture-Related Documents:</b><ul><li>Khasra or Katuni of the subscribers along with their jamabandi.</li><li>Producer certificate for all subscribers, certified by a tehsildar, agriculture officer, patwari, SDM, or district administrator.</li></ul>",
              ],
            },
            {
              type: "h4",
              text: "2. Information Required",
              bullets: [
                "Authorized and Paid-up Share Capital of the proposed company and the number of shares subscribed by members.",
                "Place of birth and duration of stay of all Members and Directors at their present residential address.",
                "Occupation of all Members and Directors.",
                "Proposed object/business of the proposed company.",
                "Educational qualification of all Members and Directors.",
                "Email IDs and contact numbers of all Members and Directors.",
              ],
            },
          ],
        },
        {
          title: "Process of Producer Company Registration",
          description:
            "The Ministry of Corporate Affairs (MCA) has streamlined the incorporation process through the SPICe+ web service, which integrates several services into a single application.",
          content: [
            {
              type: "process",
              title: "Step-by-Step Registration Process",
              steps: [
                {
                  step: 1,
                  title: "Application for Name Reservation (SPICe+ Part A)",
                  description:
                    "The first step is to apply for name reservation using the SPICe+ web service on the MCA portal. It's crucial to check for name availability and ensure it doesn't conflict with existing trademarks.",
                },
                {
                  step: 2,
                  title: "Fill Part B of SPICe+",
                  description:
                    "The second step involves filling out Part B of the SPICe+ form for company registration. This integrated form includes applications for DIN, PAN, TAN, and other necessary registrations.",
                },
                {
                  step: 3,
                  title: "Convert to PDF and Affix DSC",
                  description:
                    "The third step is to convert the filled SPICe+ web form into a PDF to affix the Digital Signature Certificate (DSC) of the directors and the professional certifying the form.",
                },
                {
                  step: 4,
                  title: "Upload the Form on MCA Portal",
                  description:
                    "After affixing the DSC, the completed form must be uploaded to the Ministry of Corporate Affairs portal for approval.",
                },
                {
                  step: 5,
                  title: "Declaration of Directors and Subscribers",
                  description:
                    "The declaration of all subscribers and first directors (formerly Form INC-9) is now automatically generated in PDF format and submitted electronically with the main form.",
                },
              ],
            },
          ],
        },
        {
          title: "Changes as per Recent Amendments",
          content: [
            {
              type: "h4",
              text: "Key Updates to the Incorporation Process",
              bullets: [
                "<b>No need to mention SRN:</b> The SRN for the reserved name in Part A is auto-filled when filing Part B.",
                "<b>Mandatory ESIC and EPFO Registration:</b> This is compulsory for all new companies incorporated from February 23, 2020.",
                "<b>Mandatory Professional Tax Registration (Maharashtra):</b> This is required for all new companies incorporated in Maharashtra.",
                "<b>Mandatory Bank Account Application:</b> A bank account must be opened via the AGILE-PRO-S form.",
                "<b>E-submission of Declarations:</b> The declaration by subscribers and directors (INC-9) is now auto-generated and submitted electronically.",
                "<b>Mandatory e-MoA and e-AoA:</b> Electronic Memorandum and Articles of Association are mandatory in most cases, especially for up to 7 Indian subscribers.",
              ],
            },
          ],
          table: {
            title: "Form Filing Scenarios for MoA & AoA",
            headers: ["S. No.", "Cases", "Forms to be filed"],
            rows: [
              [
                "1.",
                "Non-Individual first subscriber based outside India",
                "SPICe+ (INC-32) with apostilled MOA and AOA as attachments",
              ],
              [
                "2.",
                "Non-Individual first subscriber based in India",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "3.",
                "Indian National being Subscriber other than Director",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "4.",
                "Indian National being Subscriber-cum-Director",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34)",
              ],
              [
                "5.",
                "Foreign National being Subscriber other than director having valid DIN",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34) along with Valid Business Visa. If visa is unavailable, apostilled physical copies are required.",
              ],
              [
                "6.",
                "Foreign National being Subscriber-cum-Director having valid DIN",
                "SPICe+ (INC-32) with linked filing of e-MOA (INC-33) and e-AOA (INC-34) along with valid Business Visa. If visa is unavailable, apostilled physical copies are required.",
              ],
              [
                "7.",
                "Foreign National being Subscriber-cum-Director not having valid DIN",
                "SPICe+ (INC-32) with apostilled MOA and apostilled AOA as attachments.",
              ],
            ],
          },
          description_after_table:
            "<b>Note:</b> In all the above-mentioned cases, the maximum number of subscribers allowed for e-filing of SPICe+ is 7. If the number exceeds 7, the SPICe+ form must be filed with physical copies of MoA and AoA as attachments.",
        },
      ],
      features: [],
      tables: [],
      faq: [
        {
          question: "How many people are required to form a Producer Company?",
          answer:
            "A minimum of five Directors and ten Members (who are primary producers) are required to form a Producer Company.",
        },
        {
          question: "Can a Director and a Shareholder be the same person?",
          answer:
            "Yes, a director can also be a shareholder (member) and vice versa, as the company is a separate legal entity.",
        },
        {
          question:
            "What is the minimum capital requirement to form a Producer Company?",
          answer:
            "While there is no prescribed minimum capital, it is generally advised to incorporate with an authorized capital of at least ₹5 Lakhs.",
        },
        {
          question: "What are the activities allowed for a Producer Company?",
          answer:
            "Permitted activities include:<ul><li>Production, harvesting, processing, procurement, grading, marketing, and export of members' primary produce.</li><li>Rendering technical services, consultancy, training, and R&D for members.</li><li>Generation and transmission of power, and revitalization of land and water resources.</li><li>Promoting mutual assistance, welfare measures, financial services, and insurance for producers.</li></ul>",
        },
        {
          question:
            "What is the maximum time to deposit the share subscription money?",
          answer:
            "Members should deposit their share subscription money at the earliest. The company must file the form for commencement of business within 180 days from its date of incorporation.",
        },
        {
          question:
            "Can the subscription money deposited in the bank account be withdrawn?",
          answer:
            "The subscription money cannot be withdrawn for non-business purposes but can be used by the company for its official operations, such as paying salaries and other administrative expenses.",
        },
        {
          question: "Is it mandatory for directors to have a PAN Card?",
          answer:
            "Yes, it is mandatory for all Indian nationals who wish to become directors in a company to have a PAN Card. For foreign nationals, a valid passport is required.",
        },
        {
          question: "What is a Company Registration Certificate?",
          answer:
            "It is the official document issued by the Registrar of Companies as conclusive evidence that the company has been registered and is assigned a unique Corporate Identification Number (CIN).",
        },
        {
          question:
            "Can a residential address be used as the registered office?",
          answer:
            "Yes, a residential or commercial property can be used as the registered office of the company, provided the necessary documents (like a No-Objection Certificate from the owner) are submitted.",
        },
        {
          question:
            "What are the annual statutory compliance requirements for a Producer Company?",
          answer:
            "Key compliances include:<ul><li>Conducting the first Annual General Meeting (AGM) within 90 days of incorporation.</li><li>Holding subsequent AGMs annually, with a gap of no more than 15 months between two AGMs.</li><li>Filing the Annual Return and financial statements with the Registrar within 60 days of the AGM.</li></ul>",
        },
        {
          question:
            "What is the maximum limit of members in a Producer Company?",
          answer:
            "There is no upper limit on the number of members in a Producer Company.",
        },
        {
          question: "Who can be a member of a Producer Company?",
          answer:
            "Any person engaged in any activity connected with primary produce ('Producer') or an institution composed of producers ('Producer Institution') can be admitted as a member.",
        },
        {
          question:
            "What are the tax benefits available to a Producer Company?",
          answer:
            "The Income Tax Act, 1961, exempts agricultural income under Section 10(1), though the extent of the exemption may vary based on the specific agricultural activity. Dividend income distributed by the company is also tax-free in the hands of the members.",
        },
      ],
    },
  },
  "one-person-company-registration": {
    title: "One Person Company Registration",
    hero: {
      title: "One Person Company Registration",
      description:
        "One Person Company (OPC) registration is a new concept that enables solo entrepreneurs to launch their businesses within a corporate framework, enjoying both limited liability and a separate legal identity.",
      advantages: [
        "Limited Liability Protection",
        "Separate Legal Entity",
        "Perpetual Existence",
        "Best option for single owners",
        "Less Procedural Compliances",
      ],
      eligibleCriteria: [
        "Minimum One Director",
        "Minimum One Nominee",
        "No Minimum Capital required",
        "DSC of the director",
        "Director shall be Indian resident",
      ],
    },
    content: {
      overviews: [
        {
          title: "Meaning Of One Person Company",
          description:
            "According to Section 2(62) of Companies Act, a one-person company is a business entity which has only one individual as its member. Moreover, the company’s members are nothing but either the subscribers to the company’s MOA (memorandum of association) or its shareholders.<br/><br/>Therefore, an OPC can be defined as a company which has a single shareholder as its member.<br/><br/>One Person Company (OPC) registration is a new concept that surpasses the limitations of resources, time and mediums to get more partners for the execution of business plans and enables us to promote the incorporation of micro-businesses & accomplish our entrepreneurial dreams.<br/><br/>OPC can also be considered as the combination of Company and Sole proprietorship. OPC can be registered as a one-person company under Section 2(62) of the Companies Act, 2013 and the rules thereto. The absence of complexities that comes with multiple partners, motivates many people to incorporate an OPC to start their business. Besides, Limited Liability also bolsters the incorporation of OPCs.",
        },
        {
          title: "Rationale Behind One Person Company",
          content: [
            {
              type: "h2",
              text: "Key Rationale",
              bullets: [
                "An individual can easily transform the business idea into a corporate form.",
                "Limited Liability",
                "OPC can be solely carried out by the same person.",
                "Limited resources are adequate in OPC.",
                "No minimum paid-up share capital under the Companies Act, 2013.",
                "Perpetual succession",
              ],
            },
          ],
        },
        {
          title: "Benefits of One Person Company Registration",
          content: [
            {
              type: "h2",
              text: "Core Benefits",
              bullets: [
                "<b>Limited Liability</b><br/>Company’s member holds liability to the limit of his share in the company. In an OPC, one person has the complete share and entire authority over the business’s operations. Therefore, the liability of the person is limited to the investment made by him/her.",
                "<b>Independent Existence</b><br/>One Person Company has a separate legal entity and independent existence.",
                "<b>Less Tax Burden</b><br/>In OPC, you can receive remuneration as a director and rent as a lessor. Also, as a creditor, you can advance funds to your commercial entity and earn interest. Rent, Directors’ remuneration and interest are deductible expenses which reduce the profitability of the Company and thus reduces the taxable income of the business entity.",
                "<b>Quicker Actions</b><br/>OPC is entirely ruled and managed by one owner which results in fast decision making and quicker actions.",
                "No requirement of minimum capital contribution",
                "Compulsory Audit is required only when the Contribution exceeds 25 lakhs or the Annual Turnover exceeds 40 Lakhs.",
              ],
            },
          ],
        },
        {
          title: "Major Conditions For Incorporation Of OPC",
          description:
            "Person Incorporating an OPC & Nominee of Such OPC Shall Be –<ul><li>Natural Person; &</li><li>Indian Citizen; &</li><li>Resident of India</li></ul><br><b>Note–</b> A Person Is To Be Called Resident Of India If He Has Stayed In India For A Period Of Not Less Than 182 Days During Immediately Preceding One Calendar Year.<br><br><ul><li>No Person Shall Be Eligible To Incorporate More Than One OPC.</li><li>No Person Shall Be Eligible To Become Nominee In More Than One Such Company (OPC).</li><li>If A Person Is Already A Member In An OPC, And After This, He Becomes A Member In Another OPC Under His Being A Nominee In That OPC; Then He Shall Make Arrangements Within A Period Of 180 Days For Fulfilling The Condition As Referred In Abovementioned Point No. 2.</li></ul>",
        },
        {
          title: "Other Provisions Related With One Person Company",
          content: [
            {
              type: "h2",
              text: "Key Provisions",
              bullets: [
                "An OPC can be started with a minimum Authorized Capital of Rs. 1 lakh. There is no mandatory requirement for a minimum paid-up capital. Hence, you can start as an OPC with a capital contribution as low as Rs. 2. However, when the paid-up capital exceeds Rs. 50 lakh, OPC must mandatorily convert to a Private Limited Company. Also, when the average turnover for 3 consecutive years becomes Rs. 2 crores or more, there is a need to convert into a Private Limited Company.",
                "Such a company cannot be incorporated or converted into a Company under Section 8 of the Act.",
                "Such Company cannot carry out non-banking financial investment activities including investment in securities of any Body Corporate.",
                "No such company can convert voluntarily into any kind of company unless two years is expired from the date of incorporation of one person company, except the threshold limit (Paid Up Share Capital) is increased beyond fifty lakh rupees or its average annual turnover during the relevant period exceeds Two Crore Rupees.",
                "<b>Compulsory Conversion of OPC into Private or Public Company:</b><br>OPC Shall be required to convert itself, either into a Private Company or a Public Company as per provisions of this Act, within a period of 6 months from the date:<ul><li>On which it’s paid-up share capital has been increased beyond 50 Lakhs Rupees; or</li><li>On the last day of the relevant period during which it’s average annual turnover exceeds 2 Crore Rupees.</li></ul>Note: – “Relevant Period” Means A Period of Immediately 3 Preceding Consecutive Financial Years.",
              ],
            },
          ],
        },
        {
          title: "Documents & Information Required",
          description:
            "Companies Act, 2013 has listed the following requirements for the incorporation of an OPC.",
          content: [
            {
              type: "h2",
              text: "Documents Required",
              bullets: [
                "<b>Minimum One Director:</b><br/>Member: Member is a person who buys and holds shares in a company having a share capital. They become a member once their name is entered on the register of members. Director: A director is a person who leads or supervises a particular business of a company.",
                "<b>PAN Card:</b><br/>Self-attested PAN Card of Member and Director.",
                "<b>Identity Proof of Director:</b><br/>Self-attested ID proof of Member and Director (Anyone out of the following -Valid Passport/Voter ID/Aadhar Card/Valid Driving License)",
                "<b>Address Proof of Director:</b><br/>Self-attested Address Proof of Member and Director and Should Not be Older than 2 Months (Anyone out of the following – Bank Statement/Electricity Bill/Telephone Bill/Mobile Bill)",
                "<b>Passport Size Photo:</b><br/>2-2 Passport Size Colored Photos of Member and Director.",
                "<b>Business Address Proof (Owned/Rent/Leased):</b><br/>NOC from the Owner of Property/Property Papers (Title Deed)/Utility Bill (Either Electricity Bill or Mobile Bill or Telephone Bill) (Should Not be Older than 2 Months)",
              ],
            },
            {
              type: "h3",
              text: "Information Required",
              bullets: [
                "Authorized and Paid-up Share Capital of the Proposed Company. Explanation: A Company can be started with any amount of capital. There is no need for a minimum amount of capital.",
                "Place of Birth and Duration of Stay of Sole Member, Nominee and Director at Present Residential Address.",
                "Occupation of Sole Member, Nominee and Director.",
                "Proposed Object/Business of the Proposed Company.",
                "Educational Qualification of Sole Member, Nominee and Director.",
                "Email IDs and Contact Number of Sole Member, Nominee and Director.",
              ],
            },
          ],
        },
        {
          title: "Registration Process of One Person Company",
          description:
            "The Ministry of Corporate Affairs vide its notification dated 18th February 2020 effective from 23rd February 2020 has further amended the Companies (Incorporation) Rules, 2014 thereby substituting the old Form INC-32 (SPICe) with web service SPICe+ along with certain other amendments.",
          content: [
            {
              type: "process",
              title: "Step-by-Step Registration",
              steps: [
                {
                  step: 1,
                  title: "Acquirement of Digital Signature (DSC)",
                  description:
                    "Obtain the Digital Signature Certificate (DSC) of the proposed member and nominee.",
                },
                {
                  step: 2,
                  title: "Application for Name Reservation (SPICe+ Part A)",
                  description:
                    "An application for reservation of the company name is filed using the SPICe+ web service on the MCA portal. The new integrated form consists of two parts: PART A for name reservation and Part B for incorporation services. Both can be filed together or separately.",
                },
                {
                  step: 3,
                  title: "Filing for Incorporation (SPICe+ Part B)",
                  description:
                    "Fill Part B of the SPICe+ form for company registration. This includes attaching necessary documents like:<ul><li>Consent to act as Director in Form DIR-2</li><li>Self-attested copy of PAN and ID proofs of the proposed member, director, and nominee</li><li>Proof of address for the member, director, and nominee (not older than two months)</li><li>Proof of registered office address (NOC, utility bill, ownership proof)</li><li>Consent of Nominee in form INC-3</li><li>Electronically prepared MOA and AOA.</li></ul>",
                },
                {
                  step: 4,
                  title: "Convert Form and Affix DSC",
                  description:
                    "The filled SPICe+ form is converted into a PDF format to affix the DSC of the director and the certifying professional.",
                },
                {
                  step: 5,
                  title: "Filing of AGILE-PRO-S",
                  description:
                    "The AGILE-PRO-S form must be filled for mandatory registrations such as EPFO, ESIC, Profession Tax (if applicable), and for opening a bank account. This form is also converted to PDF to affix the DSC.",
                },
                {
                  step: 6,
                  title: "Uploading Forms to MCA",
                  description:
                    "After affixing DSCs, the SPICe+ and AGILE-PRO-S forms are uploaded to the Ministry of Corporate Affairs portal for approval.",
                },
                {
                  step: 7,
                  title: "Issuance of Certificate of Incorporation",
                  description:
                    "Once the forms are processed and approved by the ROC, the Certificate of Incorporation is issued, and the company is legally registered.",
                },
              ],
            },
          ],
        },
      ],
      features: [
        "Limited Liability Protection",
        "Separate Legal Entity",
        "Perpetual Existence",
        "Best option for single owners",
        "Less Procedural Compliances",
      ],
      tables: [],
      faq: [
        {
          question: "Who is eligible for incorporating a One Person Company?",
          answer:
            "A natural person who is a citizen of India and resident in India is eligible to incorporate a One Person Company and shall be a nominee for the sole member of an OPC.",
        },
        {
          question:
            "How many One Person Companies can be formed by one person?",
          answer: "A person can only form one One Person Company at a time.",
        },
        {
          question: "What are the requirements of nomination?",
          answer:
            "A subscriber to the Memorandum of an One Person Company shall nominate a person who will become the member of the company in the event of the subscriber's death or incapacity to contract.",
        },
        {
          question:
            "In what form is the nominee's consent required and can they withdraw it?",
          answer:
            "The nominee's prior consent is required in e-form INC-3. The nominee can withdraw their consent by giving a notice in writing. The subscriber must then nominate another person within 15 days of receiving the notice of withdrawal.",
        },
        {
          question: "Can a subscriber change the nominee?",
          answer:
            "Yes, the member can change the nominee at any time by providing a written notice with the name of the new nominee and intimating the same to the company.",
        },
        {
          question:
            "Can an OPC be converted into a Private or Public Limited Company?",
          answer:
            "Yes, an OPC can be converted. However, it cannot voluntarily convert into any other kind of company until two years have expired from the date of incorporation, unless its paid-up share capital or turnover exceeds the prescribed thresholds.",
        },
        {
          question:
            "Under which circumstances must an OPC convert to a Private or Public Limited Company?",
          answer:
            "An OPC must convert within six months if its paid-up share capital exceeds ₹50 Lakhs or its average annual turnover during the relevant period exceeds ₹2 Crore.",
        },
        {
          question:
            "Can a proprietorship business with an established brand name be converted into an OPC?",
          answer:
            "Yes, a proprietorship can be converted into an OPC, and it can retain its brand name by getting it approved during the name reservation process with the Ministry of Corporate Affairs.",
        },
        {
          question: "Are statutory returns required if the OPC incurs a loss?",
          answer:
            "Yes, annual compliances, including the filing of financial statements with the Registrar of Companies, are mandatory, regardless of whether the company made a profit or loss or had any business transactions.",
        },
        {
          question:
            "Can a One Person Company become a member of another company?",
          answer:
            "Yes, there is no restriction on an OPC becoming a member or shareholder in another Private or Public Limited Company.",
        },
        {
          question: "What will be the legal form of an One Person Company?",
          answer:
            "An OPC is legally regarded as a Private Limited Company. It can be formed as a company limited by shares or by guarantee.",
        },
      ],
    },
  },
  "partnership-registration": {
    title: "Partnership Firm Registration",
    hero: {
      title: "Partnership Registration",
      description:
        "A Partnership is a business structure where two or more individuals manage and operate a business in accordance with the terms and objectives set out in a Partnership Deed. It is one of the most popular business structures for new businesses with multiple co-founders.",
      advantages: [
        "Easy to Start",
        "Minimal Compliance Requirements",
        "Lower Registration Cost",
        "Shared Responsibility and Risk",
        "Quick Decision Making",
      ],
      eligibleCriteria: [
        "Minimum Two Partners",
        "Maximum 50 Partners",
        "A Legal Partnership Deed",
        "No Minimum Capital Required",
        "Consensus on a Business Name",
      ],
    },
    content: {
      overviews: [
        {
          title: "Meaning of a Partnership Firm",
          description:
            "In India, the Partnership Act, 1932, governs partnership firms. Section 4 of the act defines a partnership as “an agreement between persons who have agreed to share profits of a business carried on by all or any one of them acting for all.”<br/><br/>When two or more people share a business idea and wish to collaborate, they can form a partnership firm. This structure represents combined ownership, where there is no legal separation between the business and its individual partners. The foundation of the partnership is an agreement (the Partnership Deed) that outlines all its terms.<br/><br/>While the registration of a partnership firm is not compulsory, it is highly recommended as it provides several advantages, including a distinct legal identity and a framework for avoiding future conflicts. The registration is handled at the state level.",
        },
        {
          title: "Key Features of a Partnership Firm",
          content: [
            {
              type: "h2",
              text: "Core Features",
              bullets: [
                "<b>Governing Law:</b> Regulated by the Indian Partnership Act, 1932.",
                "<b>Applicability:</b> Suitable for any type of business, profession, or industry.",
                "<b>Profit & Loss Sharing:</b> Distributed among partners based on a mutually agreed-upon ratio.",
                "<b>Liability:</b> Partners have unlimited liability, meaning personal assets can be used to cover firm debts.",
                "<b>Tenure:</b> The firm's existence depends on the partners' will or terms specified in the deed. It can be dissolved upon the death, retirement, or insolvency of a partner.",
              ],
            },
          ],
        },
        {
          title: "Advantages of Partnership Registration",
          content: [
            {
              type: "h2",
              text: "Primary Benefits",
              bullets: [
                "<b>Quick Decision-making:</b> Each partner can act on behalf of the others, allowing the business to respond swiftly to opportunities and challenges with minimal bureaucracy.",
                "<b>Profit Distribution:</b> Profits are passed directly to the partners according to their agreed-upon ratio and are taxed as part of their individual income.",
                "<b>Low Cost & Fewer Formalities:</b> Partnerships are relatively easy and inexpensive to establish, with fewer formalities and less external regulation compared to companies.",
              ],
            },
          ],
        },
        {
          title: "Is Registration Necessary?",
          description:
            "According to the Indian Partnership Act, 1932, the registration of a partnership firm is optional and at the discretion of the partners. The registration can be done at any time—before starting the business or during its operation. However, it is always advisable to register the firm, as registered firms enjoy special rights and legal benefits that are not available to unregistered firms.",
        },
        {
          title: "Documents Required For Registration",
          content: [
            {
              type: "h4",
              text: "Required Documentation",
              bullets: [
                "Application for registration of partnership (Form 1).",
                "A notarized copy of the Partnership Deed on stamp paper.",
                "A specimen of an affidavit certifying all the details mentioned in the deed and documents are correct.",
                "PAN card and address proof of all partners.",
                "Proof of the principal place of business for the firm (e.g., ownership documents or a rental/lease agreement).",
              ],
            },
          ],
          description_after_table:
            "Once the Registrar is satisfied with the submitted documents, the firm will be entered into the Register of Firms, and a Certificate of Registration will be issued.",
        },
        {
          title: "Process of Partnership Firm Registration",
          description:
            "The process of registering a Partnership Firm involves the following key steps:",
          content: [
            {
              type: "process",
              title: "Registration Steps",
              steps: [
                {
                  step: 1,
                  title: "Select a Name for the Firm",
                  description:
                    "Choose a unique name for the partnership firm that is not too similar to existing entities.",
                },
                {
                  step: 2,
                  title: "Create and Attest the Partnership Deed",
                  description:
                    "Draft a comprehensive partnership deed, print it on stamp paper, and have it signed by all partners and attested by a notary.",
                },
                {
                  step: 3,
                  title: "File for Registration",
                  description:
                    "Submit the registration application (Form 1) along with the partnership deed and other required documents to the Registrar of Firms in the relevant state.",
                },
                {
                  step: 4,
                  title: "Apply for PAN Card",
                  description:
                    "After the firm is registered, apply for a permanent account number (PAN) in the firm's name.",
                },
                {
                  step: 5,
                  title: "Open a Current Bank Account",
                  description:
                    "Open a current account in the name of the partnership firm to manage business transactions.",
                },
              ],
            },
          ],
        },
      ],
      features: [],
      tables: [],
      faq: [
        {
          question: "Is it necessary to register a partnership firm?",
          answer:
            "No, it is not legally mandatory to register a partnership firm. However, if it is not registered, it faces consequences such as:<ul><li>A partner cannot sue another partner or the firm to enforce a right.</li><li>The firm cannot sue a third party in a court of law to enforce its rights.</li></ul>",
        },
        {
          question:
            "What are the minimum capital requirements for registration?",
          answer:
            "There is no minimum capital requirement for forming a Partnership Firm. Partners can contribute any amount of capital as mutually agreed, in tangible forms like cash or in intangible forms like goodwill.",
        },
        {
          question:
            "How many people are required to register a partnership firm, and are there any specific requirements?",
          answer:
            "A partnership firm requires a minimum of two partners. All partners must be competent to contract (i.e., not a minor and of sound mind). While NRIs and PIOs can invest, it typically requires prior government approval.",
        },
        {
          question:
            "What are the advantages of registering a partnership firm?",
          answer:
            "<ul><li><b>Quick Decision-making:</b> Partners can act independently, reducing bureaucracy.</li><li><b>Direct Profit Sharing:</b> Profits are passed directly to partners as per their agreed ratio.</li><li><b>Low Cost & Fewer Formalities:</b> They are easy and inexpensive to establish with limited external regulation.</li></ul>",
        },
        {
          question: "Is a partnership deed necessary for registration?",
          answer:
            "While an oral agreement is valid, a written Partnership Deed is essential for practical purposes. It is required by banks and tax authorities and serves as a crucial reference document to prevent future conflicts among partners.",
        },
        {
          question: "Who can be partners in a firm?",
          answer:
            "Partners must be adults (above 18), of sound mind, and not disqualified by any law from entering into a contract.",
        },
        {
          question:
            "How can a minor become a partner after attaining majority?",
          answer:
            "A minor who was admitted to the benefits of a partnership has six months after turning 18 to give a public notice of whether they choose to become a full partner. If no notice is given, they are automatically deemed to have become a partner.",
        },
        {
          question: "What are the limitations of a partner's authority?",
          answer:
            "A partner cannot perform certain actions without the consent of all other partners, such as submitting a business dispute to arbitration, opening a bank account in their own name on behalf of the firm, acquiring or transferring firm property, or entering into a separate partnership on behalf of the firm.",
        },
        {
          question: "Can a partner's rights be transferred to an outsider?",
          answer:
            "Yes, a partner can transfer their interest in the business to an outsider, but only with the consent of all other existing partners.",
        },
      ],
    },
  },
  "gst-registration": {
    title: "GST Registration",
    hero: {
      title: "GST Registration Services",
      description:
        "Get your business registered for GST with our expert assistance and ensure compliance with Indian tax regulations. GST registration is essential for businesses to avail input tax credits and conduct interstate trade seamlessly.",
      advantages: [
        "Claim Input Tax Credit (ITC)",
        "Make interstate sales without restrictions",
        "Register on e-commerce websites",
        "Enhances business credibility",
        "Simplified and unified tax compliance",
      ],
      eligibleCriteria: [
        "Turnover exceeding ₹40 lakhs for Goods",
        "Turnover exceeding ₹20 lakhs for Services",
        "Engaged in Inter-State Sales",
        "Non-Resident Taxable Persons",
        "Businesses selling on E-commerce platforms",
      ],
    },
    content: {
      overviews: [
        {
          title: "Overview of Goods and Services Tax (GST)",
          description:
            "Goods and Services Tax (GST) is a comprehensive, multi-stage, destination-based tax levied on every value addition. It applies to both tangible goods and intangible services, maintaining a balance of revenue for both the Central and State Governments through a dual GST mechanism. The GST regime, which commenced on July 1, 2017, operates on the 'One Nation, One Tax' theme, aiming to enhance transparency, reduce inflation, and eliminate the cascading effect of taxes.<br/><br/>It is mandatory for businesses involved in buying or selling goods or providing services to register under the GST Act. Entities operating without GST registration cannot collect GST from customers or claim Input Tax Credit (ITC) on their purchases. Therefore, to legally collect GST and claim ITC, registration is compulsory.",
        },
        {
          title: "GST Turnover Limit for Registration",
          description:
            "GST registration is mandatory for certain categories of persons, such as casual taxable persons, non-resident taxable persons, and those making supplies through e-commerce operators, irrespective of their turnover. A 'casual taxable person' is one who occasionally undertakes transactions involving the supply of goods or services in a state where they have no fixed place of business.<br/><br/>For other businesses, the turnover limits are as follows:<br/><br/><b>For Goods Suppliers:</b><br/>Registration is mandatory for any person exclusively supplying goods whose aggregate turnover exceeds ₹40 lakhs in a financial year, provided they meet the following conditions:<ul><li>They are not engaged in supplying any services.</li><li>They are not making intra-state supplies in the special category states (Arunachal Pradesh, Manipur, Meghalaya, Mizoram, Nagaland, Puducherry, Sikkim, Telangana, Tripura, and Uttarakhand).</li><li>They are not involved in the supply of pan masala, tobacco, or ice cream.</li></ul>If these conditions are not met, the turnover limit for mandatory registration reduces to ₹20 lakhs (or ₹10 lakhs for special category states).<br/><br/><b>For Service Providers:</b><br/>The turnover limit for service providers remains ₹20 lakhs (or ₹10 lakhs for special category states).",
        },
        {
          title: "Explanation of Aggregate Turnover under GST",
          description:
            "Aggregate Turnover is calculated on an all-India basis for a single PAN. It is the sum of (Taxable Supplies + Exempt Supplies + Exports + Inter-State Supplies) minus (Taxes + Value of Inward Supplies + Value of Supplies Taxable under Reverse Charge). All businesses under the same PAN must be included to calculate the aggregate turnover.",
        },
        {
          title: "Voluntary Registration under GST",
          description:
            "Any business can opt for voluntary GST registration, even if their turnover is below the threshold limit. Many businesses choose this option for several reasons:",
          content: [
            {
              type: "h4",
              text: "Reasons for Voluntary Registration",
              bullets: [
                "To improve the credibility and professional image of the business.",
                "To satisfy the requirements of B2B customers who may only want to deal with GST-registered vendors.",
                "To claim the benefits of Input Tax Credit (ITC) on purchases, which reduces costs.",
              ],
            },
          ],
        },
        {
          title: "Documents Required for GST Registration",
          description:
            "The following documents are required to apply for GST registration:",
          content: [
            {
              type: "h4",
              text: "List of Required Documents",
              bullets: [
                "<b>PAN Card of the Business or Applicant:</b> GST Registration is linked to the PAN, making it a mandatory document.",
                "<b>Identity and Address Proof with Photographs:</b> Identity proofs (Passport, Voter ID, PAN, Aadhaar, Driving License) and address proofs are required for the individuals associated with the business. This includes:<ul><li><b>Company:</b> Managing Director, Directors, and Authorized Person.</li><li><b>HUF:</b> Karta.</li><li><b>Proprietorship:</b> Proprietor.</li><li><b>Partnership Firm / LLP:</b> Managing, Authorized, or Designated Partners (personal details of all partners and photos of up to 10 partners are required).</li><li><b>Trust:</b> Managing Trustee, Trustees, and Authorized Person.</li></ul>",
                "<b>Business Registration Document:</b> Proof of business registration, such as a Partnership Deed or Certificate of Incorporation (not required for proprietorships).",
                "<b>Address Proof for Place of Business:</b> For the principal and any additional places of business. This can include:<ul><li><b>Owned Premises:</b> Latest Property Tax Receipt, Municipal Khata copy, or a recent Electricity Bill.</li><li><b>Rented or Leased Premises:</b> A valid rental agreement along with an ownership proof document (like a property tax receipt or electricity bill) from the lessor.</li><li><b>Other Cases (e.g., Consent):</b> A copy of a consent letter from the property owner along with their proof of ownership.</li></ul>",
                "<b>Proof of Bank Account:</b> A scanned copy of the first page of the bank passbook, a recent bank statement, or a cancelled cheque showing the name of the proprietor/business, account number, and IFSC code.",
              ],
            },
          ],
        },
      ],
      features: [
        "Claim input tax credit on purchases",
        "Conduct interstate trade without restrictions",
        "Become eligible to sell on e-commerce platforms",
        "Improve business credibility and brand image",
        "Ensure legal compliance and avoid penalties",
      ],
      tables: [
        {
          title: "GST Registration Threshold Limits",
          headers: [
            "Aggregate Turnover",
            "Registration Mandatory",
            "Applicability",
          ],
          rows: [
            [
              "<b>Initial Threshold – For the supply of Goods or Services</b>",
              "",
              "",
            ],
            [
              "More than ₹20 lakh",
              "Yes – For Normal Category States",
              "Till March 31, 2019",
            ],
            [
              "More than ₹10 lakh",
              "Yes – For Special Category States",
              "Till March 31, 2019",
            ],
            ["<b>New Limits – For Sale of Goods</b>", "", ""],
            [
              "More than ₹40 lakh",
              "Yes – For Normal Category States",
              "From April 1, 2019",
            ],
            [
              "More than ₹20 lakh",
              "Yes – For Special Category States",
              "From April 1, 2019",
            ],
            ["<b>New Limits – For Providing Services</b>", "", ""],
            [
              "The threshold limits for Service Providers have remained unchanged.",
              "",
              "",
            ],
          ],
        },
      ],
      faq: [
        {
          question: "What is the time limit for applying for GST Registration?",
          answer:
            "An application for GST Registration must be submitted within 30 days from the date a business becomes liable for registration (i.e., when its turnover exceeds the prescribed limit).",
        },
        {
          question:
            "Can GST registration be taken using a residential address?",
          answer:
            "Yes, you can register for GST using a residential address as your place of business. There is no requirement to have a commercial address.",
        },
        {
          question:
            "Can Input Tax Credit be claimed on goods used partly for business?",
          answer:
            "Yes, if goods or services are used partly for business and partly for other purposes, ITC can be claimed on the portion that is used for business purposes.",
        },
        {
          question:
            "Is it necessary to file a NIL GST return if there are no transactions?",
          answer:
            "Yes, every entity registered under GST must file GST returns for every tax period, even if there were no transactions. In such cases, a NIL return must be filed.",
        },
        {
          question: "Is a PAN Card mandatory for obtaining GST Registration?",
          answer:
            "Yes, a PAN card is a mandatory document required for obtaining GST registration for all applicants except for non-resident taxable persons.",
        },
      ],
    },
  },
  "fssai-food-license-registrations": {
    title: "FSSAI Food License Registration",
    hero: {
      title: "Food License Registration",
      description:
        "Obtain your FSSAI Food License to ensure your food business complies with the Food Safety and Standards Act, 2006, guaranteeing food safety and building consumer trust.",
      advantages: [
        "Builds consumer awareness and trust",
        "Grants legal right to use the FSSAI Logo",
        "Ensures adherence to food safety standards",
        "Provides a competitive marketing advantage",
        "Facilitates business expansion and funding",
      ],
      eligibleCriteria: [
        "Basic FSSAI Registration (Turnover < ₹12 Lakhs)",
        "FSSAI State License (Turnover between ₹12 Lakhs & ₹20 Crore)",
        "FSSAI Central License (Turnover > ₹20 Crore / Importer-Exporter)",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction to FSSAI",
          description:
            "The Food Safety and Standards Authority of India (FSSAI) was formed under the Food Safety and Standards Act, 2006, with two major objectives viz.<ul><li>To consolidate different acts & laws that is associated with the orderly management of food-related issues under various Departments and Ministries.</li><li>To lay down a science-based benchmark for the food production, storage, distribution, import and sale to ensure that the food is safe and healthy for human consumption or other uses connected with it or similar thereto.</li></ul><br>As a single reference body, FSSAI reports to the Ministry of Health & Family Welfare, Government of India. It is mandatory for all food business operators (FBOs) to comply with the FSS Act, 2006, and obtain the necessary registration or license.",
        },
        {
          title: "Who Needs an FSSAI Registration Certificate?",
          description:
            "An FSSAI Registration or License is imperative for the below-mentioned categories if their yearly turnover is above ₹12 Lakhs.",
          content: [
            {
              type: "h4",
              text: "General Categories",
              bullets: [
                "Food Business Operators (FBO) who themselves produce or sell any food article",
                "Food retailer, itinerant vendor or hawker",
                "Temporary/Permanent food stallholder",
                "Large or medium scale industries that are engaged in the food business",
                "Food business operator with annual turnover more than 12 Lakhs",
              ],
            },
            {
              type: "h4",
              text: "Based on Production & Procurement Capacity",
              bullets: [
                "When the per day production capacity of food products is above 100 kg or litres",
                "When the per day procurement or handling and collection of milk is above 500 l of milk",
                "When the per day slaughtering capacity is more than 2 large animals/10 small animals/50 poultry birds.",
              ],
            },
          ],
        },
        {
          title: "Benefits of Food License Registration",
          description:
            "After the successful food license registration, a 14-digit registration number is allotted by the concerned government department. This number is often printed on food products. Getting a food license or FSSAI registration not only increases adherence to government rules & regulations but also draws consumers' trust in the food brand. Other benefits are:",
          content: [
            {
              type: "h4",
              text: "Key Advantages",
              bullets: [
                "<b>Awareness among Consumers:</b><br/>Today, consumers have become vigilant about what they are eating. An FSSAI registration sprouts a trust factor in the minds of consumers and hence expands your client base.",
                "<b>Brand image and Marketing advantage:</b><br/>An FSSAI number gives your product a Brand Image and thus markets the superior quality of your food over others. In this way, you get an edge over other food operators who are unregistered. An FSSAI number confirms the validity of the food and so gives assurance to the consumers.",
                "<b>Expansion of Business:</b><br/>An FSSAI license lets you easily expand your business by establishing a reputation in the market. Renowned brands easily get loans from banks to fulfill the additional need for funds required for business expansion.",
                "<b>Legal Advantage:</b><br/>An FSSAI license obstructs the fraudulent use of your name & brand while saving you from the penalties to be paid for non-adherence to government laws.",
              ],
            },
          ],
        },
        {
          title: "Types of FSSAI Registration/License",
          description:
            "Legal registration is required by all medium and large food-related firms. The type of license depends on the nature and scale of the business.",
          content: [
            {
              type: "h4",
              text: "License Categories",
              bullets: [
                "<b>FSSAI BASIC REGISTRATION (for annual turnover < ₹12L):</b><br/>This is required by all small businesses with an annual turnover of less than 12 lakhs. It is suitable for beginners or small-sized businesses.",
                "<b>FSSAI STATE LICENSE REGISTRATION (for annual turnover between ₹12L & ₹20Cr.):</b><br/>This is required by all medium-sized businesses with an annual turnover of more than 12 lakhs but less than 20 Crore.",
                "<b>FSSAI CENTRAL LICENSE REGISTRATION (for annual turnover > ₹20Cr.):</b><br/>This is required for large-scale businesses with a turnover of more than 20 Crore, or for those who want to start an import/export business or supply to government departments.",
              ],
            },
          ],
        },
        {
          title: "Eligibility for an FSSAI Central License",
          content: [
            {
              type: "h4",
              text: "Manufacturer",
              bullets: [
                "<b>Dairy units</b> including milk chilling units equipped for handling/processing - Above 50,000 l of liquid milk/day or 2500 MT of milk solid per annum",
                "<b>Vegetable oil processing units</b> and units for vegetable oil production via solvent extract process and refineries including oil expeller unit- Above 2 MT per day",
                "<b>Slaughtering units</b> - Large Animals above 50/day, Small Animals above 150/day or Poultry Birds above 1000/day.",
                "<b>Meat Processing units</b> - Above 500 kg of meat per day/150 MT per annum",
                "<b>All food processing units</b> including relabellers & repackers - Above 2 MT/day other than cereals, pulses & grains milling units",
                "<b>Proprietary foods</b> - All (Regardless of limit)",
                "<b>100% Export Oriented units</b>- All (Regardless of limit)",
              ],
            },
            {
              type: "h4",
              text: "Importers",
              bullets: [
                "All Importers, regardless of units, who are importing food items inclusive of additives and food ingredients for Business use.",
              ],
            },
            {
              type: "h4",
              text: "Other Businesses",
              bullets: [
                "<b>Storage (Other than Controlled Atmosphere and Cold)</b> - Capacity > 50,000 MT",
                "<b>Storage (Cold / Refrigerated)</b> - Capacity > 1,000 MT",
                "<b>Storage (Controlled Atmosphere + Cold)</b> - Capacity > 1,000 MT",
                "<b>Wholesaler</b> - Turnover > 30 crores",
                "<b>Retailer</b> - Turnover > 20 crores",
                "<b>Distributor</b> - Turnover > 20 crores",
                "<b>Supplier</b> - Turnover > 20 crores",
                "<b>Caterer</b> - Turnover > 20 crores",
                "<b>Hotel</b> - Five star & above",
                "<b>Restaurant</b> - Turnover > 20 crores",
                "<b>Transporter</b> - Turnover > 30 crores or Having> 100 vehicle/wagon",
                "<b>Marketer</b> - Turnover > 20 crores",
              ],
            },
            {
              type: "h4",
              text: "Premises in Central Govt. & Major Ports/Airports",
              bullets: [
                "<b>Food Catering services</b> in organisations or units under Central Government Agencies such as Defence, Military.",
                "<b>Storage, Retailer, Wholesaler, Distributor</b> having establishments in Central Government Agencies.",
                "FBOs operating at major airports and seaports.",
              ],
            },
          ],
          description_after_table:
            "<b>Note:</b> A Food Business Operator (FBO) with premises in two or more States must obtain a Central License for its Head Office/Registered Office and a separate license/registration for each unit.",
        },
        {
          title: "Eligibility Criteria for FSSAI State License",
          content: [
            {
              type: "h4",
              text: "Manufacturer",
              bullets: [
                "<b>Dairy units</b> including milk chilling units - 501 to 50,000 LPD of milk Or above 2.5 MT to 2500 MT of milk solids/annum",
                "<b>Vegetable oil processing units</b> - Up to 2 MT/day and turnover > 12 lakh",
                "<b>Slaughtering units</b> - Large Animal > 2 but ≤ 50, Small Animal > 10 but ≤ 150, Poultry Birds > 50 but ≤ 1000/ day",
                "<b>Meat processing units</b> - Up to 500 kg meat/day Or 150 MT/annum",
                "<b>All food processing units</b> including relabellers & repackers - Above 100 kg/ltr to 2 MT/day. All cereals, pulses & grains milling units",
              ],
            },
            {
              type: "h4",
              text: "Other Businesses",
              bullets: [
                "<b>Storage (Other than Controlled Atmosphere and Cold)</b> - Capacity up to 50,000 MT",
                "<b>Storage (Cold / Refrigerated)</b> - Capacity up to 10,000 MT",
                "<b>Storage (Controlled Atmosphere + Cold)</b> - Capacity up to 1,000 MT",
                "<b>Wholesaler</b> - Turnover ≤ 30 crores",
                "<b>Retailer, Distributor, Supplier, Caterer, Restaurant, Marketer</b> - Turnover ≤ 20 crores",
                "<b>Hotel</b> - Three star & above and below Five star OR Up to Three star and Turnover > 12 lakhs",
                "<b>Transporter</b> - Having up to 100 vehicles/ wagons Or turnover ≤ 30 crores",
                "<b>Dhaba, Boarding houses, Canteens, Dabbawalas, Banquet halls, Food stalls etc.</b> - Turnover > 12 lakhs/annum",
              ],
            },
          ],
        },
        {
          title: "Documents for FSSAI Registration",
          description:
            "The FSSAI licence application process requires the submission of the following key documents:",
          content: [
            {
              type: "h4",
              text: "Document Checklist",
              bullets: [
                "Rental Agreement or Proof of Business Premises.",
                "Proof of Business Entity (e.g., Partnership Deed, Certificate of Incorporation).",
                "A detailed list of food products to be dealt with.",
                "Photo ID and Address Proof of the proprietor, partners, or directors.",
              ],
            },
          ],
        },
        {
          title: "FSSAI Registration Process",
          description:
            "The process for food license registration is divided into four simple steps:",
          content: [
            {
              type: "process",
              title: "Registration Steps",
              steps: [
                {
                  step: 1,
                  title: "Filling of Application Form",
                  description:
                    "The first step is filing an application in Form A with the food and safety department.",
                },
                {
                  step: 2,
                  title: "Application Review",
                  description:
                    "The department will review the application and may accept or reject it within 7 days. Any queries or rejections are communicated to the applicant.",
                },
                {
                  step: 3,
                  title: "Allotment of Registration Certificate",
                  description:
                    "Upon acceptance, the Department allots a Certificate of Registration which contains the registration number and a photo of the applicant.",
                },
                {
                  step: 4,
                  title: "Display of Registration Certificate",
                  description:
                    "The FBO must display the Certificate of Registration at their place of business during business hours.",
                },
              ],
            },
          ],
        },
        {
          title: "Noteworthy Points about FSSAI Registration/License",
          content: [
            {
              type: "h4",
              text: "Key Regulatory Framework",
              bullets: [
                "Section 31(1) and Section 31(2) of the FSS Act, 2006 are the governing sections for registration under the FSS Act 2006.",
                "Food Safety and Standards (Licensing & Registration of a food business) Regulations, 2011 serves as the regulatory body for the license & registration process.",
                "FSSAI has launched an Online Food Licensing & Registration system (FLRS) to bolster FBOs in India.",
                "Schedule 4 of the FSS (Licensing & Registration of Food Businesses) Regulations, 2011 acts as inspection criteria to ensure the Sanitary and Hygienic Requirements as prescribed.",
              ],
            },
          ],
        },
      ],
      features: [
        "Builds consumer awareness and trust",
        "Provides the legal right to use the FSSAI logo",
        "Ensures compliance with food safety standards",
        "Enhances brand image and provides a marketing advantage",
        "Facilitates business expansion and access to loans",
        "Offers legal advantages and protection against penalties",
      ],
      tables: [],
      faq: [
        {
          question:
            "I have manufacturing units in various states. Will I be required to get a common license for all of them or an individual license for each unit?",
          answer:
            "You will be required to get a Central License for the Registered Office of the company and an individual state license for each manufacturing unit in a particular state.",
        },
        {
          question: "How much time is required to obtain a food license?",
          answer:
            "It may take up to 30-60 days from the date of making an application with the Food Safety and Standards Authority of India to obtain a Food License.",
        },
        {
          question: "What is the License fee charged under FSSAI?",
          answer:
            "Yes, there is a License fee under FSSAI which is charged on an annual basis. An applicant can make an application for a period from 1-5 years. The fee for the State License is ₹2,000/- p.a. whereas the fee for an application for Central License is ₹7,500/-p.a.",
        },
        {
          question:
            "What is the validity period of the FSSAI License and how to renew the same?",
          answer:
            "The FSSAI License is valid for the period for which it is originally issued unless it is cancelled by the FSSAI department. It can be renewed for a maximum period of five years. The renewal application must be filed within 30 days from the date of expiry. If the license/registration is expired, the FBO has to apply afresh.",
        },
        {
          question:
            "Do I need an FSSAI License if I am importing food items for sale in India or for a 100% export unit?",
          answer:
            "Yes, a central license will be required from the address contained in your Import Export Code. For both import and 100% export units, an FSSAI central license is mandatory.",
        },
        {
          question:
            "What are the formalities for licenses if the warehouses are located at more than one place but within the same city?",
          answer:
            "Even if the warehouses are situated in the same city but at different locations, a separate license is required for each location. However, if multiple warehouses are on the same campus or premises, a single license is applicable with the campus address.",
        },
        {
          question:
            "Do pharmacies and medical stores need to apply for an FSSAI license if they are dealing in Health supplements or Nutraceutical products?",
          answer:
            "Yes, all Food business operators, be it pharmacies or medical stores dealing in Health supplements or Nutraceutical products, need to apply for the FSSAI license or registration.",
        },
        {
          question:
            "What is the fee charged for filing an application for modification of an FSSAI license?",
          answer:
            "For any change in the information contained in the License or the registration certificate (Form C), a fee equivalent to the fee of a one-year new license or registration is charged. No fee shall be required for modification of non–Form C details.",
        },
      ],
    },
  },
  "import-export-code-(iec)": {
    title: "Import Export Code Registration",
    hero: {
      title: "Import/ Export Code (IEC)",
      description:
        "An IMPORT EXPORT CODE or IEC is a 10-digit identification number issued by the Directorate General of Foreign Trade (DGFT), required for any entity or individual looking to engage in the import or export of goods and services from India.",
      advantages: [
        "Global Market Reach",
        "Life Time Validity",
        "No Annual Maintenance",
        "Reduces the risk of Illegal transportation",
        "No Compliance or Return Filing",
      ],
      eligibleCriteria: [
        "Required to clear shipments from customs",
        "Mandatory for receiving money from foreign currency",
        "Necessary for importers to send money abroad",
        "Essential for both goods and services",
        "A prerequisite for availing government export schemes",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction to Import Export Code (IEC)",
          description:
            "IMPORT EXPORT CODE or IEC refers to a 10-digit identification number that is issued by the Directorate General of Foreign Trade (DGFT), Ministry of Commerce and Industries, Government of India to the applicant who is involved in any kind of import or export of goods or services from India.<br/><br/><b>Is IE Code imperative? Who needs it?</b><br/>Yes, an IE Code is imperative for importers and exporters in India. Individuals or business organisations who are engaged in importing or exporting goods and services from India need an IEC. Individuals who are proprietors of a business can obtain an IE Code in their name.",
        },
        {
          title: "Validity of Import Export Code",
          description:
            "IEC is valid to be used by the entity throughout its existence and does not require any renewal or filing. The validity of an IEC issued is the same for all the branches or factories that an importer/exporter owns. Therefore, it is recommended for most organizations to obtain the IE Code, irrespective of whether they need it at the moment or not.",
        },
        {
          title: "What is the purpose of IEC?",
          description:
            "All exporters who are engaged in the export of goods or services from India need an import-export code registration to quote during the shipments of goods or services.<br/><br/>An IE Code can be used by that entity for all its import or export transactions without any further hassles. Without the IEC, you cannot participate in the international market.<br/><br/>The banks also need the IE Code of the exporters for receiving payments from abroad.",
        },
        {
          title: "Application for IEC",
          description:
            "Application for IEC is an application that is submitted by the respective Importer/Exporter to the Directorate General of Foreign Trade along with the relevant supporting documents, to obtain the 10-digit identification code.<br/><br/>Upon the application submission, DGFT issues an IEC to the entity in the period of 1-2 working days.",
        },
        {
          title: "Details and Documents Required to Apply for IEC",
          content: [
            {
              type: "h4",
              text: "Document Checklist",
              bullets: [
                "Copy of Entity’s PAN Card",
                "Business Address Proof",
                "Photograph and KYC of Directors or Partners or Proprietor",
                "Valid Indian Mobile no. of Director or Partners or Proprietor",
                "Charter documents of Entities",
                "Letter of Authorized Signatory/Board Resolution",
                "Director or Partners or Proprietor e-mail ID",
                "Cancelled Cheque or Pass Book or Bank Statement",
              ],
            },
          ],
          description_after_table:
            "You can also avail IE registration services for the import-export code registration to save your time. In such a case, you just need to share the above-mentioned documents & details, either physically or online by using the scanned copies of the same, and the rest of the job is carried by the respective service provider.",
        },
        {
          title: "IEC Registration Process",
          description:
            "Import Export Code (IEC) Registration is an online process which can be divided into simple steps as mentioned below:",
          content: [
            {
              type: "process",
              title: "Step-by-Step IEC Application",
              steps: [
                {
                  step: 1,
                  title: "Navigate to the DGFT Website",
                  description:
                    "Go to the official website of the Directorate General of Foreign Trade (DGFT).",
                },
                {
                  step: 2,
                  title: "Select Online Application",
                  description:
                    "Go to the 'Services' tab, click on 'IEC', and then select 'Online IEC Application'.",
                },
                {
                  step: 3,
                  title: "Enter PAN",
                  description: "Enter your Permanent Account Number (PAN).",
                },
                {
                  step: 4,
                  title: "Verify PAN",
                  description:
                    "You will be directed to the next page where you will need to re-enter your PAN and click the 'Search' button.",
                },
                {
                  step: 5,
                  title: "Enter PAN Verification Details",
                  description:
                    "Enter details for PAN verification which include:<ul><li>Name (as per PAN)</li><li>Date of Birth/Incorporation</li><li>Captcha Code</li></ul>",
                },
                {
                  step: 6,
                  title: "Submit for Verification",
                  description:
                    "Click on 'Submit' after entering the details. Any incorrect detail will lead to authentication failure.",
                },
                {
                  step: 7,
                  title: "Proceed after Verification",
                  description:
                    "If the details are valid, a message stating 'your PAN has been verified' will be displayed. Click on 'Proceed'.",
                },
                {
                  step: 8,
                  title: "Login for New Application",
                  description:
                    "For a new IEC application, provide your email address and mobile number.",
                },
                {
                  step: 9,
                  title: "Generate OTP",
                  description:
                    "Enter the Captcha code and click on 'Generate OTP'. An OTP will be sent to the provided email and mobile number.",
                },
                {
                  step: 10,
                  title: "Submit OTP",
                  description:
                    "Enter the received OTPs and click 'Submit'. If you haven't received an OTP, you can use the 'Regenerate OTP' option.",
                },
                {
                  step: 11,
                  title: "Fill Application Details",
                  description:
                    "After OTP submission, a 20-digit E-commerce number will be displayed. You are required to enter the following details:<ul><li>Entity Name & Address</li><li>City, State, District, PIN code</li><li>Nature of Concern (Proprietorship, LLP, Private Limited, etc.)</li><li>Preferred activities (Manufacturer Exporter, Merchant Exporter, Service provider, etc.)</li><li>Bank account details</li><li>Applicant details</li></ul>",
                },
                {
                  step: 12,
                  title: "Update and Save",
                  description:
                    "After entering all details, click on 'Update and Save'.",
                },
                {
                  step: 13,
                  title: "Enter Bank Details",
                  description:
                    "You will be redirected to a new page to fill in the bank branch details.",
                },
                {
                  step: 14,
                  title: "Add Director/Partner Details",
                  description:
                    "Update the details of the Director/Proprietor/Partner/Karta/Managing Trustee, including DIN (if applicable), Name, PAN, DOB, Address, and Aadhaar number.",
                },
                {
                  step: 15,
                  title: "Upload Documents",
                  description:
                    "Click 'ADD' and upload the required documents, such as address proof and a cancelled cheque or bank certificate. The documents must be in GIF or PDF format and not exceed 5MB.",
                },
                {
                  step: 16,
                  title: "Acceptable Address Proofs",
                  description:
                    "Acceptable documents for address proof include: Sale Deed, Rent Agreement, Lease Deed, Mobile Postpaid bill, MOU, Electricity Bill, Telephone Landline bill, or Partnership Deed. For proprietorships, a Passport, Voter ID, or Aadhaar Card are also acceptable.",
                },
                {
                  step: 17,
                  title: "NOC Requirement",
                  description:
                    "If the applicant's name isn’t on the address proof, a No-Objection Certificate (NOC) from the property owner must be submitted in PDF format along with the address proof.",
                },
                {
                  step: 18,
                  title: "Fee Payment",
                  description:
                    "Proceed to pay the required government fee for the application.",
                },
                {
                  step: 19,
                  title: "Preview Application",
                  description:
                    "Thoroughly verify all the details filled in the application form and then click on 'Print Application'.",
                },
                {
                  step: 20,
                  title: "Final Submission",
                  description:
                    "Click on 'Submit' for the final submission of the application. This can be done with or without a Digital Signature.",
                },
              ],
            },
          ],
        },
        {
          title: "Government Fee for IEC Registration",
          description:
            "The government charges an Import Export code registration fee of Rs. 500.00 and it is payable via EFT (Electronic Fund Transfer) during the online submission of the IEC Application form.<br/><br/>Upon the successful submission, the IEC allotment letter with a 10-digit code is dispatched to the address of the applicant via a self-addressed envelope.<br/><br/>After receiving an IEC code, you become eligible to start your importing and exporting businesses.",
        },
      ],
      features: [
        "Enables access to the global market",
        "Offers lifetime validity with no need for renewal",
        "Requires no annual maintenance fees",
        "Helps reduce the risk of illegal transportation",
        "Involves no mandatory compliance or return filing",
      ],
      tables: [],
      faq: [
        {
          question: "Is IEC only required for Goods?",
          answer:
            "It is presumed that IEC is only required for the import or export of goods. But in reality, it is necessary for both goods and services. As the import or export of services is an international transaction, any person providing services beyond the boundaries of India has to get an IEC.",
        },
        {
          question: "Is there a separate code for Import and Export?",
          answer:
            "One IEC can be used for both import and export. Many people have the wrong idea that a separate IEC is required for Import and Export, but this is not the case. There is only one registration for both activities.",
        },
        {
          question: "What is the renewal or return process under IEC?",
          answer:
            "It is a one-time registration and has a lifetime validity; there is no need to renew it. The IEC is used at the time of importing or exporting or paying or receiving payments. There are no returns to be filed for the IEC as no post-registration compliances exist.",
        },
        {
          question:
            "In what way is the registration number allotted for an IEC number?",
          answer:
            "Earlier, the department used to issue a separate number for the IEC code. But recently, the Ministry initiated a revision due to which the PAN of the applicant will be the registration number of the IEC. Hence the PAN and the IEC number will be the same. The Ministry will register the IEC for the applicant and issue the approval letter immediately after notifying the PAN as their IEC number.",
        },
        {
          question:
            "Is IEC required for the import or export of goods for the personal use of a person?",
          answer:
            "IEC is made compulsory only for business and commercial purposes. There is no such requirement for IEC to import or export goods for personal use.",
        },
        {
          question: "Is a different IEC required for each firm?",
          answer:
            "Not every enterprise has to apply for a separate IEC. As IEC is linked with PAN, if a person has more than one proprietorship firm, only one IEC registration is taken because the PAN of an individual is used for their proprietorship firms. In case of a partnership firm, LLP, or a Company, a separate PAN is allotted to them, hence they will need to get their own IEC.",
        },
        {
          question: "Are government departments required to have an IEC?",
          answer:
            "The State government or the Central government departments do not require to take IEC registration as they are allotted a fixed number which is quoted for any such transactions pertaining to the import or export of goods or services.",
        },
        {
          question:
            "Is IEC registration required if you have a GST registration?",
          answer:
            "Yes. Every person who is importing or exporting Goods or services has to take IEC registration. It is mandatory to register the PAN of the applicant with the DGFT department if the business involves imports or exports, even if you are registered under GST.",
        },
      ],
    },
  },
  "rera-registrations": {
    title: "RERA Registration",
    hero: {
      title: "RERA Registration in India",
      description:
        "The Real Estate (Regulation and Development) Act, 2016 (RERA) was implemented to regulate India's real estate sector, making it mandatory for builders and promoters to register their projects to ensure transparency and protect the interests of buyers.",
      advantages: [
        "Standardized Carpet Area Calculation",
        "Full Right to Information for Buyers",
        "Prevention of Project Delays",
        "Quick Grievance Redressal Mechanism",
        "Builder Accountability for Defaults",
      ],
      eligibleCriteria: [
        "Projects on land over 500 sq. meters",
        "Projects with more than 8 apartments",
        "All agents engaged in selling/purchasing properties",
        "Ongoing projects without a Completion Certificate",
        "All commercial and residential projects meeting criteria",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction to RERA",
          description:
            "The Real Estate Regulatory and Development Act (RERA) was implemented on 1st May 2017, to regulate the real estate sector of India. RERA, 2017 has shaped the total regulation of the activities of the builders and has also empowered the buyers regarding the real estate regulations.<br/><br/>Under the Real Estate Regulatory Act, 2016, every builder & promoter has to mandatorily register their real estate projects under RERA to purchase, sell, advertise, market or book.<br/><br/>RERA Registration ensures the effective and transparent regulation of the contract between the purchaser and seller of the plot, apartment, or building. Furthermore, it aims to ascertain the higher responsibility towards the clients and lessen up the delays, fraudulent acts & high transaction costs.",
          content: [
            {
              type: "h4",
              text: "Following are the salient features of RERA:",
              bullets: [
                "More security to first time home buyers upon the investment made them",
                "Better assurance of timely possession",
                "More strict actions against any fraud or false promise",
                "Digitization of all records, to reduce the loss of data",
                "Quick remedies for any dispute",
              ],
            },
          ],
        },
        {
          title: "Who Needs to Apply for RERA Registration?",
          description:
            "RERA Registration is applicable to all the Real Estate Agents, Promoters and Projects contingent upon the below-mentioned criteria:",
          content: [
            {
              type: "h4",
              text: "Applicability Criteria",
              bullets: [
                "All commercial as well as residential real estates including the plotted development",
                "Every commercial, as well as the residential project that surpasses the limit of 500 square meters or have more than 8 units or apartments",
                "All the local promoters having small projects",
                "All the on-going projects which do not have any Completion Certificate (must apply within 3 months)",
              ],
            },
          ],
        },
        {
          title: "Documents Required For RERA Registration",
          description:
            "A RERA application must be affixed with a set of following documents:",
          content: [
            {
              type: "h4",
              text: "Document Checklist",
              bullets: [
                "Builder’s/Real Estate Agent’s PAN Card.",
                "Apartment’s description like a total number of floors, measurement of carpet area, parking space and so on.",
                "Builder’s declaration and evidence that certifies his/her legal possession over the land.",
                "Builder’s balance sheet and ITR of the preceding 3 years.",
                "Property’s detailed information such as title, rights or mortgage.",
                "Project’s crucial details like location, sanctioned plan, layout plan, etc.",
                "Ownership documents such as allotment letter, sale agreement.",
                "Details about other parties who are involved like Engineers, Architects, etc.",
                "Consent letter of the owner along with supporting documents (when the builder is not the owner of the land).",
              ],
            },
          ],
        },
        {
          title:
            "Procedure For Registration Of Project/Agent Under RERA Act, 2016",
          content: [
            {
              type: "h4",
              text: "Procedure For Registration Of Project:",
            },
            {
              type: "process",
              title: "Project Registration Steps",
              steps: [
                {
                  step: 1,
                  title: "Creation of user ID",
                  description:
                    "Registration of the project starts with the creation of the user id by the promoter on the respective state's RERA web portal.",
                },
                {
                  step: 2,
                  title: "Profile creation and Documents upload",
                  description:
                    "In the next step, a promoter profile is created and project details (documents, maps, etc.) are uploaded by the applicant.",
                },
                {
                  step: 3,
                  title: "Submission of online application & fee payment",
                  description:
                    "The online application for registration is submitted after the prescribed fee is paid online.",
                },
                {
                  step: 4,
                  title: "Issuance of Registration No.",
                  description:
                    "As prescribed under Section 5 of The Real Estate (Regulation and Development) Act, 2016, The Authority grants the registration no. within a period of thirty days from the date of submitting the completed online application. The registration no. is conveyed to the applicant by e-mail and SMS.",
                },
                {
                  step: 5,
                  title: "Submission of hard copy of the online application",
                  description:
                    "A hard copy of the online application along with promoter and project-related documents is submitted to the office of the state's Registrar of RERA.",
                },
                {
                  step: 6,
                  title: "Issuance of the certificate of registration",
                  description:
                    "After submission of the hard copy, the certificate of registration is issued by the authoritative official to the applicant.",
                },
              ],
            },
            {
              type: "h4",
              text: "Procedure For Registration Of Agent:",
            },
            {
              type: "process",
              title: "Agent Registration Steps",
              steps: [
                {
                  step: 1,
                  title: "Creation of user ID",
                  description:
                    "Registration of the agent starts with the creation of the user id on the respective state's RERA web portal.",
                },
                {
                  step: 2,
                  title: "Details Upload",
                  description:
                    "After the Agent profile creation, details need to be uploaded by the applicant.",
                },
                {
                  step: 3,
                  title: "Online submission of application with fee",
                  description:
                    "The application needs to be submitted online for registration along with the prescribed registration fee which must be paid via online mode.",
                },
                {
                  step: 4,
                  title: "Issuance of Registration Number",
                  description:
                    "The Authority issues the registration no. within a period of thirty days from the date of submitting the completed online application. The Registration no. is conveyed to the applicant by e-mail and SMS.",
                },
                {
                  step: 5,
                  title: "Submission of hard copy of the online application",
                  description:
                    "A hard copy of the online application along with agent and related documents is submitted to the office of the state's Registrar of RERA.",
                },
                {
                  step: 6,
                  title: "Issuance of the certificate of registration",
                  description:
                    "After submission of the hard copy, the certificate of registration is issued by the authoritative official to the applicant.",
                },
              ],
            },
          ],
        },
        {
          title: "RERA Registration Fees for Real Estate Agents",
          description:
            "The fee for RERA registration differs from state to state. However, the estimation for the same is as follows:<ul><li>A registration fee of ₹10,000 applies when the Real Estate Agent is an individual or has a proprietorship firm.</li><li>A registration fee of ₹50,000 applies to other business entities like a Partnership firm, LLP, Private Limited Company, One Person Company, Society, or Public Limited Company.</li></ul><br/><b>Note:</b> The registration fee for RERA registration is payable during application via NEFT, RTGS System or any other similar digital transaction mode.",
        },
        {
          title: "Validity of RERA Registration",
          description:
            "An approved RERA registration has a validity for a period as specified by the Promoter for finishing the real estate project or as specified in the affidavit affixed with the application form. However, the validity may be further extended through an application under some circumstances like Force Majeure such as flood, war, drought, cyclone, earthquake or any other natural calamity that disturbs the normal build out of the real estate project.<br/><br/>It should be noted that the validity can be extended by the concerned authority to a maximum time-span of one year, in case of reasonable circumstances other than force majeure.",
        },
      ],
      features: [],
      tables: [],
      faq: [
        {
          question: "Who is liable to get themselves registered under RERA?",
          answer:
            "Registration under the Real Estate Act, 2016 shall be mandatory for all the commercial and residential real estate projects where the land is over 500 sq m, or eight apartments. Registration with the Real Estate Regulatory Authority (RERA) is done for launching a project and to provide greater transparency in project-marketing and execution.<br/><br/>No promoter is allowed to advertise, market, book, sell or offer for sale for any real estate project in any planning area without registering it first.",
        },
        {
          question: "Does RERA cover rental arrangements?",
          answer: "No, it does not cover rental arrangements.",
        },
        {
          question: "What is the minimum fee applicable for RERA registration?",
          answer:
            "As RERA is applicable state-wise, the minimum fee requirement is decided according to the states. For example, in Rajasthan, the fee for a broker's registration under RERA is ₹10,000 for an individual and ₹50,000 for other entities.",
        },
        {
          question: "How is RERA mandatory for the builders?",
          answer:
            "RERA registration is required for builders, constructors, or developers for the construction of any residential or commercial project where the area of land proposed to be developed exceeds 500 sq m or the number of apartments proposed to be developed exceeds 8, inclusive of all phases.",
        },
        {
          question: "How does RERA benefit buyers?",
          answer:
            "The objective behind RERA is to provide relief to buyers from the malpractices of unfair builders. The RERA, 2016 states certain norms for building and development of real estate which will ultimately enhance the transparency in transactions in the real estate sector.",
        },
        {
          question: "Can a RERA registration be revoked?",
          answer:
            "The Registration under RERA, 2016 can be revoked if any complaint is received against the developer and the authority is satisfied that the developer has not complied with the rules and regulations under the Act, has violated the terms & conditions of the approval, or is involved in unfair practices to sell, market or advertise their projects.",
        },
        {
          question:
            "Are there any exceptions for Registration of a Project under RERA?",
          answer:
            "There are mainly three exceptions for registration under the Act:<ul><li>Where the area of land proposed to be developed does not exceed 500 sq m or the number of apartments proposed to be developed does not exceed eight, inclusive of all phases.</li><li>Where the promoter has received a completion certificate for the Real Estate Project prior to the commencement of the Act.</li><li>For the purpose of renovation, repair, or re-development which does not involve marketing, advertising, selling or new allotment of any apartment, plot or building under the real estate project.</li></ul>",
        },
        {
          question:
            "What is the duration or tenure of validity of RERA Registration?",
          answer:
            "Registration shall be valid for the time period required for completing the project or the phase, as declared by the builder/developer.",
        },
        {
          question:
            "What happens if the builder or the developer fails to deliver during the validity of the period?",
          answer:
            "The validity of the registration is based upon the builder's own estimates. Thus, the accountability lies with them to adhere to the timelines, otherwise, they risk suffering losses/penalties as prescribed.",
        },
        {
          question: "Can registration be extended or revoked?",
          answer:
            "The Registration can only be extended in the case of force majeure events like floods, drought, fire, war, etc. Such extensions, if applied for by the builder, will be for a period of one year.<br/><br/>The Registration can be revoked by RERA if a complaint is received and it is found that the developer has not complied with the rules, violated approval conditions, or is involved in unfair practices.",
        },
      ],
    },
  },
  "msme-udyam-registration": {
    title: "MSME Udyam Registration",
    hero: {
      title: "MSME Udyam Registration",
      description:
        "The Union MSME Ministry launched the Udyam Registration Portal on 1st July 2020. This registration process was introduced as a part of the Prime Minister’s relief package amid the Covid-19 pandemic to support Micro, Small, and Medium Enterprises.",
      advantages: [
        "Access to special government tenders",
        "Availability of bank loans at cheaper interest rates",
        "Eligibility for various tax rebates",
        "Lower costs for patent registration",
        "Preference for government licenses and certifications",
      ],
      eligibleCriteria: [
        "Based on investment in plant & machinery",
        "Based on annual turnover",
        "Applies to both manufacturing and service sectors",
        "Available for Proprietorships, LLPs, Companies, etc.",
        "Requires Aadhaar Number for registration",
      ],
    },
    content: {
      overviews: [
        {
          title: "Difference between MSME registration and Udyam registration",
          description:
            "The ministry of MSME has changed the name of the MSME certificate to Udyam Aadhar Certificate, which includes a unique number termed as UAN (Udyam Aadhar Number). Now, both are one and the same, with the main difference being the certificate's name. In short, Udyam Aadhar registration is the simple and streamlined way to get an MSME registration certificate. It is easier to apply for MSME benefits after getting a 12-digit UAN in the Udyam Aadhar registration certificate.",
        },
        {
          title: "What is MSME Registration?",
          description:
            "MSME registration came into force on 2nd October 2006, to promote and develop the competitiveness of Micro, Small and Medium Enterprises. It is well known that MSMEs are crucial for the growth and development of a developing country like India. Hence, it was important for the government to enhance MSME units, for which MSME registration was launched so that registered enterprises can get the benefits of government schemes.",
        },
        {
          title: "What is a Micro, Small and Medium Enterprise?",
          description:
            "As per the MSMED Act, 2006, MSMEs and SSIs were enacted to strengthen and boost the Small-Scale sector in India. Earlier, both Service and Manufacturing were considered distinct and separate from each other, having different amounts prescribed for the Investment Required.<br/><br/>However, as per the latest amendment made in the definition of MSME by the Ministry of Finance, the difference between the manufacturing and service sectors has been eliminated, Investment Limits have been Revised, and a Turnover Criteria has been introduced. This amendment was announced on 13th May 2020.",
        },
        {
          title: "Classification of Enterprises",
          description:
            "The enterprise will be classified as a micro, small, or medium enterprise according to the following criteria:",
        },
        {
          title: "What is the criteria to classify MSMEs?",
          description:
            "The classification as an MSME is done on the basis of the investment and turnover of the business, regardless of the sector. Here are the old and revised classification limits:",
          content: [
            {
              type: "table",
              title: "Old MSME Classification (Pre-Aatmanirbhar Bharat)",
              headers: ["Sector", "Micro", "Small", "Medium"],
              rows: [
                [
                  "<b>Manufacturing</b>",
                  "< Rs. 25 Lakhs",
                  "< Rs. 5 Crore",
                  "< Rs. 10 Crore",
                ],
                [
                  "<b>Service</b>",
                  "< Rs. 10 Lakhs",
                  "< Rs. 2 Crore",
                  "< Rs. 5 Crore",
                ],
              ],
            },
            {
              type: "description",
              text: "These maximum limits of MSMEs somewhat hindered the options to expand the business up to its original capacity. Under the AATMANIRBHAR BHARAT ABHIYAN, the government has extended these investment limits and also removed the definitional gap between the service sector and manufacturing sector enterprises. Here are the revised classification limits:",
            },
            {
              type: "table",
              title: "Revised MSME Classification (Current)",
              headers: ["Criteria", "Micro", "Small", "Medium"],
              rows: [
                [
                  "<b>Investment</b>",
                  "< Rs. 1 Crore",
                  "< Rs. 10 Crore",
                  "< Rs. 50 Crore",
                ],
                [
                  "<b>Annual Turnover</b>",
                  "< Rs. 5 Crore",
                  "< Rs. 50 Crore",
                  "< Rs. 250 Crore",
                ],
              ],
            },
            {
              type: "h4",
              text: "Current Definitions:",
              bullets: [
                "A <b>Micro Enterprise</b> is one wherein the investment in Plant and Machinery or Equipment does not exceed rupees 1 crore, and turnover does not exceed rupees 5 crore;",
                "A <b>Small Enterprise</b> is one wherein the investment in plant and machinery or equipment does not exceed 10 crore rupees, and turnover does not exceed 50 crore rupees; and",
                "A <b>Medium Enterprise</b> is one where the investment in plant and machinery or equipment does not exceed 50 crore rupees, and turnover does not exceed 250 crore rupees.",
              ],
            },
          ],
        },
        {
          title: "Benefits of MSME/Udyam Registration",
          description:
            "Below are some of the benefits that can be enjoyed by enterprises after getting MSME registration:",
          content: [
            {
              type: "h4",
              text: "Key Benefits",
              bullets: [
                "Get access to special government tenders which are open for the MSME industry only.",
                "Can avail bank loans at cheaper interest rates.",
                "Benefits of tax rebates.",
                "Patent registration at a lower cost.",
                "Preference for government licenses and certifications.",
                "Access to all state and central government schemes.",
              ],
            },
          ],
        },
        {
          title: "Documents Requirement for MSME/Udyam Registration",
          description:
            "The documents needed for obtaining online MSME Registration are as follows:",
          content: [
            {
              type: "h4",
              text: "Document Checklist",
              bullets: [
                "PAN Card Details of the proprietor/ all the directors/all the partners.",
                "Aadhaar Card Details of the proprietor/all the directors/all the partners.",
                "Proof of ownership of the place being used as a Registered Office such as the Allotment Letter/Lease Agreement/Possession Letter/Property Tax Receipt.",
                "If in case the place being used is a rented premise, then the Rent Agreement with the No-Objection Certificate (NOC) from the landlord together with the utility bill.",
                "Copy of Purchase Bill of every raw material purchased.",
                "Copy of Sale Bill for each end product.",
                "A Copy of Partnership Deed in the case of a Partnership Firm.",
                "Copy of Memorandum of Association (MOA) and Articles of Association (AOA) and Certificate of Incorporation (COI) in the case of a Private Limited Company together with the Board's Resolution passed authorizing the director to sign the application.",
                "Copy of the Industrial License as acquired under the Industrial Development and Regulation Act, 1951.",
                "An affidavit on Rs. 10/- Non-Judicial Stamp Paper duly attested by the Notary Officer declaring the Power Requirement and the Status of the Machinery Installed etc.",
                "Purchase Bill of the Machinery Installed.",
                "Bills relating to Purchasing and Installation of plant and machinery.",
                "Bank Account Statement.",
              ],
            },
          ],
        },
        {
          title: "Registration Process of MSME/Udyam Registration",
          description:
            "Following steps can be followed for getting MSME Registration:",
          content: [
            {
              type: "process",
              title: "Udyam Registration Steps",
              steps: [
                {
                  step: 1,
                  title: "Visit the Official Portal",
                  description:
                    "Go on the official website of Udyam registration i.e. Udyamregistration.gov.in.",
                },
                {
                  step: 2,
                  title: "Select Your Category",
                  description:
                    "The home page will provide an option to select your category:<ul><li>For “New Entrepreneurs who are not Registered yet as MSME or those with EM-II”</li><li>For those already having registration as UAM or through Assisted filing (for migration/re-registration).</li></ul>",
                },
                {
                  step: 3,
                  title: "Aadhaar Validation for New Entrepreneurs",
                  description:
                    "When a new entrepreneur proceeds, a page will open requiring them to fill in their Aadhaar number and name as per the Aadhaar card. This is validated with an OTP sent to the mobile number linked with the Aadhaar card.",
                },
                {
                  step: 4,
                  title: "Complete the Application Form",
                  description:
                    "After validation, the main application form will open. The applicant is required to fill in all the details as demanded by the form. The registration is completed by entering a captcha code and clicking the submit button.",
                },
                {
                  step: 5,
                  title: "Migration for Existing UAM Holders",
                  description:
                    "For those migrating from UAM, the applicant will be shown a screen asking for their UAM number. This is validated with an OTP sent to the registered e-mail or mobile number. After validation, the registration process will be completed.",
                },
              ],
            },
          ],
        },
        {
          title: "How to check Udyam Registration Status?",
          content: [
            {
              type: "h4",
              text: "Steps to Check Status",
              bullets: [
                "<b>Step 1:</b> Visit: https://udyamregistration.gov.in/PrintUdyamCertificate.aspx",
                "<b>Step 2:</b> Enter the Udyam Registration Number and registered phone number.",
                "<b>Step 3:</b> Choose the appropriate 'OTP' option.",
                "<b>Step 4:</b> Finally, tap on 'Validate and Generate OTP' to view or print the certificate.",
              ],
            },
          ],
        },
      ],
      features: [],
      tables: [],
      faq: [
        {
          question: "How to download MSME Udyam Registration Certificate?",
          answer:
            "On the home page of the official site of UDYAM registration, click on the option 'Print/Verify'. This requires the UDYAM registration number and registered mobile number to verify the authenticity of the applicant. After OTP verification, it will automatically redirect to the Print Certificate Page, and the certificate can be printed from there.",
        },
        {
          question:
            "What is the validity of the MSME registration Certificate?",
          answer:
            "It is a lifetime registration certificate without any expiry time limitation, up to the extent that the entity remains financially healthy and operates within its ethical norms.",
        },
        {
          question:
            "If an applicant has multiple manufacturing plants in different cities, does it require separate MSME registration for each one?",
          answer:
            "No, the applicant has the option to add multiple manufacturing plants/branches in the same registration form for the same entity. Hence, no separate registration is required for multiple branches of the same entity.",
        },
        {
          question: "Can the details in UDYAM registration be updated or not?",
          answer:
            "Yes, if the applicant wants to update any information, they can click on the 'Update Details' option on the home page of the official MSME UDYAM registration website.",
        },
        {
          question: "Can the Registration be canceled in the future?",
          answer:
            "Yes, the authorized person can apply for cancellation of the registration on the portal by clicking on the option 'Update/Cancel UDYAM registration'.",
        },
        {
          question: "What is the genesis of Udyog Aadhar?",
          answer:
            "The Ministry of MSME notified Udyog Aadhar, taking a cue from the Prime Minister’s radio show named “Man ki Baat” held in September 2015.",
        },
        {
          question:
            "Is an Aadhar Card Mandatory to obtain MSME/SSI Registration?",
          answer:
            "Yes, it is mandatory to have an Aadhar Card to obtain MSME Registration in India.",
        },
        {
          question: "Is the Credit Score necessary for MSME Registration?",
          answer: "No, a Credit Score is not necessary for MSME Registration.",
        },
      ],
    },
  },
  "iso-certification": {
    title: "ISO Certification",
    hero: {
      title: "ISO Registration in India",
      description:
        "The International Organization for Standardization (ISO) develops and publishes international standards to enhance information security and protect company assets. ISO certification improves business credibility, helping to attract more clients and facilitating the exchange of goods on an international level.",
      advantages: [
        "Customer satisfaction",
        "International credibility",
        "Better internal management",
        "Globally recognised standard",
        "Consistent outcomes",
      ],
      eligibleCriteria: [
        "ISO 9001:2015 (QMS)",
        "ISO 14001:2015 (EMS)",
        "ISO 27001:2013 (ISMS)",
        "ISO 20000-1:2018 (ITSMS)",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction to ISO Certification",
          description:
            "ISO is an International Organization for Standardization that develops & publishes an international standard. ISO consists of representatives from different national standards bodies and aims at improvement in information security and protection of company assets. ISO has catalogued some internationally recognized standards like 9001, 22000, 14000 to bolster the exchange of goods at the international front. ISO certification improves the credibility of the business and helps to get more business. It must be noted that ISO is an autonomous, non-governmental global body with 164 national standards bodies as its members.<br/><br/>Series of the International Organization for Standardization reflect an array of standards for the Quality Management System rooted in the process model. ISO has an answer for all organizations which seek the way to enhance the quality of their goods & services and seamlessly meet the expectations of their customers. An ISO 9000 family is inclusive of renowned standards of ISO to address different aspects of quality management. There are a total of 14 quality management standards.",
        },
        {
          title: "Details for ISO Certification",
          description:
            "To get certified with ISO 13845, ISO 9001, ISO 31000, ISO 50001, ISO/TS 16949, ISO 27000, and all other popular certification acknowledged by Large scale organizations throughout the world, a set of details and documents are required. These are as follows:",
          content: [
            {
              type: "h4",
              text: "Key Details",
              bullets: [
                "Internationally recognized Mark",
                "Satisfaction among Customers",
                "Quality Assurance",
                "An edge to the business in case of government tenders",
                "Credibility and Marketability",
              ],
            },
          ],
        },
        {
          title: "Documents Required For ISO Registration",
          description:
            "The following documents are required to apply for ISO Registration:",
          content: [
            {
              type: "h4",
              text: "Document Checklist",
              bullets: [
                "PAN Card",
                "Passport Size Photo",
                "Aadhar Card/ Voter ID Card",
                "Two copies of sale bill or purchase bill",
              ],
            },
          ],
        },
        {
          title: "Types of ISO Registration",
          content: [
            {
              type: "h4",
              text: "Available ISO Standards",
              bullets: [
                "ISO 9001:2015 (Quality Management System)",
                "ISO 14001:2015 (Environment Management System)",
                "ISO 45001:2018 (Occupational Health and Safety Management System)",
                "ISO 20000-1:2018 (Information Technology Service Management System)",
                "ISO 22000:2018 (Food Safety Management System)",
                "ISO 27001:2013 (Information Security Management System)",
                "ISO 50001:2018(Energy Management System)",
                "ISO 13485:2016 (Medical Devices Quality Management System )",
                "ISO 22301:2012 (Business Continuity Management System)",
                "ISO 21001:2018 (Educational Organisations Management System)",
                "ISO 55001:2014 (Asset Management System)",
                "ISO 41001:2018 (Facility Management System)",
                "ISO 37001:2016 (Anti-Bribery Management System)",
                "ISO 29990:2010 (Learning Management System)",
              ],
            },
          ],
        },
        {
          title: "ISO Registration Process in India",
          content: [
            {
              type: "h4",
              text: "ISO Certification: Prerequisite",
            },
            {
              type: "process",
              title: "Prerequisite Steps",
              steps: [
                {
                  step: 1,
                  title: "Selection of an ISO Certification Type",
                  description:
                    "Selection of an ISO certification type, among the different types of ISO Certification that is appropriate for the business is critical. Some of the IOS types are:<br/>ISO 9001 2008 – Quality Management<br/>ISO 14001 – Environmental Management<br/>ISO 27001 – Information security Management<br/>ISO 22008 – Food Safety Management and so on.",
                },
                {
                  step: 2,
                  title: "Selection of an ISO Certification Body",
                  description:
                    "Selection of an authenticated & reliable ISO Certification Body is yet another important prerequisite as ISO itself does not offer any certification to the companies and it has to be done by the external bodies.",
                },
              ],
            },
            {
              type: "h4",
              text: "ISO Registration Process",
            },
            {
              type: "process",
              title: "Registration Steps",
              steps: [
                {
                  step: 1,
                  title: "Fill ISO Registration form",
                  description:
                    "The first step is to select an appropriate ISO certification type for your business. Some of the ISO types are:<br/>ISO 9001 2008 – Quality Management<br/>ISO 14001 – Environmental Management<br/>ISO 27001 – Information security Management<br/>ISO 22008 – Food Safety Management and so on.",
                },
                {
                  step: 2,
                  title: "Verification & Submission of Documents",
                  description:
                    "The submitted document is verified and double-checked and thereafter the same are filed with the concerned ISO Registrar. Once all the documents are submitted online payment is to be made via various payment modes as available. When the ISO registration services are availed by ISO certification consultants, a checklist of documents that need to be submitted for ISO registration, are given to the companies that seek registration. The scanned copy of these documents can be sent by the companies to the ISO certification consultant.",
                },
                {
                  step: 3,
                  title: "ISO Audit",
                  description:
                    "ISO Audit is verification and examination of your business process records to check the authenticity. The three main types of audits are as follows:-<ul><li>First party audit or internal audit</li><li>Second-party audit or supplier audit</li><li>Third-party audit or certification audit</li></ul>",
                },
                {
                  step: 4,
                  title: "ISO Certification",
                  description:
                    "If the audit goes well i.e. if the company successfully stands the audit, a Certificate is issued to the Company through a courier at their business address.",
                },
              ],
            },
          ],
        },
        {
          title: "ISO Registration Benefits",
          description:
            "An ISO registration promises the products’ safety and regularity while promoting the international participation and rapport. Some of the benefits of ISO Registration are:",
          content: [
            {
              type: "h4",
              text: "Key Advantages",
              bullets: [
                "<b>Global Business</b><br/>An ISO registration opens up the avenues for you to enter in the global business market.",
                "<b>Increased Efficiency & Productivity</b><br/>The productivity of the company is streamlined through ISO Registration, followed by optimistic expansion of resource acquisition and international growth.",
                "<b>Security and Satisfaction of Consumers</b><br/>ISO Registration offers credibility, safety and commitment to consumers and also knocks off the products that lay adverse effects on the environment.",
              ],
            },
          ],
        },
      ],
      features: [
        "Global Business Opportunities",
        "Increased Efficiency & Productivity",
        "Enhanced Security and Consumer Satisfaction",
        "Internationally Recognized Mark",
        "Improved Quality Assurance",
        "Credibility and Better Marketability",
        "Increased Revenue and Recognition",
      ],
      tables: [],
      faq: [
        {
          question: "What is ISO Certification?",
          answer:
            "It is a kind of seal of approval from the third part body as an indication which shows your company’s credibility and also the instills confidence in your clients.",
        },
        {
          question: "How much cost is incurred on ISO Certification?",
          answer:
            "The cost mainly depends upon the number of employees in your organization along with your products and services. The cost also depends upon the accreditation body and the certification body.<br/><br/>Depending upon the number of employees, certification body calculates the audit mandate the requirement than multiplies it with the auditor manday rate and then adds the accreditation body fees. Some of the certification bodies also charge “file maintenance” charges, administrative charges etc. In addition to the certification you also have to bear the auditors travel and living expenses. You must ensure that arrangements for travel and living are done as per your company standards and not as demanded by auditor or the certification body.",
        },
        {
          question: "What documents are required for ISO Certification?",
          answer:
            "<ul><li>PAN Card</li><li>Passport Size Photo</li><li>Aadhar Card/ Voter ID Card</li><li>Two copies of sale bill or purchase bill</li></ul>",
        },
        {
          question: "What are ISO 9001-2015?",
          answer:
            "The ISO 9001 is a quality management system which can be integrated into any business. It is focused on ensuring that the business delivers a consistent level of quality to the customers by having a well defined and regularly reviewed processes and procedures. This system fully integrates within the existing business procedures and it becomes part of the culture of the organization. Accordingly, a business will not perform a task to conform to the ISO 9001 but it will perform the task for the good of the business. There are eight main business principles covered by the system which are:<ul><li>Customer focus</li><li>Leadership Involvement of people</li><li>Process approach</li><li>System approach to management</li><li>Continual improvement</li><li>Factual approach to decision making</li><li>Mutually beneficial supplier relationships.</li></ul>",
        },
        {
          question:
            "Does ISO 9000 / 9001 or any other certification ensure that a buyer will always get good quality?",
          answer:
            "No. it does not ensures that the certified company has an appropriate processes in place in ensure that only good quality products are/ will be delivered to the buyer. But this is not achieved 100%. A buyer may get a faulty product or service.",
        },
        {
          question:
            "Does ISO 9000 / 9001 certified company should respond to customer complaints?",
          answer:
            "Yes. the ISO 9001 certification requires an organizations to have a complaint management system.",
        },
        {
          question: "What is a certification body and accreditation body?",
          answer:
            "A certification body also called as registrar is an organization which issues certificate of ISO. An accreditation body is an organization which empowers the certification body to issue the certificate. Generally an accreditation body is a member of an International accreditation forum [IAF] but there are many other “independent” accreditation bodies also.",
        },
        {
          question:
            "How do one can know that whether they are ISO Certified entity?",
          answer:
            "When you are ISO you will receive a certificate from the certification body bearing a unique certificate number. Using this unique number over accreditation’s body website one can verify that your business is an ISO certified entity.",
        },
        {
          question: "What do you mean by ISO Audit?",
          answer:
            "The ISO audit is a basic tool to check the quality process system of an organization ensuring that the organization is following the requirements as prescribed. Once an ISO certification is granted, the ISO audit needs to be done on an annual basis.",
        },
      ],
    },
  },
  "business-registration-number": {
    title: "BRN Registration",
    hero: {
      title: "BRN Registration",
      description:
        "Starting a business is itself a big challenge. You not only have to decide your budget, set goals and make strategy but also achieve legal compliance. In addition to registering your business and getting licensed, there are several other compliances you must full fill before starting a business. Depending on your industry and location, you must need to apply for a business registration number. In this article we will understand what BRN exactly is, how to obtain BRN and why it is necessary.",
      advantages: [
        "Enhances Reputation with Customers",
        "Enables Corporate Bank Account Opening",
        "Simplifies Access to Loans",
        "Secures Your Business Name",
      ],
      eligibleCriteria: [
        "Sole Proprietorship Registration through Udyog Aadhaar",
        "Registration under Shop and Establishment Act",
        "Registration through GST Registration",
      ],
    },
    content: {
      overviews: [
        {
          title: "What Is Business Registration Number (BRN)?",
          description:
            "A BRN is a unique identifier it is either a state tax ID number or a registered identification number. It gives a special identity to your business. After receiving BRN, concerned authorities will receive all the details of business activities online which enables easy registration of your organisation. A business registration number can be either a state state employer identification number (EIN) or a registered identification number. Both serve as unique identifiers & can be obtained for free. In addition to this, you may apply online for obtaining BRN to save time and to keep things simple.",
        },
        {
          title: "Advantages of Taking BRN Registration",
          description:
            "There are many benefits of taking BRN some of them are given below:",
          content: [
            {
              type: "h4",
              text: "Key Benefits",
              bullets: [
                "<strong>Reputation with customers:</strong> Building reputation is a tough task especially for them who never did any business before. Getting your business registered and taking BRN gives your customers confidence that they are dealing with a reputable organization. When your business is online and you have the option of customers paying to your organisation’s account before you can ship the goods or services, having a registered organisation along with a corporate account will give more credibility and trust.",
                "<strong>Account Opening in Your Company Name:</strong> If you want to open corporate account in your company name, then you can use BRN to make this process simple. When you have a corporate account, then it will give you more credibility and trust from your customers, bank, suppliers and other business partners side.",
                "<strong>Getting Loans:</strong> When your business is registered and you have the BRN, then accessing loan becomes very easy and fast compare to taking loan when you don’t have BRN. With the help of BRN, you don’t have to prove that you’re actually a business. This increases credibility and trust and your investors or lenders will see that they are dealing with a trustable organisation and will be willing to do lend you more money.",
                "<strong>Getting on Record:</strong> One great advantage of having your company registered with the local, state government and you have BRN then this is to ensure that your company name is not registered by someone else. No organisation can registered his business with same name even not in future.",
              ],
            },
          ],
        },
        {
          title:
            "Documents Requirement for obtaining Business Registration Number",
          description:
            "The following are the documents you must have for taking BRN and getting your business registered:",
          content: [
            {
              type: "h4",
              text: "Document Checklist",
              bullets: [
                "Digital signature certificate(DSC)",
                "Director identification number(DIN)",
                "Registration from MCA portal",
                "Certificate of Incorporation",
                "Scanned copy of PAN Card",
                "Copy of aadhar Card",
                "Latest electricity bill",
                "Photo of applicant",
                "Bank statement of the organisation",
                "Other information like phone number, email address etc.",
              ],
            },
          ],
        },
        {
          title:
            "Basic Requirements and Options Available for Sole Proprietorship Registration",
          description:
            "Registering a sole proprietorship business is a digital process that can be accompanied with the help of an expert. However, a person interested in registering as a sole proprietorship requires fulfilling some basic requirements like opening a bank account in the name of the business entity, etc.",
          content: [
            {
              type: "h4",
              text: "Registration Options",
              bullets: [
                "Sole Proprietorship Registration through Udyog Aadhaar under Ministry of MSME",
                "Sole Proprietorship registration under Shop and Establishment Act",
                "Sole Proprietorship registration through GST Registration",
              ],
            },
          ],
        },
        {
          title: "How to obtain BRN Registration?",
          description:
            "A business entity can apply for BRN by following procedure:",
          content: [
            {
              type: "process",
              title: "BRN Application Process",
              steps: [
                {
                  step: 1,
                  title: "Visit Portal",
                  description:
                    "Visit BRN registration portal and select Registration > Apply for BRN. In case of NGO/VO, click on Apply BRN(For NGO).",
                },
                {
                  step: 2,
                  title: "Agree to Terms",
                  description:
                    "Read all the terms and conditions mentioned on the registration page and click ‘I have read and agree to the above instructions’.",
                },
                {
                  step: 3,
                  title: "Initial Verification",
                  description:
                    "Enter the Mobile No. Email ID and Captcha Code and select verify.",
                },
                {
                  step: 4,
                  title: "OTP Verification",
                  description:
                    "Enter the OTP received on the above mentioned Email ID.",
                },
                {
                  step: 5,
                  title: "Apply for BRN",
                  description:
                    "Select Apply BRN on the existing BRN search page.",
                },
                {
                  step: 6,
                  title: "Fill Details",
                  description: "Enter all other relevant details as required.",
                },
                {
                  step: 7,
                  title: "Upload Signature",
                  description:
                    "Upload signature of the business owner (in JPEG format upto 50 KB).",
                },
                {
                  step: 8,
                  title: "Business Details",
                  description:
                    "Enter Name & Address of business place of Enterprises/Firms including PAN/TAN.",
                },
                {
                  step: 9,
                  title: "Head Office Details",
                  description:
                    "Enter Name & Address of main business place/head office of the Enterprises/Firms.",
                },
                {
                  step: 10,
                  title: "Correspondence Address",
                  description:
                    "Select Correspondence address to be used for future reference which can be either Applicant address or Business Place address or Head Office address.",
                },
                {
                  step: 11,
                  title: "Activity Description",
                  description:
                    "Enter Description of Major Activity. The applicant can select the activity code form the list as suitable to the business entity.",
                },
                {
                  step: 12,
                  title: "Start of Operations",
                  description:
                    "Enter Year of Starting of Operation. If not started, then click Not Started.",
                },
                {
                  step: 13,
                  title: "Annual Accounts",
                  description:
                    "Choose Yes or No for whether annual accounts are maintained or not?",
                },
                {
                  step: 14,
                  title: "Ownership Code",
                  description:
                    "Enter Ownership Code from the drop down list. Ownership Code refers to a type of business entity like: Proprietorship, Partnership Firm, Company, Limited Liability Partnership, Self Help Group etc.",
                },
                {
                  step: 15,
                  title: "Number of Persons",
                  description:
                    "Enter total no. of expected/working number of persons of the business entity including owner.",
                },
                {
                  step: 16,
                  title: "Investment Details",
                  description:
                    "Expected/Proposed Investment in the business entity. (Rs. in lakhs)",
                },
                {
                  step: 17,
                  title: "Applicable Acts",
                  description:
                    "Select the applicable acts under which registration is required.",
                },
                {
                  step: 18,
                  title: "Declaration and Submission",
                  description:
                    "Click the checkbox of declaration and select submit. After submitting the application successfully take the print of the application.",
                },
                {
                  step: 19,
                  title: "Receive BRN",
                  description:
                    "BRN will be auto generated and sent to your registered Mobile No. and Email id.",
                },
              ],
            },
          ],
        },
        {
          title: "Precautions while applying for BRN",
          content: [
            {
              type: "process",
              title: "Important Precautions",
              steps: [
                {
                  step: 1,
                  title: "Select Correct Application Type",
                  description:
                    "To get BRN for your Firm, you have to Click on Apply BRN. If you want to apply BRN for NGO, then click on Apply BRN (For NGO).",
                },
                {
                  step: 2,
                  title: "Use Own Contact Details",
                  description:
                    "Use own Mobile Number/e-mail for BRN. Do not use Mobile/email of any other person otherwise issued BRN will be treated for that person. If applying BRN through Aadhaar Number, then you should use Mobile number registered in Aadhaar.",
                },
                {
                  step: 3,
                  title: "Read Tutorial",
                  description:
                    "Before applying for BRN, you must read BR tutorial carefully. So that there is no chances of any mistake.",
                },
                {
                  step: 4,
                  title: "Provide Correct Particulars",
                  description:
                    "In the identification Particulars, information related to the status of Institution/Firm should to be provided.",
                },
                {
                  step: 5,
                  title: "Fill Information Carefully",
                  description:
                    "In the application of BRN, some information is auto filled (non-editable) and rest information is to be filled.",
                },
                {
                  step: 6,
                  title: "Head Office Information",
                  description:
                    "In case Name & Address of Head Office of the organisation is available, then only it should be filled, otherwise leave it blank.",
                },
                {
                  step: 7,
                  title: "Major Activity Details",
                  description:
                    "In the details of Major Activity, fill the relevant work of your organisation and choose the activity code wisely.",
                },
                {
                  step: 8,
                  title: "Handle Rejection",
                  description:
                    "In case BRN application is rejected, its reason can be viewed by PRINT BRN option. BRN can be updated by UPDATE BRN option after rectifying the reason mentioned in rejection. In this situation there is no need to apply for fresh BRN.",
                },
                {
                  step: 9,
                  title: "Update or Cancel Online",
                  description:
                    "The facility to UPDATE OR CANCEL BRN online is available on the portal.",
                },
              ],
            },
          ],
        },
      ],
      features: [
        "Establishes credibility with customers and partners.",
        "Facilitates opening of a corporate bank account.",
        "Improves access to business loans and financing.",
        "Protects your business name from being used by others.",
        "Provides an official record with government authorities.",
        "Streamlines compliance and official processes.",
      ],
      tables: [],
      faq: [
        {
          question:
            "Is any ID /proof Required for getting business registration number?",
          answer:
            "Ans. Yes, ID proof of Owner of the organisation is mandatory. If the Owner registers through their Adhaar Number, BRN will be issued automatically and if other ID proofs like PAN Card, Ration Card, Voter ID, Driving Licence, Pass Port is used, BRN will be issued after processing.",
        },
        {
          question:
            "When the business of applicant is registered in one act for business registration and if he need to register in another act, whether he has to apply for new BRN?",
          answer:
            "Ans. No, you do not have to take new BRN for another act and existing BRN is applicable. You will have to update your Registration Number of new act on portal online.",
        },
        {
          question:
            "Will applicant have to inform changes in business activities every year?",
          answer:
            "Ans. Yes, Business activities status, change in activities, production or other details have to be informed to nearest District Business Registration Centre at the end of each financial year.",
        },
        {
          question:
            "I have submitted my application but not received BRN . whom I have to contact?",
          answer:
            "You can contact to nearest district business registration centre for any issue related to BRN.",
        },
        {
          question:
            "What problem applicant may face , if he submitted different information to registration authority as submitted in BRN?",
          answer:
            "Ans. Yes, If different information be submitted to the concerned authority, there may be problem in business registration because BRN information is provided to Registration authorities by integrate process.",
        },
        {
          question:
            "What I have to do if Ownership of my Business has changed?",
          answer:
            "You can contact to nearest District Business Registration centre for changes in ownership details.",
        },
        {
          question:
            "If applicant have mentioned X work while taking BRN but he has changed the work to Y. Whether he has to changed BRN details?",
          answer:
            "Ans. Yes, applicant have to inform changes to nearest District Business Registration Centre so that it may be updated on portal.",
        },
        {
          question:
            "What problem an applicant has to face, if he submitted different information to registration authority as submitted in business registration number?",
          answer:
            "Ans. Yes, If different information be submitted to registration authority by the applicant, then there may be problem in business registration because BRN information is provided to Registration authorities by integrate process.",
        },
      ],
    },
  },
  "trust-registration": {
    title: "Trust Registration",
    hero: {
      title: "Trust Registration",
      description:
        "A trust is a harmonization under which the owner of the Trust transfers the property to a trustee to provide the advantage to a third party. A trust is regulated by The Indian Trust Act 1882 i.e. all the trusts are required to get registered under The Indian Trust Act 1882. Nowadays, registration of a trust is a complete online process which can be done by execution of a Trust Deed. The most important requirement under Trust registration is a Trust deed.",
      advantages: [
        "Involvement In Charitable Activities",
        "Avail Tax Exemptions",
        "Benefit to Unprivileged People",
        "Legal Compliance and Recognition",
        "Preservation Of Family Wealth",
      ],
      eligibleCriteria: [
        "Trustor: The person who creates the trust.",
        "Trustee: The person who manages the trust.",
        "Beneficiary: The person who benefits from the trust.",
      ],
    },
    content: {
      overviews: [
        {
          title: "What is a Trust?",
          description:
            "A Trust is an arrangement where the owner or trustor of the Trust transfers the property to a trustee. Such transfer of property is done for the benefit of a third party. The property is transferred to the trustee by the trustor along with a proclamation that the property should be held by the trustee for the beneficiaries of the trust.<br/><br/>The Indian Trust Act 1882, provides for the provisions related to Trust in India. The Trust Registration is advisable in India for obtaining the benefits.",
        },
        {
          title: "What are the advantages of Trust Registration?",
          description: "The advantages of registering a trust are as follows:",
          content: [
            {
              type: "h4",
              text: "Key Advantages",
              bullets: [
                "To Involve In Charitable Activities",
                "Registered Trust Avails Tax Exemptions",
                "Provides benefits To unprivileged People",
                "Compliance With Law",
                "Preservation Of Family Wealth",
                "Avoid Court",
                "Immigration/Emigration Of Family",
                "Forced Heirship",
                "Tax Mitigation",
                "Managing Assets",
              ],
            },
          ],
        },
        {
          title:
            "What are the Parties Involved in the Trust Registration Process?",
          description:
            "The parties involved in the Trust registration process are as follows:",
          content: [
            {
              type: "h4",
              text: "Key Parties",
              bullets: ["Trustor", "Trustee", "Beneficiary"],
            },
          ],
        },
        {
          title: "What are the Types of Trusts?",
          description:
            "In India, there are two types of trust which are as follows:",
          content: [
            {
              type: "h4",
              text: "Trust Categories",
              bullets: [
                "<b>Private Trust:</b> A Private trust is a trust that is created for the benefit of 1 or more individuals who are, or within a given time may be, definitely ascertained. In other words Private Trusts are constituted for the benefit of individuals rather than for the benefit of public. Private Trusts are governed under the Indian Trusts Act 1882 and may be created inter vivos or by will.",
                "<b>Public Trust:</b> A Public Trust is a trust which is constituted wholly for the benefit of Public at large. The major provisions under Public Trusts are as follows:<ul><li>Public trusts are basically divided under charitable or religious trusts and are regulated by the general Law.</li><li>The regulations of Indian Trusts Act which is applicable on private trusts, do not apply to Public Trusts.</li><li>Like private trusts, public trusts may also be established inter vivos or by will.</li><li>The Charitable and Religious Trust Act, 1920, the Religious Endowments Act, 1863, the Charitable Endowments Act, 1890, the Bombay Public Trust Act, 1950 are some of the Acts for the enforcement of public trusts in India.</li></ul>",
                "<b>Public-Cum-Private Trusts:</b> Those trusts whose income may be used for public purposes as well as a part may go to a private person or persons are known as Public-cum-Private Trusts.",
              ],
            },
          ],
        },
        {
          title: "Classification in Terms of Motive of Formation",
          description:
            "Recently, trusts can also be used as a vehicle for investments, such as mutual funds and venture capital funds. These trusts are governed by Securities and Exchange Board of India (SEBI). Classification in terms of motive of formation is as follows:",
          content: [
            {
              type: "h4",
              text: "Classifications by Motive",
              bullets: [
                "<b>Private Trust:</b> Settlor creates a Trust primarily for benefit of one or more particular individuals as its Beneficiary.",
                "<b>Public Trust:</b> Beneficiaries are the general public or a class as a whole. It has some charitable end as its Beneficiary.",
                "<b>Simple Trust:</b> Trustee is just a passive depository of the Trust property. There are no active duties expected from Trustee and no directions are given to him.",
                "<b>Special Trust:</b> Trustee is active and acts as an agent to execute the Grantor’s wishes. This Trust is operative.",
                "<b>Express Trust:</b> Here, the Settlor creates a Trust over his assets either in present or upon his death. It can be either by way of a will or Trust deed.",
                "<b>Implied Trust:</b> It is created where some legal requirements for an Express Trust are not met, but intention on behalf of the parties is to create a Trust that is presumed to exist.",
                "Others depending on the type of object(s).",
              ],
            },
          ],
        },
        {
          title: "Documents required for Trust Registration",
          description:
            "The documents needed for registering a trust are mentioned below:",
          content: [
            {
              type: "h4",
              text: "Document Checklist",
              bullets: [
                "Proof of Identity for Trustor & Trustee - Aadhaar Card, Voter ID, Passport, Driving License",
                "Address Proof of Registered Office - Copy of Certificate of Property/Utility Bills (Telephone, Water, Electricity Bill)",
                "In the case of rented property, No Objection Certificate from the owner is needed.",
                "Objective of the Trust Deed.",
                "Particulars of the Trustee and settlor (Self-attested copy Id and Address Proof along with the data associated with occupation).",
                "Trust Deed on correct Stamp Value.",
                "Photographs of Trustee and settlor.",
                "PAN Card of Trustee and settlor.",
              ],
            },
          ],
        },
        {
          title: "What is included in deed of trust?",
          description: "The Trust deed involves the following information:",
          content: [
            {
              type: "h4",
              text: "Deed Contents",
              bullets: [
                "Total number of trustees.",
                "The Registered address of the trust.",
                "Proposed name of the trust.",
                "Rules and laws to be strictly followed by the Trust.",
                "Presence of settlor and two witnesses at the time of registration of Trust.",
              ],
            },
          ],
        },
        {
          title: "What are the steps involved in Trust Registration?",
          description:
            "The procedure of the Trust Registration in India is as follows:",
          content: [
            {
              type: "process",
              title: "Registration Process",
              steps: [
                {
                  step: 1,
                  title: "Choose an Appropriate Name",
                  description:
                    "This is the first step in the procedure of Trust Registration in India. Additionally, the name so suggested by the applicant should not come under the restricted list of the names as per the provisions of the Emblems and Names Act, 1950.",
                },
                {
                  step: 2,
                  title: "Decide the Authors and Trustees",
                  description:
                    "There is no specifically defined provision with regards to the number of settlers or authors. However, in most of the cases, there is generally only one author of a Trust. Furthermore, there is no limit on the maximum number of the trustees of a Trust. But a minimum number of two trustees are necessary to form a Trust in India. Also, generally, the author cannot be the trustee of a Trust. And the author is required to be a resident of India.",
                },
                {
                  step: 3,
                  title: "Formulate Memorandum of Association and Trust Deed",
                  description:
                    "A Trust Deed is legal evidence of the existence of the Trust. It contains the rules and regulations of the Trust. This document also contains the laws regarding the removal, changes, or addition of the Trustees to the Trust. On the other hand, Memorandum of Association or MOA represents the charter of the Trust. It defines the relationship between the Trustor and the Trustees and also specifies the primary objectives for which such a Trust is formed by the applicants. Such a document of a Trust should contain the addresses, names, and occupations of all the members along with their signatures.",
                },
                {
                  step: 4,
                  title: "Preparation of Trust Deed on a Stamp Paper",
                  description:
                    "As a Trust, the applicant is required to prepare the Trust Deed on a stamp paper. The value of the stamp paper is of a certain percentage of the total value of the property of the Trust. Furthermore, this percentage value of the Trust varies from state to state. In addition to this, the applicant is required to pay a fee of Rs. 1100. Out of this Rs. 1100 amount of Rs. 100 is the Trust Registration fee and other Rs. 1000 are the charges of keeping a certified copy of the Trust Deed with the Sub-Registrar.<br/><br/>Once the applicant submits all the required papers, he/she can collect a certified copy of the Trust Deed. Such a copy can be collected within a time period of one week from the office of the Registrar.",
                },
                {
                  step: 5,
                  title: "Submission of Trust Deed to the Registrar",
                  description:
                    "After the receipt of the copy of the Trust Deed, the applicant is required to submit the same along with properly attested photocopies of all the necessary documents with the office of the local registrar.<br/><br/>Furthermore, the settler should put his/her signatures on every page of the photocopy of the Trust Deed. Also, it is mandatory for all the settlers as well as the two other witnesses to be physically present along with the identity proofs (original as well as the self-attested photocopy of the same) at the time of Trust Registration in India. However, the physical presence of Trustees of the Trust is debatable.",
                },
                {
                  step: 6,
                  title: "Obtain the Certificate of Registration",
                  description:
                    "After the submission of the Trust Deed with the Registrar, the registrar will retain the photocopy of the Deed and return the original registered copy of the Trust Deed.<br/><br/>After the completion of all the formalities, a Certificate of Registration will be issued to the applicant. Such a Certificate of Registration will be issued within a minimum of seven working days.",
                },
              ],
            },
          ],
        },
        {
          title:
            "What are the Penalties that can be levied on Breaches in Compliances of Trust Registration?",
          description:
            "There are three types of penalties that can be levied in case of non- compliances of trust registration that are mentioned below:",
          content: [
            {
              type: "h4",
              text: "Types of Penalties",
              bullets: [
                "<b>Civil And Criminal Penalties:</b> In case of Breach of trust, section 405 to Section 409 of the Indian Penal Code 1860 can be imposed on the beneficiary that means both civil and criminal penalties may be imposed.",
                "<b>Application For Tax Deduction Account Number:</b> On registration of a trust or an establishment, the trust or an establishment should apply for tax deduction account number in form number 49B of Income Tax rules to Assessing Officer or the prescribed authority and quote the tax deduction account number on all the challans for payment of sums under section 200, on all the TDS certificates and all the returns delivered under section 206, 206A and 206B. In case of non- compliance of above sections, a penalty of Rs. 10,000/- can be levied as prescribed under section 272BB.",
                "<b>Failure To Furnish The Return Of Income:</b> If the trust or institution fails to furnish the return of income then it attracts penalty under the Act. If the certificate for the TDS has not been provided along with the ITR due to the default of the payer in not furnishing such certificate then the ITR will not be considered as defective. However, the certificate is required to be produced within 2 years from the end of the assessment year.",
              ],
            },
          ],
        },
        {
          title: "What is the Impact of Section 12AB on Trust Establishments?",
          description:
            "To continue taking exemption below section 10 or 11 all the present charitable trust or establishments are mandatorily needed to get a fresh registration under Section 12AB which are already registered under the below mentioned section:",
          content: [
            {
              type: "h4",
              text: "Applicable Sections",
              bullets: [
                "Section 12A",
                "Section 12AA",
                "Section 10(23C)",
                "Section 80G",
              ],
            },
          ],
        },
        {
          title: "Is it necessary to E-file the ITR for a Trust?",
          description: "A trust should file a ITR electronically-",
          content: [
            {
              type: "h4",
              text: "E-filing Requirements",
              bullets: [
                "With or",
                "Without a Digital signature.",
                "Under the Electronic Verification Code.",
              ],
            },
          ],
          description_after_table:
            "However, trusts who are liable to get its accounts audited section 44AB shall furnish the return electronically.",
        },
      ],
      features: [
        "Eligibility for Tax Exemptions",
        "Legal framework for charitable activities",
        "Preservation and management of family wealth",
        "Ensures legal compliance and recognition",
        "Avoids potential court disputes over assets",
        "Aids in tax mitigation strategies",
      ],
      tables: [],
      faq: [
        {
          question:
            "Is it necessary for the trust to induce the registration done under section 12AB?",
          answer:
            "Yes, a trust should get the registered under section 12AB of Income Tax Act, 1961 to get the exemption under section 11.",
        },
        {
          question: "Is trust a separate Legal Entity?",
          answer:
            "In a strict legal sense, a trust isn’t a separate legal entity, not like an organization. A trust gets created once the settlor hands over any property to the trustee to be used and used for the advantage of the beneficiary. This legal arrangement is codified vide a trust deed.",
        },
        {
          question: "What are the Parties involved in a Trust?",
          answer:
            "<ul><li>Settlor</li><li>Trustee, and</li><li>Beneficiaries</li></ul>",
        },
        {
          question: "What are the types of Trust?",
          answer: "<ul><li>Private Trust</li><li>Public Trust</li></ul>",
        },
        {
          question: "What is the distinction between Trustee and Trustor?",
          answer:
            "Trustor is that the one who creates the trust, whereas the one who has the responsibility of managing the trust for the beneficiary i.e. Trustee.",
        },
        {
          question: "What is the governing law for a Trust?",
          answer:
            "Trusts are governed under The Indian Trusts Act, 1882 in India.",
        },
        {
          question:
            "What is a Public Trust and what’s the aim behind forming it?",
          answer:
            "By and enormous an charitable trust is created for setting up a school, universities, alternative instructive activities, clinic, mature age homes, halfway house, for advancement of child welfare and their strengthening, government help of a lot of fragile section of society, and for satisfaction of Corporate Social Responsibilities (CSR) by organizations.",
        },
        {
          question:
            "What are the Documents needed throughout the Trust Registration process?",
          answer:
            "<ul><li>Proof of Identity for Trustor & Trustee</li><li>Address Proof of Registered Office</li><li>NOC from the owner is needed</li><li>Particulars of the Trustee and settlor</li><li>Trust Deed on correct Stamp Value.</li><li>Photographs & PAN of Trustee and settlor.</li></ul>",
        },
        {
          question: "How do I register a trust under Indian Trust Act 1882?",
          answer:
            "<ul><li>Select a correct Name</li><li>Drafting of Trust Deed</li><li>Selecting Settlers and Trustees of Trust</li><li>Preparing Memorandum of Association</li><li>Paying the Requisite Fees</li><li>Collection of a duplicate of Trust Deed</li><li>Submission of Trust Deed to Registrar</li><li>Obtain Registration Certificate</li></ul>",
        },
      ],
    },
  },
  "society-registration": {
    title: "Society Registration",
    hero: {
      title: "Society Registration",
      description:
        "The piece of equipment of “society” evolved to complete the need of an organization of non-commercial character for the sustainability of repeated charitable activities like education, art, religion, culture-music, and sport, etc. Associations or societies are fashioned to help further these causes since they work on a non-profit base. The call for a legal entity is to own, possess and handle the finances and assets for the accomplishment of liberal or promotional objects, as laid behind by donors, is the result of these actions. Moreover, a society can be shaped to realize this end.",
      advantages: [
        "Acquires a legal status",
        "Eligible to open a bank account",
        "Legal recognition before forums",
        "Eligible for Income Tax benefits",
        "Can enter into legal contracts",
      ],
      eligibleCriteria: [
        "A minimum of 7 or more persons.",
        "Eligible members include individuals, foreigners, partnership firms, limited companies, and other registered societies.",
        "Minors are not eligible to be members.",
      ],
    },
    content: {
      overviews: [
        {
          title: "Overview of Society Registration",
          description:
            "A group of people working together to promote charitable activities like sports, music, culture, religion, art, education, etc. and when the group is registered under the Society Registration Act then it will be recognized legally as Society. Additionally, it brings uniformity in the way of working of Societies which helps in better governance too. It is mostly formed to carry out activities like scientific/charitable or literary works. The purpose of Society Registration can be underlined as it enables to give boost to legal conditions of Society. It also helps Society to get a legal status in India. In other words, it becomes a legal entity.",
        },
        {
          title: "Purpose of Society Registration",
          description:
            "Whenever we decide anything, the first thing which clicks in our mind is that what is the purpose for which we are doing the action. So here are some purposes of society registration which are defined under the Act:",
          content: [
            {
              type: "h4",
              text: "Key Purposes",
              bullets: [
                "Promotion of fine arts.",
                "Diffusion of political education.",
                "Grant of Charitable Trust",
                "Promotion of Science and Literature.",
                "Creation of Military Orphan Funds.",
              ],
            },
          ],
        },
        {
          title: "Benefits of Getting Society Registration",
          content: [
            {
              type: "h4",
              text: "Key Benefits",
              bullets: [
                "Legal status to the entity.",
                "Society is eligible to open a bank account on its own name.",
                "Legal recognition before forum and authorities.",
                "Multiple benefits under Income Tax Act.",
                "Eligibility to enter into a contact on its own name.",
                "Gain capability to sue or sued.",
              ],
            },
          ],
        },
        {
          title: "Eligibility for Society Registration",
          description:
            "Registered Societies are similar to a partnership firm. Moreover, these societies enjoy divergent merits than that of an unregistered organization. There must be a least of 7 members or more for creating community. Following members are allowed to enroll for Memorandum of society: Besides person, the following bodies are eligible to form an association by contributing to the Memorandum of a society:",
          content: [
            {
              type: "h4",
              text: "Eligible Members",
              bullets: [
                "Foreigners",
                "Partnership firm",
                "Limited company",
                "Registered society",
                "Minors not eligible",
                "Foreign companies",
                "Indian companies",
                "Other registered society",
              ],
            },
          ],
        },
        {
          title: "Documents Required For Society Registration",
          description:
            "The following documents are required for Society Registration as follows:",
          content: [
            {
              type: "h4",
              text: "Document Checklist",
              bullets: [
                "PAN Card and one Residence Proof (Bank Statement, Aadhar Card, Utility Bill, Driving License, Passport) of minimum 7 persons.",
                "Memorandum of Association.",
                "Proof of Address of Registered Office and if the place is not owned then NOC of the owner with the Utility Bill is also required.",
                "Declaration from president that he is willing to accept the said post of the proposed Society.",
                "Rules & Regulations of society.",
                "Any other document which the state government specifically demands as per their own requirements.",
              ],
            },
          ],
        },
        {
          title: "What are the Precautions while Keeping a Name of Society?",
          description:
            "The precautions that one should keep in mind in finalizing the name of Society are as follows:",
          content: [
            {
              type: "h4",
              text: "Naming Guidelines",
              bullets: [
                "The name of Society should be as per the rules laid out by Society Act, 1860 which states if identical name is selected, the Authority will reject it.",
                "The name should not be against State Government/ Government of India.",
                "The name should abide by Emblem and Names Act, 1950.",
                "No word or phrase must be included which goes against Government/Community.",
              ],
            },
          ],
        },
        {
          title: "Procedure of Society Registration",
          description:
            "Generally, in the offline process the above documents have to be submitted with the registrar office with the appropriate fees in 2 copies. The registrar after getting the application will sign the first copy and return it while the other copy kept by them for acknowledging the genuineness of the society. Once the registrar is satisfied then an Incorporation Certificate will be issued with a registration number by them.<br/><br/>Electronically there are different websites for each state and the process began accordingly. The online society registration process is described below:",
          content: [
            {
              type: "process",
              title: "Online Registration Steps",
              steps: [
                {
                  step: 1,
                  title: "Login/Register on Portal",
                  description:
                    "Login on the SSO page. In case of new user of SSO portal then get yourself register by providing your e-mail id in it.",
                },
                {
                  step: 2,
                  title: "Select Society Registration",
                  description:
                    "Select society registration from the main menu.",
                },
                {
                  step: 3,
                  title: "Provide Details and Documents",
                  description:
                    "Provide required details of members and attach the documents as regarding to the details of members and registered office of society.",
                },
                {
                  step: 4,
                  title: "Save Application",
                  description:
                    "After verifying all the above provided details save the application.",
                },
                {
                  step: 5,
                  title: "Payment and Submission",
                  description:
                    "The applicant now requires to pay the registration fees and click on the submit button to forward the application to the registrar. Now the applicant can check the status on official website of society registration by providing application number over it.",
                },
                {
                  step: 6,
                  title: "Download Documents",
                  description:
                    "After the approval of registrar, the applicant is required to login again for downloading the By-laws and MOA of the Society.",
                },
              ],
            },
          ],
          description_after_table:
            "After getting the Bye-laws and MOA a society can now work as a legal person.",
        },
        {
          title: "Time Required in Society Registration",
          description:
            "After completing the incorporation requirements, it will take 12-15 days in getting approval and generation of registration certificate.",
        },
        {
          title: "Legal compliances after getting society registration",
          description:
            "After getting registration the society have to comply with the below stated regularities:",
          content: [
            {
              type: "h4",
              text: "Post-Registration Compliances",
              bullets: [
                "Obtaining PAN Card of society.",
                "Opening current account of society.",
                "Income tax return to be filed every year.",
                "AGM Resolution, accounts and members list to be filed with Registrar of Firms",
              ],
            },
          ],
        },
      ],
      features: [
        "Obtains a distinct legal identity",
        "Allows for the opening of a dedicated bank account",
        "Gains legal recognition for official purposes",
        "Qualifies for various benefits under the Income Tax Act",
        "Can legally enter into contracts",
        "Can sue and be sued as a legal entity",
      ],
      tables: [],
      faq: [
        {
          question: "Who all can form a society?",
          answer:
            "A society can be formed by any 7 or more persons associated for any literary, scientific or charitable purpose, or for any such purpose as described under section 20 of Society Registration Act.",
        },
        {
          question:
            "What action to be taken if more than one society in the same and similar name is registered?",
          answer:
            "According to the act, the name of society must be unique and should not be similar to any other registered society. Hence if any of such case is found than opportunity to represent their cases is being given to the concern persons and after hearing the enquiry if the case is found interrupted the action to cancel the society registration on later date is initiated.",
        },
        {
          question: "Can a society be dissolved?",
          answer:
            "Yes, a society can be dissolved by:<ul><li>Its members,</li><li>The registrar,</li><li>The court,</li><li>Government</li></ul>",
        },
        {
          question: "What are the rights of members of a society?",
          answer:
            "The rights of the society are described below:<ul><li>Right to receive notices.</li><li>Right to vote.</li><li>Right to receive copies of bye laws.</li><li>Right to receive statement of accounts.</li><li>Right to attend general meetings.</li></ul>",
        },
        {
          question: "How to download Incorporation Certificate of Society?",
          answer:
            "For downloading the incorporation certificate, one should login its SSO ID and click on Society Registration. Now click over the action button in front of application id of the applied society. Here an option to download MOA, Bylaws and incorporation certificate is provided.",
        },
        {
          question:
            "If the registered office place of society is taken on rent or lease then what is the documentary requirement while getting society registered?",
          answer:
            "The below documents are required in the above case:<ul><li>Utility Bill.</li><li>NOC of the owner.</li><li>Rent Agreement/Lease Agreement, whichever the case may be.</li></ul>",
        },
        {
          question:
            "Whether the members are personally liable for the debts of the society?",
          answer:
            "No, the members are not personally liable for any debt or liabilities of the society.",
        },
        {
          question: "Whether the society can be sued?",
          answer:
            "As society is a separate legal entity in front of forum and authorities after getting registered, so it has authority to sue anyone and can be sued as a legal person.",
        },
      ],
    },
  },
  "section-8-company": {
    title: "Section-8 Company Registration",
    hero: {
      title: "Section-8 Company Registration",
      description:
        "The Section 8 Company means a Company formed with an object to promote commerce, art, science, sports, research, education, religion, protection of the environment, charity or any other object, who intends to apply their income and profits in promoting their objects and prohibits the payment of dividend to its members.",
      advantages: [
        "Limited Liability Protection",
        "For social welfare activities",
        "Tax Benefits and Rebates",
        "Best option for opening NGO",
        "Less Procedural Compliances",
      ],
      eligibleCriteria: [
        "Minimum Two Directors",
        "Minimum Two Shareholders",
        "No Minimum Capital required",
        "Maximum Fifteen Directors",
        "One Director shall be Indian resident",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction",
          description:
            "The Section 8 Company means a Company formed with an object to promote commerce, art, science, sports, research, education, religion, protection of the environment, charity or any other object, who intends to apply their income and profits in promoting their objects and prohibits the payment of dividend to its members.<br/><br/><b>Governing Act:</b><br/>In India, Section-8 Company is regulated by the Indian Companies Act, 2013 (and the amendments thereof) and the rules & regulations that are made thereunder and is administered by the Ministry of Corporate Affairs, Government of India through the Offices of Registrar of Companies (‘RoC’).<br/><br/>Section 8 Companies are similar to a Trust or Society as the Societies and Trusts are registered under the State Government regulations whereas Section 8 Company is registered under the Central Government’s “Ministry of Corporate Affairs (MCA)”. This, however, has various advantages when it is compared to Trust or Society and it also has higher credibility amongst the donors, Government departments, and other stakeholders. There is no requirement to use the word “Limited” or “Private Limited” as the case may be.",
        },
        {
          title: "Benefits of Section-8 Company Registration",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "No requirement of minimum paid-up capital.",
                "Exempted from stamp duty while registering.",
                "Tax deductions benefits u/s 12AA and u/s 80G of Income Tax Act to the donors of the company",
                "Firms can also become its Members",
                "Less procedural Compliance than other entities",
              ],
            },
          ],
        },
        {
          title: "Requirements for the Incorporation of Section 8 Company",
          description:
            "Companies Act, 2013 has listed the following requirements for the incorporation of a Section 8 company.",
          content: [
            {
              type: "h4",
              text: "1. Document Required",
              bullets: [
                "<b>Minimum 2 Directors: </b><ul><li><b>Minimum Number of Members: </b>Two/Seven (Two if it is proposed to be incorporated as Private Limited and Seven in case of Public Company)</li><li><b>Minimum Number of Directors: </b>Two/Three (Two if it is proposed to be incorporated as Private Limited and Three in case of Public Company)</li></ul>",
                "<b>PAN Card: </b>Self-attested PAN Card of Members and Directors.",
                "<b>Identity Proof of Directors: </b>Directors- (Anyone out of the following -Valid Passport/Voter ID/Aadhar Card/Valid Driving License)",
                "<b>Address Proof of Directors: </b>Self-attested Address Proof of Members and Directors and Should Not be Older than 2 Months (Anyone out of the following – Bank Statement/Electricity Bill/Telephone Bill/Mobile Bill)",
                "<b>Passport Size Photo: </b> 2-2 Passport Size Colored Photos of Members and Directors.",
                "<b>Business Address Proof (Owned/Rent/Leased): </b>NOC from the Owner of Property/Property Papers (Title Deed)/Utility Bill (Either Electricity Bill or Mobile Bill or Telephone Bill) (Should Not be Older than 2 Months)",
              ],
            },
            {
              type: "h4",
              text: "2. Requirement of Information:",
              description:
                "<b>Authorized and Paid-up Share Capital of the Proposed Company and Number of Shares Subscribed by Members.</b><br>Explanation: A Company can be started with the minimum capital of Rs. 500000/- and 10 members and shall be treated as a Public company.",
              bullets: [
                "Place of Birth and Duration of Stay of Members and Directors at Present Residential Address.",
                "Occupation of Members and Directors.",
                "Proposed Object/Business of the Proposed Company.",
                "Educational Qualification of Members and Directors.",
                "Email IDs and Contact Number of Members and Directors.",
              ],
            },
          ],
        },
        {
          title: "Process of Section-8 Company Registration",
          description:
            "The Ministry of Corporate Affairs vides its notification dated 18th February 2020 effective from 23rd February 2020 has further amended the Companies (Incorporation) Rules, 2014 thereby substituting the old Form INC-32 (SPICe) with web service SPICe+ along with certain other amendments.",
          content: [
            {
              type: "process",
              title: "Registration Process",
              steps: [
                {
                  step: 1,
                  title: "Application for Reservation",
                  description:
                    "The first step is to make an application for reservation of name which shall be reserved by using the web services (SPICe+) available at www.mca.gov.in along with the specified fees. Before Applying for a name, kindly check that the name is available on <a href='https://www.mca.gov.in/content/mca/global/en/home.html' target='_blank'>MCA</a> as well as no trademark. Is there no such name under the Class of work you are going to apply.<br/><br/>The new integrated form consists of two parts i.e. PART A and Part B. The Name(s) of a company can be reserved in Part A of SPICe+. In case the applicant wants to apply for name, incorporation and other integrated services together, he can do so together by filling necessary information in Part A and Part B.",
                },
                {
                  step: 2,
                  title: "Fill the Part B of SPICe+",
                  description:
                    "The second step is to fill the Part B of SPICe+ for registering the Company. The said form contains various sections which allow you to save and modify information if required. while filling the said sections following attachments are required to be attached:-<ul><li>Memorandum of Association in Form INC-13</li><li>Articles of Association</li><li>Declaration in INC-14 by any CS/CA/CMA in practice stating that the draft memorandum and articles of association have been drawn up in conformity with the provisions of Section 8 of the Act and Rules made thereunder</li><li>Estimation of the future annual income and expenditure of the company for the next 3 years, specifying the sources of the income and the objects of the expenditure</li><li>Grounds on which the application is made</li><li>Brief description of the proposed activity</li><li>Statement of assets and liabilities</li><li>Declaration by each of the persons making the application in Form INC-15 i.e. a declaration that draft memorandum and articles of association have been drawn up in conformity with the provisions of Section 8 of the Act and Rules made thereunder</li><li>List of promoters (name, address, DIN or Income Tax PAN)</li><li>List of proposed directors (name, address, DIN or Income Tax PAN)</li><li>Application for Licence</li><li>Consent to act as Director in DIR-2</li></ul>",
                },
                {
                  step: 3,
                  title: "Convert SPICe+ Form into PDF",
                  description:
                    "The third step is to convert the SPICe+ form into a pdf format to affix the DSC.",
                },
                {
                  step: 4,
                  title: "Fill AGILE-PRO",
                  description:
                    "The fourth step is to fill the AGILE-PRO, where certain changes have been introduced which are as follows:-<ul><li>Mandatory registration of EPFO and ESIC.</li><li>Mandatory opening of Bank accounts.</li><li>Facility to obtain the GSTIN using the said form.</li></ul>The said form is also required to be converted into pdf form and DSC is to be affixed.",
                },
                {
                  step: 5,
                  title: "Upload Forms on MCA",
                  description:
                    "After affixing the DSC on the said forms are required to be uploaded on the Ministry of Corporate Affairs in accordance with the existing process.",
                },
                {
                  step: 6,
                  title: "Declare Company’s Subscribers & First Directors",
                  description:
                    "Declaration of all Subscribers and first Directors of the company which is currently being filed in Form INC-9 will be automatically generated in pdf format and shall be submitted only through Electronic form.<br/><br/>After the registration, the section-8 company can easily promote the respective fields such as commerce, art, sports or environment safety or whatever it is working for. Besides, the company registered under Section-8 need not pay any dividend to its members and the company still gets all the benefits of limited companies.<br/>Feel free to contact us for more information about Section 8 company registration.",
                },
              ],
            },
          ],
        },
      ],
      features: [],
      tables: [],
      faq: [
        {
          question: "Who can apply for Section-8 Company Registration?",
          answer:
            "Any person or Group of associated persons who are intending to register a limited liability company for the objects specified below can apply for the Company Registration or Formation under Section 8 of the Companies Act, 2013 . The following points have to be proved to the satisfaction of the Central Government that:<ul><li>Promotion of commerce, art, science, sports, education, research, and social issues like social welfare, religion, charity, protection of the environment or any other object is also included.</li><li>The company after incorporation intends to apply its profits, if any, or other income in promoting such objects only;</li><li>Payment of Dividend to the members should be prohibited by the company.</li></ul>",
        },
        {
          question:
            "Is it necessary that the name of Section -8 Company should include the word like Foundation, Forum, Association, Federation etc.?",
          answer:
            "Yes. in accordance with rule 8(7) of the Companies (Incorporation) Rules, 2014, for the Companies registered under Section 8 of the Act, the name of such Companies shall include the words foundation, Forum, Association, Federation and the like etc.",
        },
        {
          question:
            "Can a Company which has unlimited liabilities be registered as a Section 8 Company?",
          answer:
            "No, as per the Rules only a limited company registered the this Act or under any previous company law shall make an application to the Registrar for issue of license. Therefore, a company with unlimited liabilities cannot be registered as a Section 8 Company.",
        },
        {
          question:
            "Is there any relaxation in stamp duty payment in incorporation of a Section 8 Company?",
          answer:
            "Stamp duty on memorandum & articles of association of a Company or on any increase in share capital is governed by Indian Stamp Act, 1899 as adopted by respective state or stamp act of respective state, as the case may be. Some of the states provide privileged rates for stamp duty on MOA/ AOA of Section 8 Companies or on increase in authorized share capital.",
        },
        {
          question:
            "Can One Person Company become a member of the Section-8 Company?",
          answer:
            "No, Rule 3(6) of the Companies (Incorporation) Rules, 2014 prohibits one person company to invest in securities of any body corporate.",
        },
        {
          question:
            "Can a partnership firm or an Limited Liability Partnership become a member of Section 8 Company?",
          answer:
            "Yes, under the Companies Act, 2013, a Partnership firm or an LLP can become the member of Section 8 Company. The provisions of respective Acts need to be complied with by the partnership firm or LLP as the case may be.",
        },
        {
          question:
            "Can a Society registered under the Societies Act be converted in to a Section -8 Company?",
          answer:
            "Yes. Section 8(1) of the Companies Act, 2013 allows person or association of persons to be registered as a Section 8 Company on fulfillment of certain conditions and procedure as prescribed therein. The term “person” has not been defined in the Companies Act, 2013. Section 2(41) of the General Clauses Act, 1897 provides that “person” shall include any Company, or association or body of individuals, whether incorporated or not. Accordingly, a Society registered under the Societies Registration Act, 1860 is a person. Therefore, Society can be registered/converted as a Section 8 Company.",
        },
        {
          question: "How license can be cancelled?",
          answer:
            "Section 8 companies require a grant of a license by the Central Government. All such licenses are revocable as well on the following grounds:<ul><li>the company contravenes provisions of Section 8;</li><li>terms of the license are violated;</li><li>when its conduct is fraudulent, or it violates its own objectives and public policy.</li></ul>The Government can even order the company to be wound-up or amalgamated with another similar company under certain circumstances. The Government has to hear the company before passing such orders.",
        },
      ],
    },
  },
  "fcra-registration": {
    title: "FCRA Registration",
    hero: {
      title: "FCRA Registration",
      description:
        "Foreign contributions or income from nations outside of India are governed by the Foreign Contribution Regulation Act (FCRA). The FCRA was put into effect to make sure that foreign aid did not compromise India’s sovereignty or political integrity. Under the Foreign Contributions Regulation Act, non-governmental organizations, charitable organizations that accept funds from overseas, and foreign sources must register. The prior authorization procedure is used for registration with the FCRA registration department, which is part of the Ministry of Home Affairs. NGOs must register under the FCRA since they cannot accept donations from abroad directly.",
      advantages: [
        "Facilitates Foreign Investment",
        "Ensures Legal Compliance",
        "Permits Foreign Donations",
        "Enables Government Support",
        "Enhances Organizational Recognition",
      ],
      eligibleCriteria: [
        "Must be a registered NGO (Trust, Society, or Section 8 Company)",
        "In existence for at least three years",
        "Financial statements for the last three years available",
        "Minimum expenditure of Rs. 10 lakhs on core objectives",
        "Primary goal must be charitable or for societal service",
      ],
    },
    content: {
      overviews: [
        {
          title: "Benefits of FCRA Registration",
          description:
            "The benefits of FCRA registration are many. Some of them are-",
          content: [
            {
              type: "h4",
              text: "Key Benefits",
              bullets: [
                "<b>Foreign Investment:</b> The benefit of FCRA registration is continuous support and investment from foreign entities. Support can be from a registered foreign head office or another foreign entity.",
                "<b>Compliance:</b> Entities that are registered with the FCRA requirement would comply with the relevant regulations.",
                "<b>Donations:</b> FCRA registered entities can accept donations from foreign entities.",
                "<b>Government Support:</b> When organizations are registered under FCRA, it helps the organization to legally receive foreign contributions or government assistance. As a result, the applicant may utilize full-state assistance through this registration process.",
                "<b>Recognition:</b> Usually, this form of registration is done for companies and NGOs. NGOs relying on foreign funds require registration under FCRA requirements. An entity would have a good reputation in society.",
              ],
            },
          ],
        },
        {
          title: "Eligibility for FCRA registration",
          description:
            "The organization’s principal goal must be charitable work or societal service without a profit-making objective, such as in the areas of health, education, the arts, culture, entertainment, etc. The other criteria include-",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>Minimal term</b><br>The applicant must have been registered and in business for at least three years before requesting registration.",
                "<b>Accounting Statements</b><br>The last three financial years' financial statements must be signed by an authorized accountant, and both the revenue and expense statements and financial statements must be provided.",
                "<b>Minimal costs</b><br>The primary goal of the NGO was to receive a minimum of Rs. 10 lakhs, excluding any administrative costs.",
                "<b>Registering of an NGO</b><br>The applicant must be registered by the aforementioned Acts, including the Trusts Act of 1882, the Companies Registration Act of 1860, and Section 8 of the Companies Act, which requires that NGOs be registered under the Companies Act 2013.",
              ],
            },
          ],
        },
        {
          title: "Documents of FCRA Registration",
          description:
            "The documents required for FCRA Registration are as follows-",
          content: [
            {
              type: "h4",
              text: "Document Checklist",
              bullets: [
                "Certified copy of the certificate of incorporation or trust",
                "Data on the non-profit organization and PAN",
                "A copy of the founding agreement and articles of association",
                "Certificate issues as per under Section 12AB of the Income Tax Act",
                "Impression of the chief functionary",
                "Certified true copies of the governing body's resolution",
                "Detailed activity report for the previous 3 years",
                "Audited financial statements",
              ],
            },
          ],
        },
        {
          title: "Procedure to apply for FCRA registration",
          description: "The procedure to apply for FCRA Registration is-",
          content: [
            {
              type: "process",
              title: "Application Steps",
              steps: [
                {
                  step: 1,
                  title: "Visit FCRA Portal",
                  description:
                    "To begin the FCRA online registration process, go to the web site in step 1. To continue, click 'Forms'.",
                },
                {
                  step: 2,
                  title: "Select Application Form",
                  description:
                    "Depending on the type of registration, select either 'Application for FCRA Registration Form FC - 3A' or 'Application for FCRA Prior Permission-Form FC - 3B'.",
                },
                {
                  step: 3,
                  title: "Create Account",
                  description:
                    "After that, select 'Apply Online' and 'Sign Up' to create your username and password. Once the applicant has successfully registered, a message authenticating the account's creation will show up on the screen.",
                },
                {
                  step: 4,
                  title: "Login and Start",
                  description:
                    "To access your account, enter the username and password you previously created. Before continuing, select FCRA Registration from the list of options.",
                },
                {
                  step: 5,
                  title: "Initiate New Registration",
                  description:
                    "On the following screen, select 'FC-3' from the title bar to start a fresh registration procedure.",
                },
                {
                  step: 6,
                  title: "Fill Details",
                  description:
                    "Fill out the form completely, making sure to include the organization's name and contact details.",
                },
                {
                  step: 7,
                  title: "Enter Committee Details",
                  description:
                    "By selecting 'Executive Committee' from the navigation bar, complete the Executive Committee form.",
                },
                {
                  step: 8,
                  title: "Add Key Feature Details",
                  description:
                    "To add, remove, or amend key feature details, enter the required information in the 'Add key feature details' box.",
                },
                {
                  step: 9,
                  title: "Upload Documents and Pay",
                  description:
                    "Upload to the website the necessary PDF documents. Use one of the several payment options to complete the registration process.",
                },
              ],
            },
          ],
        },
        {
          title: "Validity of FCRA License",
          description:
            "An FCRA registration is valid for 5 years after its approval. If the registered entity is engaged in continuous activities, a renewal application must be submitted at least 12 months before the registration expires. At least six months before to the term’s expiration, the registered entity must notify the other party.",
        },
        {
          title: "Non-Compliances for FCRA Registration",
          content: [
            {
              type: "h4",
              text: "Penalties for Non-Compliance",
              bullets: [
                "Control and account seizure",
                "Up to five times the amount of the foreign donation in fines",
                "Confiscation and seizure of the contribution receipt",
              ],
            },
          ],
        },
        {
          title: "Final words",
          description:
            "Registration under the Law on the Regulation of Foreign Contributions offers many benefits to organizations engaged in social and charitable activities by facilitating the legal receipt of foreign contributions, expanding funding sources, increasing credibility, and enabling cooperation with international donors and partners.",
        },
      ],
      features: [],
      tables: [],
      faq: [
        {
          question: "Can you update your FCRA registration?",
          answer:
            "The FCRA registration certificate is valid for 5 years after it has been authorized. To keep the FCRA registration active, a renewal application must be submitted six months before the registration expires.",
        },
        {
          question: "Can donations be received in rupees from abroad?",
          answer:
            "Any donation made in foreign money or Indian rupees from a “foreign source” is classified as a “foreign contribution.”",
        },
        {
          question:
            "What is the yearly return filing deadline for FCRA-registered entities?",
          answer:
            "The FC-4 annual compliance form must be submitted on or before December 31st of each year, nine months following the end of the financial year.",
        },
        {
          question:
            "Can a foreign contribution be combined with local receipts?",
          answer:
            "No, contributions from abroad cannot be combined with local receipts.",
        },
        {
          question: "What type of annual return is filed?",
          answer: "FC-4 form.",
        },
        {
          question: "What form must be submitted to register for the FCRA?",
          answer: "FC-7 form.",
        },
        {
          question: "When is a renewal application required?",
          answer:
            "Six months before the registration’s validity period expiring, an application for an extension must be made.",
        },
        {
          question: "Who requires FCRA registration?",
          answer:
            "FCRA registration under the Foreign Contribution (Regulation) Act is required for organizations in India that receive foreign contributions or donations from foreign sources.",
        },
        {
          question: "Which organizations can apply for FCRA registration?",
          answer:
            "Entities eligible for registration under the Foreign Contribution Regulation Act include trusts, companies, and Section 8 companies registered under Indian laws.",
        },
        {
          question: "Can FCRA registration be revoked?",
          answer:
            "Yes, a company’s registration under the Foreign Contribution Regulation Act may be cancelled if it violates FCRA guidelines, engages in criminal activity, or fails to adhere to the Act’s requirements.",
        },
      ],
    },
  },
  "trademark-registration": {
    title: "Trademark Registration",
    hero: {
      title: "Trademark Registration in India",
      description:
        "Apply for Online Trademark Registration in India. Trademark your brand name & logo with the help of Trademark expert in India.",
      advantages: [
        "Establishes a public record",
        "Right to sue infringers in court",
        "Creation of Goodwill",
        "Protects the Brand Name",
      ],
      eligibleCriteria: [
        "Brand Name",
        "Brand Logo",
        "Numeric Combinations",
        "Name and Surname",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction",
          description:
            "In simpler terms, a trademark means a brand or logo which represents your business.<br/><br/>It is a visual symbol in the form of a word, signature, a device, or a label or numerals or combination of colours applied to articles of commerce to distinguish and indicate to the purchasing public that is a good manufactured or otherwise dealt in by a particular person as distinguished from similar goods dealt or manufacture by other persons to identify their products and/or services. Trademark registration in India laurels your product with an exquisite trademark that makes it superior to other products.<br/><br/>Trademark registration consultants are highly competent in providing trademark consulting services and they are well-acquainted with all the lawful needs that are important for trademark registration under Trade Marks Act, 1999.",
        },
        {
          title: "Legal Requirements for Trademark Registration in India",
          description:
            "The legal requirements for registering a trademark under the Trade Marks Act, 1999 are as follows:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>Graphic Representation</b><br/>The desired mark should be capable of being represented graphically.",
                "<b>Unique</b><br/>The trademark should be unique enough to distinguish the goods or services of one from products or services of others",
                "<b>Purpose Defining</b><br/>The desired mark should be in used or proposed to be used concerning goods or services to indicate or to stipulate a connection in the course of trade between the services or goods and some person have the right to use the mark with or without an identity of that person",
              ],
            },
          ],
          description_after_content:
            "Trademark registration not only give the brand an exquisite identity but also prevent fraudulent use of the trademark.",
        },
        {
          title: "How to Select a Trademark",
          description:
            "A trademark is to be selected carefully while launching a a product or goods or services. While selecting a trademark that the scope of legal protection you would obtain depends on the type of trademark chosen.<br/><br/>One must select a trademark that complies with government rules and can exclusively depict the high-quality & safety of your product or service.<br/><br/>For selecting a trademark a better strategy would be to adopt a coined word or an arbitrary word which has no reference or relevance to the goods/services upon which it is used.<br/><br/>Examples include Canon, Lotus Software.<br/>Advice from trademark registration consultants is yet another safe way to select a trademark that can stand the test of laws and times, as these professionals stay updated with amendments in legal acts and they have a good idea of changes which may arrive.<br/><br/>To have a broader scope of protection, a trademark should be more distinctive.",
        },
        {
          title: "Who can apply for Trademark",
          description:
            "Any person i.e. individual, company, proprietor or legal entity claiming to be the owner of the trademark may apply in writing in prescribed manner for registration.<br/><br/>The application should specifically contain the goods/services, name and address of applicant and agent (if any) with power of attorney, the tenure for which the trademark is intended to be used.",
        },
        {
          title: "Is registration of trademark important?",
          description:
            "Consumers purchasing decisions are always influenced by trademarks and the reputation such brands represent. A trademark indirectly puts forth a wide array of benefits of purchasing a particular brand.There are numerous benefits of Trademark registration.<br/><br/>Some of the benefits of registering a trademark in India are as follows:-",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>Protects your Brand Name</b><br/>Trademark registration prevents the fraudulent use of your trademark.",
                "<b>Builds trust & Goodwill</b><br/>Trademark registration built in the trust factor and goodwill among the minds of existing consumers as well as potential clients.",
                "<b>A Valuable Asset</b><br/>Trademark is a valuable asset that belongs just to you and for you. This asset can neither be snatched away nor be hampered and the benefits from it never perish.",
                "<b>Gives uniqueness to the brand and becomes easily Identifiable</b><br/>Trademark registration stamps your brand with a unique identity that makes your brand easily distinguished from others.",
                "<b>Serves as a lifelong support</b><br/>Trademark registration comes with life-time support. The benefits of a trademark are not limited to a certain period of time. It is a lifelong recognition.",
                "<b>For business expansion</b><br/>Once your trademark is registered, it represents your business even in the absence of your words. It helps you retain your existing customers, give a sense of authenticity to the potential customers and transform your target market into your permanent clients.",
              ],
            },
          ],
        },
        {
          title: "Documents required for Trademark Registration",
          description:
            "Documents which are required for the registration of a trademark are as follows:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>ID Proof</b> (Driving License, Voter ID card or passport, pan card, aadhar card)",
                "<b>Brand Name</b> (a soft copy of brand name and logo to be registered)",
                "<b>Power of Attorney</b>",
                "<b>Board Resolution</b> (in case the Company is the applicant)",
              ],
            },
          ],
        },
        {
          title: "Trademark Classification and Classes",
          description:
            "Trademark classification and classes lead to the preparation of a hierarchy that showcases which trademark is being adopted under which category. This facilitates the government bodies to easily work with the trademark classes list at national as well as international levels.<br/><br/>A sum of 45 classes of a trademark is there for different goods and services. Out of the total of 45, 34 is for products while 11 is for services.",
        },
        {
          title: "Process of Trademark Registration in India",
          description:
            "The whole process of registration of a trademark can be divided into the following steps:",
          content: [
            {
              type: "process",
              title: "Trademark Registration Process",
              steps: [
                {
                  step: 1,
                  title: "Trademark Search",
                  description:
                    "The first and foremost step for the registration of a trademark is to search for the availability of the proposed name. Picking up a brand name that is catchy, different, trendy as most of the generic names would already be in someone’s hands.<br/>There are two ways to test its availability - one by searching word marks and the second is phonetically under the required class. Once found to be unique you can proceed to the next step.",
                },
                {
                  step: 2,
                  title: "Submission of Documents",
                  description:
                    "The next step is to submit the documents and to begin with the same information is submitted to the department in the form of application to be submitted online. Documents can be submitted to Trademark registration consultants and he shall thoroughly check the documents followed by the submission of the same to the Registrar online.",
                },
                {
                  step: 3,
                  title: "Preparation of TM application",
                  description:
                    "The Trademark application is prepared in Form TM-A by logging on the portal which can be done by the Applicant/Proprietor or Agent or the Attorney of such applicant/Proprietor or Trademark registration consultants. The relevant information is required to be entered in the respective tabs. The information as entered can be saved and modified before the submission. If you avail the Trademark registration services from the concerned consultants, you keep getting notifications about the status of trademark application via SMS or Email.",
                },
                {
                  step: 4,
                  title: "Trademark challan",
                  description:
                    'Upon the successful submission of trademark Application to the registrar in TM-A form, a Challan is generated which contains the trademark application no., date of filing and applicant name along with attorney name. This serves as proof that the application is successfully submitted to the registrar and is pending under the governmental process.<br/><br/>The evidence of successful applicants must be kept safe with you or if you have extended the responsibility of trademark registration to a Trademark registration consultant, he shall bear the complete responsibility to take care of the same.<br/><br/>The applicant can start using a filled mark by writing "TM" upon receiving the challan.',
                },
              ],
            },
          ],
        },
        {
          title: "Trademark Registered",
          description:
            "On the successful completion of the above-mentioned four steps, it takes around one year to get the desired mark registered. It is a long process to get the “R” Mark.<br/><br/>Upon the acceptance of the application request by the registrar, the same is published for four months in the journal for third-party opposition. Further, if no objection is received by the Registrar, then the proposed mark will be registered by him within the period of 6 months which shall be valid for ten years and can be renewed by filing a renewal application within 6 months before the expiry of 10 years.",
        },
        {
          title: "Government fees for Trademark Registration",
          table: {
            title: "Government fees for Trademark Registration",
            headers: [
              "S. No.",
              "Type of application or applicant",
              "The amount for Offline Filing (in INR.)",
              "The amount for Online Filing (in INR.)",
            ],
            rows: [
              [
                "1.",
                "Application for registration of a trademark /collective Marks / Certification Mark / Series of trademark for specification of goods or services included in one or more than one classes.",
                "Rs. 5,000",
                "Rs.4,500",
              ],
              [
                "2.",
                "Where the applicant is an Individual / Startup/Small Enterprise",
                "Rs. 5,000",
                "Rs. 4,500",
              ],
              [
                "3.",
                "In all other cases (Note: Fee is for each class and for each mark)",
                "Rs. 10,000",
                "Rs. 9,000",
              ],
            ],
          },
          description_after_table:
            "You can simply entrust a recognizable sign, expression or design to your product by choosing a trademark for it. The delegation of the trademark and service mark to your products and services offer a wide array of benefits to your business apart from legal distinguished identification.",
        },
      ],
      features: [
        "Protects your Brand Name",
        "Builds trust & Goodwill",
        "A Valuable Asset",
        "Gives uniqueness to the brand and becomes easily Identifiable",
        "Serves as a lifelong support",
        "For business expansion",
      ],
      tables: [],
      faq: [
        {
          question: "What is a Trademark?",
          answer:
            "Trademark is an intellectual property right consisting of a recognizable sign or a design in order to identify the products or services from a specific source, although the trademarks that are used to identify services are called as service marks.",
        },
        {
          question: "What can be registered as Trademark?",
          answer:
            "A trademark is simply any word, name, symbol etc. which is used to identify and to distinguish the products or services of one specific seller or service provider from those of the other competitors in the market. It also indicates the source of products or services.",
        },
        {
          question: "What Trademarks are not Register able?",
          answer:
            "The TM logo granted right after the filing of application indicates an unregistered trademark which is still distinguished from the similar products or services. According to the Trademark Act, an unregistered Trademark does not get a total protection and it cannot be prevented from a third party from using the same mark.",
        },
        {
          question: "What is Trademark class?",
          answer:
            "A Trademark classes refers to the description of goods to which the marks are applicable. It is a procedure by which examiners and the trademark attorneys arrange the required documents including trademark and service mark application.",
        },
        {
          question: "How long Does it take to file a Trademark application?",
          answer:
            "The word TM can be used right after the filing of application but usually it takes at least 6 months to get it registered.",
        },
        {
          question:
            "What documents are required to file a Trademark application?",
          answer:
            "<ul><li>ID Proof (Driving License, Voter ID card or passport, pan card, aadhar card)</li><li>Brand Name (a soft copy of brand name and logo to be registered)</li><li>Power of Attorney</li><li>Board Resolution (in case the Company is the applicant)</li></ul>",
        },
        {
          question:
            "What are the different kinds of trademarks that can be registered?",
          answer:
            "<ul><li>A name (personal or surname of the applicant or the person’s signature)</li><li>A newly coined or invented word or any other arbitrary word from dictionary, not being vividly descriptive of the character or quality of the product or service</li><li>Alphanumeric or letters or numerals or combination of them</li><li>Image, Symbol, Monograms, 3D shapes, letters etc.</li><li>Sound marks in audio format.</li></ul>",
        },
        {
          question: "How long is a registered trademark valid for?",
          answer:
            "The Registered Trademarks are valid for 10 years from the date of filing of the application. The trademark owner can file for the renewal of trademark in order to keep it protected for more time prior to the end of the validity.",
        },
        {
          question:
            "Can a registered trademark be transferred to any other person?",
          answer:
            "Yes, a registered trademark can be transferred from one person to another.",
        },
        {
          question: "How much does it cost to register a trademark?",
          answer:
            "As far as the Government fees is concerned, the costs for making an online application for the Trademark Registration is Rs. 4500/- and for Small Enterprises and Rs. 9000/- for Big Enterprises for each class of use.",
        },
        {
          question:
            "Is the trademark liable for reduction or removal on the ground of non-use?",
          answer:
            "Yes, a registered trademark can be replaced or be removed on the ground of non-use. Although as excused in clause 3 of section 47 of trademarks act, 1999",
        },
      ],
    },
  },
  "copyright-registration": {
    title: "Copyright Registration",
    hero: {
      title: "Copyright Registration",
      description:
        "Apply for Copyright Registration through our Experts to protect your work from being misused. Benefits, Who can apply.",
      advantages: [
        "Establishes a public record",
        "Right to sue infringers in court",
        "Creation of Goodwill",
        "Legal Protection to Work",
        "Protection after owners’ death",
      ],
      eligibleCriteria: [
        "Cinematography film",
        "Computer programs",
        "Website",
        "Published",
        "Artistic work",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction to Copyright Registration",
          description:
            "With the increasing awareness among people regarding the intellectual property rights and also with the continuous advancement in technology, there is a rush amongst the number of intellectual property rights’ registration in India. Several tailor-made solutions in the zones of Intellectual Property Rights are available today to safeguard the business through Copyright, Trademark, Patents and Registration.<br/><br/><b>An Overview</b><br/>Copyright is the legal right to ownership and enjoyment entitled to creators of literary, dramatic, musical, artistic work, producers of cinematograph films, and recordings. In India, copyright registration provides its owner exclusive, sole right to distribute, reproduce, adapt, translate the work, or give authorization to another entity for performing the same.<br/><br/>Copyright Registration is often used by many businesses for producing their literature or user manuals. It provides certain safeguards to the owner such as the right of ownership and enjoyment of the authors over their creations and consequently allows them to protect and reward their creativity.<br/><br/>Copyrights Act, 1957 also provides the right to transfer from the person owning the said Copyright to another or the person’s employer who had commissioned it.",
        },
        {
          title: "Who Can Apply for Copyright Registration",
          description:
            "Any person who has produced any literary, dramatic, musical, artistic work, cinematograph film, or sound recording which is original in nature and not have been previously registered or applied for registration are eligible to get it registered under the Copyright Act, 1957. The Invention produced or prepared must be original and useful in nature.<br/><br/>In India, Copyrights are mainly classified under three classes of work and each of the classes provides its distinctive right.<br/><br/><b>Individuals who are legally accountable for the submission of a copyright application are as follows:</b>",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>The Author</b>- This can either be an individual who has invented the work or the boss or for whomever the work was invented, in case of “made for hire” work.",
                "<b>The Copyright Claimant</b>- This can either be the author or an organization or an individual who has received ownership rights from the author either via written contract/assignment/will or any other transfer of rights.",
                "<b>The Authorized Agent</b>- Any individual or institution duly authorized to perform on author’s behalf, other copyright claimant or a holder of exclusive rights.",
                "<b>The Owner of Exclusive Rights</b>- An owner of any of the exclusive rights that form a copyright to be transferred and separately owned.",
              ],
            },
          ],
        },
        {
          title: "Benefits of Copyright Registration",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>Protection to the invention</b><br>Registration of Copyrights protects the invented work from being copied or misused by any unauthorized person be it individual or entity and also ensures certain minimum safeguards over the creation.",
                "<b>Value addition to intangible assets or skills</b><br>Registration of Copyrights adds value to the intangible assets of the business or person.",
                "<b>Right to sue</b><br>Registration of copyright entitles the owner with a right to sue and file a suit in case of illegal use and infringement.",
                "<b>Builds trust & brand image</b><br>Registration of copyright helps in the trust development and creation of a brand image among consumers.",
              ],
            },
          ],
        },
        {
          title: "Information Required for Copyright Registration",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "Name of Applicant*",
                "Full Address of the Applicant*",
                "Nature of Work produced which shall include the class, description, title and language of work (if required)",
                "Date of Publication (If published)",
              ],
            },
          ],
          description_after_content: "* Proof to be provided for point 1&2",
        },
        {
          title: "How to Register a Copyright?",
          description:
            "The whole process of copyright registration can be divided into four steps:",
          content: [
            {
              type: "process",
              title: "Copyright Registration Process",
              steps: [
                {
                  step: 1,
                  title: "COLLECTION OF REQUIRED DOCUMENTS",
                  description:
                    "Basic documents as stated above are required along with an authorization letter signed by you for filing of application. So, the steps ask for the collection of all these imperative documents.",
                },
                {
                  step: 2,
                  title: "APPLICATION FOR REGISTRATION",
                  description:
                    "The next step is to file an application for the registration. Applications must be prepared and submitted to the Registrar of Copyright in the prescribed format. This can either be done via the offline method or online within 2 working days. After that, the Registrar issues a Diary No., and a waiting period of 30 days is mandatory for receiving objections (if any).",
                },
                {
                  step: 3,
                  title: "CONDUCT HEARING",
                  description:
                    "In case when any objection is received by the Registrar, a hearing on the application of copyright is conducted. The scrutinizer checks the application for any disparity, if no objections are received within the prescribed time of 30days.",
                },
                {
                  step: 4,
                  title: "REGISTRATION OF WORK",
                  description:
                    "In the absence of any disparity, the registration process is completed and the extract of the same is sent to the Registrar for entry.<br/><br/>If a case of disparity, on successful completion of hearing conducted by the Registrar the scrutinizer will again scrutinize the application and will give its decision.<br/><br/>Copyright registration consultants handle the whole process of copyright registration that starts with the collection of documents, continues with application filling, and ends at approval.",
                },
              ],
            },
          ],
        },
        {
          title: "Validity of Registered Copyright",
          description:
            "The Copyright registered is valid for 60 years. In case literary, dramatic, artistic or musical work the 60 years are counted from the year following death of author and in case of sound recordings, cinematographic films, photographs, anonymous, posthumous publications, pseudonymous publication, work of international organization and work of government, the period for 60 years starts from the date of publication.",
        },
      ],
      features: [
        "Protection to the invention",
        "Value addition to intangible assets or skills",
        "Right to sue",
        "Builds trust & brand image",
      ],
      tables: [],
      faq: [
        {
          question:
            "What type of works can be protected under the Copyright Act, 1957?",
          answer:
            "The Copyright subsists throughout the India in the following classes of works which are as follows:<ul><li>Original literary, dramatic, musical and artistic works;</li><li>Cinematograph films; and</li><li>Sound recordings</li></ul>",
        },
        {
          question:
            "What is the criterion required for the works to be qualified for copyright protection?",
          answer:
            "Any work which is falling under any of the categories as mentioned above and the said work is seeking to be copyrighted needs to be original; Though, it is not necessary that the said work should posses some original thought or idea. The law is only concerned with the originality of the expression of thought.",
        },
        {
          question: "Who can apply for the Copyright protection in India?",
          answer:
            "Individuals who are legally accountable for the submission of a copyright application are as follows:<ul><li>The Author – This can either be an individual who has invented the work or the boss or for whomever the work was invented, in case of “made for hire” work.</li><li>The Copyright Claimant – This can either be the author or an organization or an individual who has received ownership rights from the author either via written contract/assignment/will or any other transfer of rights.</li><li>The Authorized Agent – Any individual or institution duly authorized to perform on author’s behalf, other copyright claimant or a holder of exclusive rights.</li><li>The Owner of Exclusive Rights – An owner of any of the exclusive rights that form a copyright to be transferred and separately owned.</li></ul>",
        },
        {
          question: "What are the rights granted to the copyright holder?",
          answer:
            "A copyright registered grants protection to the right holder/creator and his/her representatives for the works and prevents such works from being copied or reproduced without the prior consent.<br/><br/>The creator/originator of a work can prohibit or he/she/it can authorize anyone to:<ul><li>reproduce the said work in any form, such as prints, sound, video, etc;</li><li>use the said work for a public performance, such as a play or a musical work;</li><li>make copies or recordings of the work, like via compact discs, cassettes, etc.;</li><li>broadcasting it in various forms; or</li><li>translating the same to various other languages</li></ul>",
        },
        {
          question:
            "Are any moral rights protected under the Copyright Act, 1957 (like rights to be identified as an author of a work or to object to the derogatory treatment of a work)?",
          answer:
            "Yes, the Copyright Act, 1957 grants the author “special rights,” which exist independently and solely with the author’s copyright, and subsists with him/her even after the assignment (wholly or partially) of the said copyright. There are following right granted to the author which are as follows:-<ul><li>Right to claim authorship of the work; and</li><li>Right to restrain or claim damages with respect to any distortion, mutilation, modification, or other act in</li><li>Relation to the said work if such distortion, mutilation, modification, or other act would be prejudicial to.</li><li>his honor or repute</li></ul>These are the special rights which can also be exercised by the legal representatives/heirs of the author.<br/><br/>The right against the distortion is available even after the expiry of the term of a copyright after the recent amendment as earlier, it was available only against the distortion, mutilation etc. done during the term of copyright of the work.",
        },
        {
          question:
            "For how much time do the moral rights subsist in copyright works?",
          answer:
            "The author’s moral right as a right against the distortion is available even after the expiry of the term of the copyright.",
        },
        {
          question:
            "Can a copyright in a work be jointly owned by the individual? If yes, what are the rights of the co-owner?",
          answer:
            "As per the Copyright Act, the “work of joint authorship” means a work produced by with the collaboration of two or more authors in which the contribution of one author is not different from the contribution of the other authors. Hence, the Act recognizes the joint authorship. The Joint authors fully enjoy all of the rights granted under the Act. The tenure of copyright of a work in case joint authorship is calculated with respect to the author that dies last.",
        },
        {
          question:
            "What step should be taken to validly transfer, assign or license the copyright?",
          answer:
            "An assignment of the copyright shall be valid only if it is reduced to writing duly signed by the assignor or by his/her authorized agent.",
        },
        {
          question:
            "Under what circumstances the Copyright be used without a license?",
          answer:
            "Following are the special circumstances under which a copyright can be used without a license:<ul><li>For the purpose of private study, research or entertainment etc.</li><li>Quoting for an appropriate portion from the Copyright work</li><li>Reporting of the current events in newspapers, magazines or radios/television etc.</li><li>Translation or reproducing it in small quantity for use by the teachers or scientific researches</li><li>Performance free of charge</li><li>Copying, drawing, photographing or recording an artistic work which is placed or displayed in an outdoor public space</li><li>Usage by government officials in performance of their duties</li></ul>",
        },
        {
          question: "What is the duration of copyright in protected works?",
          answer:
            "The duration of protection for the copyright works varies with the type of work and the date of creation.",
        },
      ],
    },
  },
  "design-registration": {
    title: "Design Registration",
    hero: {
      title: "Design Registration",
      description:
        "Get your Online Design Registration from anywhere in India by our experts. Eligibility, Documents, Process for Registration.",
      advantages: [
        "Establishes a public record",
        "Right to sue infringers in court",
        "Creation of Goodwill",
        "Legal Protection to Work",
        "Marketing",
      ],
      eligibleCriteria: [
        "New and original",
        "Not opposed to public order",
        "Appealable to eye",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction",
          description:
            "Design registration is a type of intellectual property right governed by the Design Act, 2000 which helps to protect any newly created shape, configuration, patterns and composition of lines or colours applied to an article created under an industrial process from counterfeiting.<br/><br/>However, to get a design registered, it must fulfill some conditions. These conditions are as follows:<ul><li>It must be newly invented and original in nature</li><li>The design should relate to features, configuration, shape, pattern or ornament applied to an article</li><li>The design applied to any article must be by an industrial process</li><li>The design must appear on the final product and must be visible;</li><li>It should not deal with anything which is covered under the trademark, copyright or patent registration.</li></ul>",
        },
        {
          title: "Eligibility Norms for Design Registration",
          description: "One must unfailingly meet the eligibility norms.",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "It should be new and original",
                "It should be close or near to any other existing design or a combination of known designs",
                "It should not be a mere mechanical contrivance",
                "It must not be in opposition to public order",
              ],
            },
          ],
        },
        {
          title: "Who can apply for Design Registration?",
          description:
            "Any person stating to be the owner or proprietor of the new and original design which is not previously published anywhere and which is also not contrary to the public morality can apply for the registration of the same.<br/><br/>Further, any agent or design registration consultant may also apply for the registration on behalf of its owner.",
        },
        {
          title: "Documents and Details Required for Design Registration",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "Name of the Applicant along with its full address.",
                "Certified True Copy of the Power of Attorney (if any) given to the Agent duly signed by the proprietor, partner or one of the Directors of the Company",
                "Affidavits in paragraph form containing a declaration of its truthfulness and verifiability",
                "Documentary proof of priority required in the case if any previous registration or application for registration made",
              ],
            },
          ],
        },
        {
          title: "Information Required",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "Applicant’s Name, Address, and nationality. In case the applicant is not a natural person than a documentary proof stating the legal status and the place of incorporation",
                "Name of the article to which the design is to be applied.",
                "A short & precise statement of the novelty that one lay claim to be his design",
                "Class or category of the article representing the design",
                "Applicants or applicants’ name(s), age, address (es), and nationality (ies) whether they are partners in a firm or Directors of the firm or company",
                "Name, address, designation, and nationality of the person who signs the General Power of Attorney",
              ],
            },
          ],
        },
        {
          title: "Process for Registration of Design",
          description:
            "The whole process of design registration can be divided into the steps mentioned below:",
          content: [
            {
              type: "process",
              title: "Design Registration Process",
              steps: [
                {
                  step: 1,
                  title: "Application",
                  description:
                    "Submit an application specifying the details such as name & address, applicant’s information- a person or company, description of the article & its type, claim of novelty and so on. One may also enclose images or drawing of the article in the application form.",
                },
                {
                  step: 2,
                  title: "Acceptance of application & registration",
                  description:
                    "Application duly filled in the prescribed form signed either by the applicant or by his authorized agent along with the requisite documents and is thereafter examined by the Design Office and objections if any are raised to that. Further, the Design Office issues a Certificate granting Copyright in Registered design after the objections if any rose is being removed to the satisfaction of the Department.",
                },
                {
                  step: 3,
                  title: "Publication & Validity",
                  description:
                    "Post-registration of the design, the same is notified in the official journal. The registered design is valid for 10 years which may be further extended to another 5 years on the filing of an application for extension with payment of the prescribed amount.",
                },
              ],
            },
          ],
          description_after_content:
            "A Design Registration Consultant tracks and takes all necessary steps needed at every stage of the design registration process until the design gets registered successfully and also stands by the ethical standard of your creativity.<br/><br/>Design registration makes a design an intellectual property and intangible asset for a period of ten years which can be further extended for a limited period of five years through design renewal. Also, it provides the owner with an exclusive right to use, sell, franchise or contract the design.<br/><br/>After the registration of the design, the owner also gets specific legal rights to take actions against those who breach the design right.",
        },
      ],
      features: [
        "Establishes a public record",
        "Right to sue infringers in court",
        "Creation of Goodwill",
        "Legal Protection to Work",
        "Marketing",
      ],
      tables: [],
      faq: [
        {
          question: "What do you mean by Design under the Design Act, 2000?",
          answer:
            "As per Section 2(d) of the Design Act, 2000<br/><br/>“Design means only the features of shape, configuration, pattern or ornament or composition of lines or colour or combination thereof applied to any article whether two dimensional or three dimensional or in both forms, by any industrial process or means, whether manual, mechanical or chemical, separate or combined, which in the finished article appeal to and are judged solely by the eye, but does not include any mode or principle or construction or anything which is in substance a mere mechanical device, and does not include any trade mark, as define in clause (v) of sub-section of Section 2 of the Trade and Merchandise Marks Act, 1958, property mark or artistic works as defined under Section 2(c) of the Copyright Act, 1957.”",
        },
        {
          question:
            "What are the eligibility norms for registering an article?",
          answer:
            "<ul><li>It should be new and original;</li><li>It should be close or near to any other existing design or a combination of known designs;</li><li>It should not be a mere mechanical contrivance;</li><li>It should be appealable to the eye and be applied to an article;</li><li>It must not be in opposition to public order.</li></ul>",
        },
        {
          question: "Who can apply for the Design Registration?",
          answer:
            "Any person who claims to be the proprietor of any new or original article may apply for its registration. A proprietor may be either from India or from a Convention Country.<br/><br/>A proprietor can be any of the following:<ul><li>an author of the design,</li><li>a person who has acquired the said design,</li><li>a person for whom such design has been developed by the author, or</li><li>a person on whom they said design has devolved.</li><li>The application for such registration of design can be filed by the applicant either by himself or through a professional person (i.e. patent agent, legal practitioner). However, for the applicants who are not residing in India, address of an agent residing in India can be used as address for services.</li></ul>",
        },
        {
          question:
            "What is the right time to apply for the Design Registration?",
          answer:
            "The Application for the Design Registration must be filed before making such design available to the Public as the novel Design cannot be given for registration. It is also to be taken care that the Design Registration is granted to the person whoever files the application first.",
        },
        {
          question: "Can the Design Registration be renewed?",
          answer:
            "No, there is no such provision for renewing the term of the Design registration once a period of 15 years is over.",
        },
      ],
    },
  },
  "patent-registration": {
    title: "Patent Registration",
    hero: {
      title: "Patent Registration",
      description:
        "Govind Sinha & Co. is a leading Online Patent Registration. Meaning, Criteria, Procedure for Filing a Patent Application. Submit your details.",
      advantages: [
        "Establishes a public record",
        "Right to sue infringers in court",
        "Creation of Goodwill",
        "Legal Protection to Work",
        "Marketing",
      ],
      eligibleCriteria: [
        "Ordinary application",
        "Conventional application",
        "Provisional application",
        "PCT International application",
        "PCT National phase application",
      ],
    },
    content: {
      overviews: [
        {
          title: "Meaning of Patent",
          description:
            "A patent can be defined as a form of intellectual property that grants the right to its owner to expel others from using, making, selling or importing the invention for a definite span of time, in exchange of releasing a sanctioning public acknowledgement of the creation.<br/><br/>In simple words, a patent is a secured invention or the special right given to an inventor by a government to manufacture, sell or use the invention for a defined number of years.",
        },
        {
          title: "Patent Registration",
          description:
            "In India, patent registration is applicable either with provisional or complete specification. It is a preliminary step where an applicant files the patent application where he/she feels that the invention has turned to reach such a stage wherein it can be disclosed on paper but has not attained its final stage. It is an option to secure and temporarily protect their invention in an inexpensive way until they decide to file the full patent application or an application with complete specification.",
        },
        {
          title: "Provisional Patent",
          description:
            "Provisional Patent has a pendency period of 12 months from the date of filling after which the inventor is required to file a complete specification in order to take advantage of provisional specifications. If the inventor fails to file the complete specification within the period of 12 months the patent application with provisional specification is deemed to be abandoned.",
        },
        {
          title:
            "Points to be covered while Drafting Provisional Specification",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "It should contain the title as well as the description of the invention",
                "It should start with a preamble “The following specification describes the invention”",
                "The second page should begin with the description of the invention beginning with the field of invention, background, object and statement of invention",
                "The applicant must provide as much as information which he/she may have at the time of filing of the application.",
                "Claims are not recorded under the provisional specification; they are covered under complete specification",
              ],
            },
          ],
        },
        {
          title: "Criteria For Patent Registration",
          description:
            "In India, Patent laws are governed by the Indian Patent Act, 1970 which looks after the registration, renewal, transfer, and protection of patents in India. Following criteria must be fulfilled in order to identify the patentable article:-",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "Patentable subject matter which is decided in accordance with section 3 or 4 of the Patent Act List.",
                "A novelty which means it should be a new invention with no same or similar prior arts. It should not have been published in a public domain.",
                "The step taken for registration must be an inventive step not obvious to a person skilled in the same file to which such invention relates.",
                "The invention must have a practical utility which means it should be capable of being applied in any industry.",
                "Claims are not recorded under the provisional specification; they are covered under complete specification.",
              ],
            },
          ],
        },
        {
          title: "Procedure for Filing a Patent Application",
          content: [
            {
              type: "process",
              title: "Patent Filing Process",
              steps: [
                {
                  step: 1,
                  title: "Documents Required",
                  description:
                    "It is always advisable to conduct a patent search in case of registration of any intellectual property right which will help the inventor or Patent Attorney to identify the novelty of the patent and its obviousness. It helps the inventor to draft the patent application in a better way and also to extend the scope of its invention which distinguishes it from the existing inventions.",
                },
                {
                  step: 2,
                  title: "Patent Drafting",
                  description:
                    "After conducting a patent search, the application is prepared in a techno-legal language known as specification i.e. either provisional or complete. The Provisional specification is always prepared without claims and the complete specification is prepared with claims. The inventions state the description of the invention beginning with the field of invention, background, object and statement of invention and best possible method to perform an invention which can be performed by the skilled person.",
                },
                {
                  step: 3,
                  title: "Patent Application Filing",
                  description:
                    "A Patent application is filed for obtaining a patent which can be either filed as a provisional application or a complete specification.<br/><br/>A Provisional specification is filed in order to obtain a priority date over other applications. An application is prepared according to the Indian Patent Act, 1970 consisting of a series of forms.<br/><br/>If the applicant opts for provisional specification a time period of 12 months is allowed to file a complete specification.",
                },
                {
                  step: 4,
                  title: "Patent Publication",
                  description:
                    "After completing the above-mentioned process, the application is published in an official journal after the expiry of 18 months from the date of filing or date of priority whichever is earlier. The Patent, when published in a journal, is open for objection (if any).",
                },
                {
                  step: 5,
                  title: "Patent Examination/Prosecution",
                  description:
                    "After publication, a request for examination is to be filed within 48 hours of filling date or date of priority whichever is earlier.<br/><br/>Thereafter, the patent examiner inspects the patent application and issues an examination report which contains a series of objections if any raised by the examiner.<br/><br/>Subsequently, to the result of the examination report, it has to be filed within 12 months from the issue of the examination report.<br/><br/>If the examiner thinks fit to call and conduct a hearing with the applicant or its agent this process is termed as Patent Prosecution.",
                },
                {
                  step: 6,
                  title: "Granting The Patent",
                  description:
                    "If the examiner is satisfied with the response provided by the applicant or its agent, the application is put in order for grant and if the examiner is not satisfied with the reply and arguments then he may reject the same.",
                },
              ],
            },
          ],
        },
      ],
      features: [
        "Establishes a public record",
        "Right to sue infringers in court",
        "Creation of Goodwill",
        "Legal Protection to Work",
        "Marketing",
      ],
      tables: [],
      faq: [
        {
          question: "What is the need of patenting an invention?",
          answer:
            "The patent filing is important in order to possess an exclusive rights over the invention. If one doesn’t protect the same under the law, anyone can exploit it commercially once it becomes available to the public. The patent is also protected to restrict others from utilizing, selling, or making copies of the same.",
        },
        {
          question: "What can be patented and the criteria for registration?",
          answer:
            "There must be an invention which needs to have below mentioned three main qualities to be patentable:<ul><li>Patentable subject matter which is decided in accordance with section 3 or 4 of the Patent Act List</li><li>novelty which means it should be a new invention with no same or similar prior arts.& it should not have been published in a public domain.</li><li>The step taken for registration must be an inventive step not obvious to a person skilled in the same file to which such invention relates.</li><li>The invention must have a practical utility which means it should be capable of being applied in any industry.</li><li>Claims are not recorded under the provisional specification; they are covered under complete specification</li></ul>",
        },
        {
          question: "Who can apply for the Copyright protection in India?",
          answer:
            "What do you mean by new invention as per the Indian Patent Act?<br/><br/>New invention means any invention or technology with respect to a product or process which has not been anticipated by any publication in a document or used in the country or elsewhere in the world before the date of filing of the application with complete specification, i.e. the subject matter has not appeared in public domain or that it does not form part of the state of the art.",
        },
        {
          question: "Who can apply for patent registration?",
          answer:
            "A patent application can be filed either by first and true inventor or his/her assignee, either alone or jointly with any other person.<br/><br/>In case of any deceased person his/her legal representative, who immediately before his/her death was entitled to file an application for patent<br/><br/>The application for patent can also be made by the virtue of an assignment of the right to apply for a patent for the invention.",
        },
        {
          question: "What is a provisional specification?",
          answer:
            "A provisional specification is a patent document which is filed to establish priority of the invention in case the disclosed invention is only on a conceptual stage and a delay is expected in submitting the full and specific description of the invention.<br/><br/>Provisional Patent has a pendency period of 12 months from the date of filling after which the inventor is required to file a complete specification in order to take advantage of provisional specifications. If the inventor fails to file the complete specification within the period of 12 months the patent application with provisional specification is deemed to be abandoned.",
        },
        {
          question: "What is a complete specification?",
          answer:
            "A Complete Specification is a techno-legal document which contains full scientific details of the invention and claims to the patent rights. For obtaining a patent, an applicant must be fully and particularly describe the respective invention therein claimed in a complete specification. The disclosure of the invention in a complete specification must be made such that a person skilled in the art may be able to perform the invention.",
        },
        {
          question:
            "Can a disclosed or published invention be patented in India?",
          answer:
            "The Publication of an invention before filing of the patent application would disqualify the invention to be patentable because of the disclosure of invention by way of publication is detrimental to novelty of the invention.<br/><br/>Hence, the inventor should not disclose their inventions before filing of the patent application. The invention should be considered for publication after a patent application has been filed.",
        },
        {
          question:
            "When is an application for the patent be published by the Patent Office in India?",
          answer:
            "Every application for patent is published after the expiry of 18 months from the date of its filing or priority date whichever is earlier. However, following applications cannot be published.<ul><li>Application in which secrecy direction is imposed</li><li>Application which has been abandoned u/s 9(1) and</li><li>Application which has been withdrawn 3 months prior to 18 months</li></ul>The every application when published should include the particulars of the date of application, number of application, name and address of the applicant along with the abstract.",
        },
        {
          question: "What is the time period of a patent?",
          answer:
            "The time period of every patent granted under the Patent Act is 20 years from the respective date of filing of the application for Patent.",
        },
        {
          question:
            "Does the patent protected in India provides a global protection?",
          answer:
            "Like any other Intellectual Property Rights, Patents is also territorial in nature and therefore are effective only within the territory of India.<br/><br/>However, for filing an application in India enables the applicant to file a corresponding application for the same invention in convention countries, within or before expiry of the 12 months from the filing date in India.<br/><br/>Separate patent is to be obtained in each country where the applicant wants to have a protection of his/her invention in those countries. There is no patent valid worldwide.",
        },
      ],
    },
  },
  "itr-filing": {
    title: "ITR Filing",
    hero: {
      title: "ITR Filing in India: A Comprehensive Guide",
      description:
        "Income Tax Return (ITR) filing is an essential obligation for individuals and entities in India. It is a legal requirement imposed by the government to assess and collect taxes from citizens and organizations based on their income. The process of ITR filing in India can seem daunting to many, but with the right knowledge and guidance, it can be a smooth and hassle-free experience. This article will provide you with a comprehensive guide to ITR filing in India.",
      advantages: [
        "Legal Compliance and Avoiding Penalties",
        "Income Verification and Financial Transparency",
        "Claiming Tax Deductions and Refunds",
        "Establishing Financial History",
        "Avoiding Income Scrutiny",
        "Contributing to Nation Building",
      ],
      eligibleCriteria: [
        "Individuals whose total income exceeds the basic exemption limit.",
        "All registered companies and firms, irrespective of profit or loss.",
        "Partnership firms and Limited Liability Partnerships (LLPs).",
        "Trusts, NGOs, and other associations with income over the exemption limit.",
      ],
    },
    content: {
      overviews: [
        {
          title: "Meaning of Income Tax Return",
          description:
            "Income Tax Return is a form or document that individuals and entities are required to file with the Income Tax Department, providing details of their income earned during a specific financial year. It includes information about various sources of income, deductions claimed, and tax payments made.",
        },
        {
          title: "Who should file Income Tax Return in India?",
          description:
            "As per the Income Tax Act, 1961, individuals and entities falling under the following categories are required to file ITR Return:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>Individuals:</b> All individuals whose total income exceeds the basic exemption limit (currently INR 2.5 lakh for individuals below 60 years) are required to file ITR. This applies to salaried employees, self-employed professionals, freelancers, and others.",
                "<b>Companies and firms:</b> All registered companies and firms, irrespective of their profit or loss, are required to file ITR.",
                "<b>Partnership firms and LLPs:</b> Partnership firms and Limited Liability Partnerships (LLPs) are required to file ITR.",
                "<b>Trusts and Associations:</b> Trusts, NGOs, charitable institutions, and other associations having income exceeding the exemption limit must file ITR Return.",
              ],
            },
          ],
        },
        {
          title: "Types of Income Tax Return Forms",
          description:
            "The Income Tax Department has designed different types of ITR forms to cater to various categories of taxpayers. The appropriate form depends on the nature of income, sources of income, and the taxpayer’s residential status. Some commonly used ITR forms include:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>ITR-1 (SAHAJ):</b> This form is for individuals having income from salary, pension, one house property, or other sources (excluding lottery or racehorse income).",
                "<b>ITR-2:</b> This form is for individuals and Hindu Undivided Families (HUFs) not having income from business or profession.",
                "<b>ITR-3:</b> This form is for individuals and HUFs having income from a proprietary business or profession.",
                "<b>ITR-4 (SUGAM):</b> This form is for individuals, HUFs, and firms (other than LLPs) opting for presumptive taxation under Section 44AD, 44ADA, or 44AE of the Income Tax Act, 1961.",
                "<b>ITR-5:</b> This form is for entities such as LLPs, Association of Persons (AOPs), and Body of Individuals (BOIs).",
                "<b>ITR-6:</b> This form is for companies that are not claiming exemption under Section 11 of the Income Tax Act, 1961.",
                "<b>ITR-7:</b> This form is for persons, including companies, who are required to furnish an ITR return under Sections 139(4A), 139(4B), 139(4C), or 139(4D) of the Income Tax Act, 1961.",
              ],
            },
          ],
        },
        {
          title: "Importance of ITR Filing in India",
          description:
            "Income Tax Return Filing is an essential aspect of financial responsibility for individuals and businesses in India. It is a process through which taxpayers report their income, deductions, and tax liabilities to the government. While it may seem burdensome at times, filing income tax returns carries significant importance for both the taxpayers and the nation as a whole. The importance of ITR Filing in India are as follows:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>Legal Compliance and Avoidance of Penalties:</b><br/>Filing income tax returns is a legal requirement mandated by the Income Tax Act, 1961 in India. It applies to individuals, Hindu Undivided Families (HUFs), partnership firms, companies, and any other entities that generate taxable income. By fulfilling this obligation, taxpayers demonstrate their compliance with the law and contribute to the nation’s economy.<br/>Failure to file income tax returns can result in penalties, interest, and even legal consequences. The penalties can include fines and imprisonment, depending on the severity of the violation. Thus, filing tax returns on time helps taxpayers avoid unnecessary penalties and legal complications.",
                "<b>Determining Tax Liability and Claiming Refunds:</b><br/>The primary purpose of filing income tax returns is to determine the tax liability of individuals and entities. Through this process, taxpayers calculate their taxable income, apply relevant deductions and exemptions, and arrive at the final tax amount owed to the government. By correctly assessing their tax liability, taxpayers ensure they contribute their fair share to the development of the country.<br/>Additionally, income tax return filing allows individuals to claim tax refunds. If a taxpayer has paid more taxes during the financial year than their actual liability, they can claim a refund by filing their returns. This refund can provide a much-needed financial boost and serve as an incentive for timely filing of tax returns.",
                "<b>Documentation and Financial Record:</b><br/>Income tax return filing helps in maintaining a comprehensive financial record. The process necessitates gathering and organizing relevant financial information, including income from various sources, expenses, investments, loans, and other financial activities. By documenting these details, taxpayers can keep track of their financial transactions, assess their financial health, and plan for the future.<br/>Moreover, having an updated record of income tax returns is often required for various financial activities. For instance, when applying for loans, mortgages, or visas, individuals may need to provide their income tax returns as proof of income and financial stability. Hence, timely filing of returns ensures smooth financial operations and facilitates future endeavors.",
                "<b>Supporting Economic Development:</b><br/>Income tax plays a crucial role in funding the developmental projects and welfare programs undertaken by the government. It provides the necessary resources to build infrastructure, improve public services, and support initiatives aimed at socio-economic development. By filing tax returns honestly and accurately, taxpayers contribute to the nation’s progress and help create a better society for all citizens.",
                "<b>Strengthening Governance and Transparency:</b><br/>Income tax return filing promotes good governance and transparency in the financial system. It helps the government in monitoring and regulating economic activities, reducing tax evasion, and identifying non-compliant individuals or entities. Through comprehensive reporting, tax authorities can track income patterns, detect discrepancies, and ensure fairness in the taxation system. This, in turn, leads to a more equitable distribution of resources and strengthens the overall governance framework.",
              ],
            },
          ],
        },
        {
          title: "Advantages of Income Tax Return Filing",
          description:
            "The following are the advantages of ITR Filing in India:",
          content: [
            {
              type: "h4",
              text: "Legal Compliance and Avoiding Penalties",
              bullets: [
                "One of the primary advantages of filing Income Tax Returns is to fulfill your legal obligations as a taxpayer. The Income Tax Act, 1961 mandates that individuals and businesses earning above the specified threshold file their tax returns. By complying with the law, you avoid penalties, fines, or legal complications that could arise from non-compliance.",
              ],
            },
            {
              type: "h4",
              text: "Income Verification and Financial Transparency",
              bullets: [
                "Income Tax Return filing acts as a declaration of your income and assets to the government. It helps in establishing a clear record of your financial activities and offers transparency to tax authorities. This documentation becomes crucial in various situations, such as applying for loans, securing visas, or participating in government tenders, where your financial status may be scrutinized.",
              ],
            },
            {
              type: "h4",
              text: "Claiming Tax Deductions and Refunds",
              bullets: [
                "Income Tax Returns provide an opportunity to claim various tax deductions and exemptions available under the Income Tax Act. These deductions can significantly reduce your tax liability and help you save money. Popular deductions include those for investments in tax-saving instruments (e.g., Employee Provident Fund, Public Provident Fund), health insurance premiums, home loan interest payments, and contributions to charitable organizations.<br/><br/>Additionally, filing income tax returns enables individuals to claim refunds if they have paid excess taxes during the financial year. Tax refunds can arise from sources like TDS (Tax Deducted at Source) or advance tax payments. By filing your returns, you can receive the refund due to you from the government, providing a welcome financial boost.",
              ],
            },
            {
              type: "h4",
              text: "Establishing Financial History",
              bullets: [
                "Consistently filing income tax returns helps build a reliable financial history. This is particularly beneficial for individuals who plan to apply for loans or credit cards in the future. Lenders assess the creditworthiness of applicants based on their income tax return filings, making it essential to have a clean and consistent record. A positive financial history increases the likelihood of getting favorable loan terms, higher credit limits, and lower interest rates.",
              ],
            },
            {
              type: "h4",
              text: "Avoiding Income Scrutiny",
              bullets: [
                "The Income Tax Department scrutinizes cases where individuals or businesses have not filed their tax returns or where discrepancies are detected. By filing your returns promptly and accurately, you minimize the chances of attracting the attention of the tax authorities for the wrong reasons. Proactive compliance reduces the risk of being subjected to income tax audits, notices, or investigations.",
              ],
            },
            {
              type: "h4",
              text: "Financial Planning and Budgeting",
              bullets: [
                "Filing income tax returns requires individuals to compile and organize their financial information. This process encourages better financial planning and budgeting. By evaluating your income, expenses, investments, and savings, you gain a comprehensive understanding of your financial standing. It allows you to identify areas for improvement, make informed decisions, and optimize your financial resources effectively.",
              ],
            },
            {
              type: "h4",
              text: "Contributing to Nation Building",
              bullets: [
                "Filing income tax returns is a fundamental way to contribute to the development and progress of the nation. Income tax revenue forms a significant part of the government’s income, which is utilized for infrastructure development, social welfare programs, education, healthcare, defense, and more. By fulfilling your tax obligations, you actively participate in the nation-building process and help create a better society for all.",
              ],
            },
          ],
        },
        {
          title: "Documents required for Income Tax Return Filing in India",
          description:
            "To complete the income tax return filing process accurately and efficiently, it is essential to gather and organize the necessary documents. The following are the documents required for ITR Filing:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>PAN Card:</b> Permanent Account Number ( PAN ) is a unique identification number issued by the Income Tax Department. It is a mandatory document for filing income tax returns.",
                "<b>Aadhaar Card:</b> Aadhaar is a 12-digit unique identification number issued by the Unique Identification Authority of India (UIDAI). Linking your Aadhaar card with your PAN card is compulsory for income tax return filing.",
                "<b>Form 16:</b> Form 16 is issued by your employer and provides details of your salary, allowances, deductions, and Tax Deducted at Source (TDS) during the financial year. It is an essential document for salaried individuals.",
                "<b>Form 16A:</b> Form 16A is similar to Form 16 but is issued by entities other than employers, such as banks, for TDS on income other than salary. It is relevant for individuals receiving income from fixed deposits, interest on securities, etc.",
                "<b>Form 26AS:</b> Form 26AS is a consolidated statement that shows the tax credits available to you based on TDS deducted by your employer, banks, or other deductors. It is crucial for cross-verification and reconciliation while filing your tax returns.",
                "<b>Bank Statements:</b> Maintain a record of your bank statements for the financial year. It helps in verifying the income earned, interest received, and expenses claimed during the year.",
                "<b>Investment Proofs:</b> Gather proofs of your investments made during the financial year to claim deductions under various sections of the Income Tax Act, 1961. This includes documents related to investments in Public Provident Fund (PPF), National Savings Certificates (NSC), tax-saving fixed deposits, life insurance premiums, and other eligible investment instruments.",
                "<b>Property Documents:</b> If you own property, ensure you have the necessary documents like sale deed, purchase agreement, and home loan statements. These documents are required to claim deductions on home loan interest and principal repayments.",
                "<b>Rent Receipts:</b> If you are a salaried individual living in a rented house and want to claim House Rent Allowance (HRA) exemption, keep rent receipts handy. Make sure they are appropriately stamped and contain the necessary details such as landlord’s name, address, and PAN (if applicable).",
                "<b>Other Documents:</b> Keep any other supporting documents that may be relevant to your income tax return filing, such as charitable donations receipts, medical bills for claiming medical reimbursements, and proofs of deductions under Section 80D (health insurance premiums).",
              ],
            },
          ],
        },
        {
          title: "Steps for Income Tax Return Filing",
          content: [
            {
              type: "process",
              title: "ITR Filing Process",
              steps: [
                {
                  step: 1,
                  title: "Determine the Applicable Income Tax Return Form",
                  description:
                    "The first step in filing your income tax return is to determine the appropriate form to use. The Income Tax Department of India provides several forms for different types of taxpayers, such as individuals, Hindu Undivided Families (HUFs), companies, and partnerships. The commonly used forms for individuals are ITR-1 (Sahaj), ITR-2, ITR-3, and ITR-4. Carefully assess your sources of income and choose the form that suits your situation.",
                },
                {
                  step: 2,
                  title: "Gather the Required Documents",
                  description:
                    "Before starting the income tax return filing process, gather all the necessary documents. These may include your PAN (Permanent Account Number) card, Aadhaar card, bank statements, Form 16 (provided by your employer), Form 16A (for income from other sources), details of investments, and any other relevant financial documents. Having these documents readily available will help you provide accurate information while filing your return.",
                },
                {
                  step: 3,
                  title: "Compute Your Income and Tax Liability",
                  description:
                    "The next step is to compute your total income for the financial year. Consider all sources of income, such as salary, house property, capital gains, business or profession, and other incomes. Deduct eligible expenses, deductions, exemptions, and allowances to arrive at your taxable income. Use the income tax slabs and rates applicable for the financial year to calculate your tax liability accurately.",
                },
                {
                  step: 4,
                  title: "File Your Income Tax Return Online",
                  description:
                    "The Income Tax Department has made it mandatory for most taxpayers to file their income tax returns online. Visit the official website of the Income Tax Department and register yourself as a taxpayer. Once registered, log in to your account and select the relevant income tax return form. Fill in the necessary details, such as personal information, income details, and deductions. Double-check the information provided before submitting the return.",
                },
                {
                  step: 5,
                  title: "Verify and Submit Your Return",
                  description:
                    "After filling in the required details, verify your income tax return. The Income Tax Department provides multiple verification methods, such as using Aadhaar OTP (One-Time Password), generating and sending a signed physical copy of ITR-V to the Centralized Processing Centre (CPC), or using Electronic Verification Code (EVC). Choose the verification method that suits you and complete the verification process.",
                },
                {
                  step: 6,
                  title: "Keep Proof of Filing",
                  description:
                    "After successfully filing your income tax return, ensure that you keep a copy of the filed return for future reference. It is advisable to retain copies of Form 16, Form 16A, and any other relevant documents supporting the information provided in your return. These documents may be required for audit purposes or while applying for loans or visas.",
                },
                {
                  step: 7,
                  title: "Pay Any Remaining Tax Liability",
                  description:
                    "If, after filing your return, you find that you have a tax liability, make the payment as per the guidelines provided by the Income Tax Department. Utilize the authorized modes of payment, such as net banking or debit/credit card, to pay the outstanding tax amount. Remember to pay any due taxes before the specified due dates to avoid penalties and interest charges.",
                },
                {
                  step: 8,
                  title: "Respond to Notice, if Received",
                  description:
                    "In some cases, the Income Tax Department may send a notice seeking additional information or clarification regarding your income tax return. If you receive such a notice, respond promptly and provide the requested details. Ignoring or delaying the response may lead to further complications, including penalties.",
                },
              ],
            },
          ],
        },

        {
          title:
            "Penalty in case of late ITR Filing as per Income Tax Act, 1961",
          description:
            "The following are the penalty may be imposed on taxpayer in case of late income tax return filing:",
          content: [
            {
              type: "h4",
              text: "Section 234F: Late Filing Fees",
              bullets: [
                "Section 234F was introduced in the Income Tax Act, 1961, in order to encourage timely filing of income tax returns. According to this section, if an individual or Hindu Undivided Family (HUF) fails to furnish the income tax return within the specified due date, they are liable to pay a late filing fee. The applicable fees under Section 234F are as follows:<ul><li>If the return is filed after the due date but on or before December 31 of the assessment year (AY), a late filing fee of Rs. 5,000 is applicable.</li><li>If the return is filed after December 31 of the AY, a late filing fee of Rs. 10,000 is applicable.</li></ul>However, there is a relief provision for small taxpayers. If the total income of the individual does not exceed Rs. 5, 00,000, the maximum fee payable is restricted to Rs. 1,000.<br>It is important to note that the late filing fee under Section 234F is not applicable to individuals who are 80 years or older at any time during the relevant financial year.",
              ],
            },
            {
              type: "h4",
              text: "Interest on Delayed Payment",
              bullets: [
                "Apart from the late filing fees, the Income Tax Act, 1961, also imposes interest on delayed payment of taxes. If the taxpayer fails to pay the income tax liability within the due date, they will be liable to pay interest under Section 234A, 234B, and 234C of the Act. Let’s understand these sections in detail:",
              ],
            },
            {
              type: "h4",
              text: "Section 234A: Interest for Delay in Filing Return",
              bullets: [
                "Under Section 234A, if a taxpayer fails to file the income tax return within the due date, they are liable to pay interest at the rate of 1% per month or part thereof. This interest is calculated from the due date of filing the return until the actual date of filing.",
              ],
            },
            {
              type: "h4",
              text: "Section 234B: Interest for Default in Payment of Advance Tax",
              bullets: [
                "If a taxpayer fails to pay the advance tax or pays an amount less than the required installment, they will be liable to pay interest under Section 234B. The interest rate is 1% per month or part thereof, calculated from the due date of advance tax installment until the actual payment of tax.",
              ],
            },
            {
              type: "h4",
              text: "Section 234C: Interest for Default in Payment of Quarterly Installments",
              bullets: [
                "Section 234C applies to individuals who are liable to pay advance tax in installments. If the taxpayer fails to pay the required installment or pays an amount less than the prescribed percentage, they will be liable to pay interest under Section 234C. The interest is calculated at the rate of 1% per month or part thereof for the period of default.",
              ],
            },
            {
              type: "h4",
              text: "Prosecution and Other Consequences",
              bullets: [
                "Apart from the penalties mentioned above, the Income Tax Act, 1961, also includes provisions for prosecution and other consequences in case of willful non-compliance or fraud. If a taxpayer willfully fails to furnish the income tax return or provides false information, they may face legal action, which could include prosecution, imprisonment, or both, along with the imposition of penalties.<br/><br/>It is important for taxpayers to understand their obligations under the Income Tax Act, 1961, and adhere to the specified timelines for filing income tax returns. Timely compliance not only helps avoid penalties but also ensures a smooth tax filing process and maintains the integrity of the taxation system.",
              ],
            },
          ],
        },
        {
          title: "Way Forward",
          description:
            "In conclusion, ITR filing is a crucial responsibility for individuals and entities in India. By understanding the process, gathering the necessary documents, computing income and tax liability accurately, and adhering to the deadlines, taxpayers can fulfill their obligations effectively. It is advisable to stay updated with the latest rules and guidelines issued by the Income Tax Department to ensure compliance and avoid any penalties or legal issues.",
        },
      ],
      features: [
        "Legal Compliance and Avoiding Penalties",
        "Income Verification and Financial Transparency",
        "Claiming Tax Deductions and Refunds",
        "Establishing Financial History",
        "Avoiding Income Scrutiny",
        "Financial Planning and Budgeting",
        "Contributing to Nation Building",
      ],
      tables: [],
      faq: [],
    },
  },
  "nri-taxation": {
    title: "NRI Taxation",
    hero: {
      title: "NRI Income Tax Return in India",
      description:
        "The taxable income of a Non-Resident Indian (NRI) depends entirely on their residential status for the given financial year. If an individual is classified as a 'Resident,' their global income is taxable in India. Conversely, for an NRI, only the income that is earned or accrued in India is subject to Indian taxation. This includes salary for services rendered in India, capital gains from assets in India, rental income from property in India, and interest from fixed deposits or savings accounts. Interest earned on NRE and FCNR accounts is tax-exempt, but interest on NRO accounts is taxable.",
      advantages: [
        "Tax exemption on interest from NRE and FCNR accounts",
        "Deductions for life insurance premiums and tuition fees under Section 80C",
        "Deductions for health insurance premiums for family under Section 80D",
        "Tax benefits on interest paid for education loans under Section 80E",
        "Deductions for donations to specified institutions under Section 80G",
        "Deduction on interest income from NRO savings accounts up to ₹10,000 under Section 80TTA",
      ],
      eligibleCriteria: [
        "Residential status determines tax liability",
        "Only income earned or accrued in India is taxable for NRIs",
        "Income earned outside India is not taxable in India",
        "Tax filing is mandatory if total taxable income in India exceeds ₹2.5 lakhs",
        "Capital gains from the sale of assets in India are taxable",
        "Rental income from property located in India is taxable",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction to NRI Taxation",
          description:
            "Many families have members working abroad who send money back to India or make investments for their family's future, raising significant questions about NRI income tax returns. During tax season, every taxpayer seeks ways to save on their hard-earned money. The NRI income tax system is favorable in this regard, as it allows NRIs to bring foreign income to India without it being taxed in the country.<br/><br/>Several other types of income are also not taxed in India for NRIs. Most NRIs operate through Non-Resident External (NRE) or Foreign Currency Non-Resident (FCNR) accounts. While Indian residents pay tax on savings account interest exceeding ₹10,000, NRIs do not pay tax on the interest earned in their NRE and FCNR accounts. However, interest from a Non-Resident Ordinary (NRO) account is taxable. Similarly, certain investments made by NRIs are not taxed in India.<br/><br/>NRI taxation rules encourage investment in the country, which boosts the national economy. It's a favorable system that helps the government attract investments from non-residents. However, any long-term or short-term capital gains from the sale of assets or investments within India are taxable.<br/><br/>If an NRI inherits property or other assets, the transfer of ownership is not taxed. But any income generated from these assets, such as rent or proceeds from a sale, is taxable. Under Sections 54, 54EC, and 54F, significant tax deductions can be availed if the proceeds from capital gains are reinvested in India. If an NRI's total income from all Indian sources (rent, dividends, capital gains, etc.) exceeds ₹2.5 lakh, they are required to file taxes.<br/><br/>NRIs are not eligible for certain investments like National Saving Certificates (NSC), Senior Citizen Schemes, or Post Office Time Deposits, and they cannot open new PPF accounts. However, they can invest in other instruments like home loans, life insurance, pension plans, and equity-linked saving schemes (ELSS). An NRI can also claim tuition fees paid for a spouse or children in India, and deductions under Section 80D for health insurance premiums for dependents in India.",
        },
        {
          title: "Income Tax Provisions for NRIs",
          description:
            "A person is classified as an NRI if they meet the specific guidelines laid out in the Income Tax Act. Income earned by an NRI outside India does not fall under the jurisdiction of Indian income tax. However, if they earn income in India through sources like capital gains, mutual funds, or sale of assets, and this income exceeds the basic exemption limit, they must file a tax return.<br/><br/>The main concerning points with NRI taxation is outlined as follows:",
          content: [
            {
              type: "h4",
              text: "Key Points in NRI Taxation",
              bullets: [
                "For NRIs, income tax slabs are based on income level, irrespective of age, gender, or other factors.",
                "If Tax Deducted at Source (TDS) is applicable, it is charged on all income generated by an NRI, regardless of any threshold.",
                "Standard deductions are generally not applicable to investment income, except in specific situations.",
                "If an NRI's income is subject to the provisions under Section 115G of the income tax act, they are not required to e-file their income tax return.",
              ],
            },
            {
              type: "h4",
              text: "Governing Sections of the Income Tax Act",
              bullets: [
                "<b>Section 115D:</b> Governs the calculation of the total taxable income of an NRI.",
                "<b>Section 115E:</b> If an NRI's income consists only of investment income or long-term capital gains, the tax on such income is charged at a rate of 20%.",
                "<b>Section 115F:</b> Deals with the non-chargeability of capital gains from the transfer of certain foreign exchange assets.",
                "<b>Section 115G:</b> Provides an exemption for NRIs from filing an income tax return in certain cases.",
                "<b>Section 115H:</b> Outlines the tax benefits an NRI receives when their status changes to 'Resident'.",
                "<b>Section 115I:</b> Pertains to any income derived from a foreign exchange asset.",
              ],
            },
          ],
          description_after_content:
            "The above-mentioned rules are subject to change based on the discretion of the Central Government and the Income Tax Department.",
        },
        {
          title: "Applicable Deductions and Exemptions for NRIs",
          description:
            "NRIs sometimes end up paying more tax than their actual liability because much of their income is subject to high rates of TDS (Tax Deducted at Source). Therefore, it's crucial to be aware of the deductions and exemptions available.",
          content: [
            {
              type: "h4",
              text: "1. Section 80C:",
              bullets: [
                "Life insurance premium payments.",
                "Tuition fee payments for children's education in India.",
                "Principal repayment on a home loan for a property in India.",
                "Investments in Equity Linked Savings Schemes (ELSS) and Unit Linked Insurance Plans (ULIPs).",
              ],
            },
            {
              type: "h4",
              text: "2. Section 80D:",
              bullets: [
                "Premiums paid for health insurance for self, family, or dependent parents up to ₹25,000 (₹50,000 if parents are senior citizens).",
                "Preventive health check-ups up to a maximum of ₹5,000 within the overall limit.",
              ],
            },
            {
              type: "h4",
              text: "3. Section 80E:",
              bullets: [
                "Interest paid on an education loan taken for the higher education of the NRI, their spouse, children, or a student for whom the NRI is a legal guardian. This deduction is available for up to 8 years.",
              ],
            },
            {
              type: "h4",
              text: "4. Section 80G:",
              bullets: ["Donations made to eligible institutions and funds."],
            },
            {
              type: "h4",
              text: "5. Section 80TTA:",
              bullets: [
                "Interest income from a savings bank account (NRO Account) up to ₹10,000.",
              ],
            },
          ],
        },
        {
          title: "Income Tax Rates for 2023-24 for NRIs:",
          description:
            "The below-given table represents the data for the latest Income Tax Slabs for the FY 2023-2024. This new income tax regime is optional for taxpayers.",
          table: {
            title: "New Income Tax Slab for Individual (New Regime)",
            headers: ["Income Tax Slab", "Tax Rate"],
            rows: [
              ["Below 2.5 Lacs", "No Tax"],
              ["2.5 Lacs- 5.0 Lacs", "5%"],
              ["5.0 Lacs- 7.5 Lacs", "10%"],
              ["7.5 Lacs – 10.0 Lacs", "15%"],
              ["10.0 Lacs – 12.5 Lacs", "20%"],
              ["12.5 Lacs – 15.0 Lacs", "25%"],
              ["Above 15 Lacs", "30%"],
            ],
          },
          description_after_table:
            "<b>Note:</b> New income tax rates are optional.<br/><br/>The information provided is a brief overview. For a detailed understanding of NRI Taxation, feel free to contact us. Govind Sinha & Co. offers a wide array of services related to NRI Taxation. Our legal experts and experienced professionals stay updated with the latest amendments to provide accurate, flawless, and quick services.",
        },
      ],
      features: [
        "Income tax slabs are based on income, not age or gender.",
        "TDS is charged on income irrespective of any threshold.",
        "Nominal deductions on investment income are limited.",
        "E-filing exemption is available under Section 115G.",
        "Specific tax provisions for various income types.",
        "Tax benefits are provided when NRI status changes to Resident.",
      ],
      tables: [],
      faq: [],
    },
  },
  "statutory-audit": {
    title: "Statutory Audit",
    hero: {
      title: "Statutory Audit Services",
      description:
        "In India, the laws pertaining to Statutory Audit are prescribed under the Companies Act, 2013. In general terms, it is an audit of the Financial Statements of a Company, i.e., the Balance Sheet and Profit & Loss Account. It is mandatory to conduct a statutory audit if a business meets certain criteria. The audit must be performed by an Independent Chartered Accountant, who then prepares a report stating facts, opinions, adverse remarks, and any disclaimers of information observed, in the format prescribed by the regulator. An independent auditor must not have any conflicting relationship with the auditee company.",
      advantages: [
        "Ensures accuracy of financial statements and books of accounts.",
        "Verifies the authenticity and validity of all business transactions.",
        "Confirms the correct valuation of assets and liabilities.",
        "Provides a true and fair view of the company's financial position and operating results.",
        "Aids in the detection and prevention of errors and fraud.",
        "Confirms that funds are appropriated correctly and ethically.",
      ],
      eligibleCriteria: [
        "Every company registered under the Companies Act, 2013, regardless of turnover or capital.",
        "A Limited Liability Partnership (LLP) if its annual turnover exceeds ₹40 lakhs or its capital contribution is ₹25 lakhs or more.",
        "Proprietorships and Partnership Firms if their sales turnover exceeds ₹1 crore.",
        "Professionals if their annual gross receipts exceed a threshold limit of ₹25 lakhs.",
      ],
    },
    content: {
      overviews: [
        {
          title: "Types of Statutory Audit",
          description:
            "A Statutory Audit can be broadly classified into two main types:",
          content: [
            {
              type: "h4",
              text: "Tax Audit",
              bullets: [
                "A Tax Audit is an examination of an entity's tax records as required by the Income Tax Act, 1961. It involves a thorough review of the business or individual's tax returns by the tax authorities to ensure compliance.",
              ],
            },
            {
              type: "h4",
              text: "Company Audit",
              bullets: [
                "A Company Audit involves the verification of a company's financial statements, including the Balance Sheet, Profit & Loss Account (or Income and Expenditure Statement), and Cash Flow Statement. This audit is required to be conducted at the end of every financial year.",
              ],
            },
          ],
        },
        {
          title: "Who Requires a Statutory Audit?",
          description:
            "Different types of business entities are required to have their books of account audited based on specific criteria:",
          content: [
            {
              type: "h4",
              text: "Company under Companies Act, 2013",
              bullets: [
                "As per the provisions of the Companies Act, 2013, every company, regardless of its sales turnover or nature of business, is mandatorily required to get its accounts audited every financial year. For a newly incorporated company, the Board of Directors must appoint an auditor within 30 days of its incorporation.",
              ],
            },
            {
              type: "h4",
              text: "Limited Liability Partnership (LLP)",
              bullets: [
                "The accounts of an LLP must be audited if the LLP has an annual turnover of ₹40 lakhs or more, or if its total capital contribution is ₹25 lakhs or more.",
              ],
            },
            {
              type: "h4",
              text: "Proprietorships and Partnership Firms",
              bullets: [
                "A tax audit is required for Proprietorships and Partnership Firms whose sales turnover exceeds ₹1 crore in terms of business, or if their annual gross receipts cross a threshold of ₹25 lakhs in the case of a profession.",
              ],
            },
          ],
        },
        {
          title: "Objectives of Statutory Audit",
          description:
            "The objectives of a statutory audit are categorized into primary and subsidiary objectives.",
          content: [
            {
              type: "h4",
              text: "Primary Objectives of Statutory Audit",
              bullets: [
                "Examination of the company's financial statements.",
                "Evaluation of the arithmetical accuracy of books of accounts and verification of casting, posting, balancing, etc.",
                "Confirmation of the appropriate distinction between revenue and capital nature of transactions.",
                "Verification of the authenticity and validation of transactions.",
                "Confirmation of the value of assets and liabilities.",
                "Presentation of a correct and fair picture of operating results via the income statement and financial position via the balance sheet.",
                "Confirmation of the proper appropriation of funds.",
              ],
            },
            {
              type: "h4",
              text: "Subsidiary Objectives of Statutory Audit",
              bullets: [
                "Detection and deterrence of errors.",
                "Detection and deterrence of frauds.",
              ],
            },
          ],
        },
        {
          title: "Tests under Statutory Audit Procedure",
          description:
            "An auditor performs a series of tests to complete a Statutory Audit in compliance with all relevant rules and regulations. This comprehensive process begins with understanding the company's internal working environment and concludes with the detailed examination of financial accounts and balances.",
          content: [
            {
              type: "h4",
              text: "Evaluation of Operating Environment",
              bullets: [
                "The auditor evaluates whether the organization's internal practices are in harmony with industry guidelines and regulatory benchmarks and ensures that these practices are ethical.",
              ],
            },
            {
              type: "h4",
              text: "Evaluation of Operating Controls",
              bullets: [
                "The auditor examines the business entity's operating controls by communicating with employees, and industry consultants, reviewing previous years' audit reports, or going through industry publications.",
              ],
            },
            {
              type: "h4",
              text: "Evaluation of Substantive Controls",
              bullets: [
                "The auditor evaluates whether the corporation implements and maintains operating mechanisms designed to prevent fraud or errors, in line with industry practices and regulatory standards.",
              ],
            },
            {
              type: "h4",
              text: "Examination of Account Balances",
              bullets: [
                "The auditor examines account balances to confirm the authenticity and validity of financial reports, ensuring their compliance with regulatory standards, statutory principles, and industry practices.",
              ],
            },
            {
              type: "h4",
              text: "Examination of Account Details",
              bullets: [
                "The auditor evaluates accounts and balances held with banks, insurance companies, or other financial institutions to ensure that these balances and the corporate financial statements are accurate and fair.",
              ],
            },
            {
              type: "h4",
              text: "Crucial Takeaways",
              bullets: [
                "A statutory audit is a legal requirement to check the accuracy of a company's financial statements and records.",
                "It involves a financial analysis of the records held by a business entity, government entity, or person.",
                "The audit confirms the proper management of funds and the accuracy of financial filings.",
                "It is applicable to a wide range of firms, including public companies, banks, brokerage firms, and insurance companies.",
              ],
            },
          ],
        },
        {
          title: "Process of Statutory Audit",
          description:
            "The process of a statutory audit can be summarized in the following steps:",
          content: [
            {
              type: "process",
              title: "Audit Process Steps",
              steps: [
                {
                  step: 1,
                  title: "Review",
                  description:
                    "The statutory auditor obtains a deep understanding of the company's internal and external environment. This includes reviewing the business operations, financial statements, books of accounts, and internal control systems.",
                },
                {
                  step: 2,
                  title: "Audit Execution",
                  description:
                    "The auditor verifies the financial statements of the auditee. A key part of this is 'sample audit,' where the auditor verifies transactions and balances on a sample basis to test the overall accuracy.",
                },
                {
                  step: 3,
                  title: "Reporting",
                  description:
                    "Based on the data and information collected through various procedures, the auditor prepares a report. This report expresses an opinion on whether the financial statements, based on the audit evidence, are free from material misstatement and present a true and fair view of the company's financial health.",
                },
              ],
            },
          ],
        },
        {
          title: "Types of Audit Opinion",
          description:
            "An auditor can issue different types of opinions in their report based on their findings:",
          content: [
            {
              type: "h4",
              text: "Modified Opinion",
              bullets: [
                "A modified report indicates that the financial statements are materially misstated. It can be of three types:<ul><li><b>Qualified:</b> Issued when the auditor finds that the financial statements are not prepared according to Generally Accepted Accounting Principles (GAAP).</li><li><b>Adverse:</b> This is the most severe type of report. It states that the financial statements are materially misstated and do not present a true and fair view.</li><li><b>Disclaimer:</b> Issued when the auditor is unable to obtain sufficient evidence to form an opinion on the financial statements, effectively stating that an opinion could not be determined.</li></ul>",
              ],
            },
            {
              type: "h4",
              text: "Unmodified Opinion",
              bullets: [
                "This is a clean audit opinion which states that the financial statements are free from any material misstatement and present a true and fair view.",
              ],
            },
          ],
        },
        {
          title: "Who Is Eligible to Appoint as a Statutory Auditor?",
          description:
            "As per Section 141 of the Companies Act 2013, the statutory auditor of a company must be a Chartered Accountant practicing in India. If the auditee appoints a firm, the majority of the partners in that firm must be Chartered Accountants practicing in India.",
        },
      ],
      features: [
        "A statutory audit is a legal requirement to verify the accuracy of financial records.",
        "It involves a comprehensive financial analysis of the entity's records.",
        "The audit confirms the proper management of funds and accuracy of filings.",
        "It is applicable to various firms including public companies, banks, and insurance companies.",
      ],
      tables: [],
      faq: [],
    },
  },
  "roc-filing": {
    title: "ROC Filing",
    hero: {
      title: "ROC Filing Services",
      description:
        "Every company, whether Public, Private, Section-8, Producer, or any other type incorporated under the Companies Act, 2013, is required to file its annual Financial Statements and Annual Return with the Registrar of Companies (ROC). These must be filed within 30 days (in e-form AoC-4) and 60 days (in e-form MGT-7) respectively, from the conclusion of the company's Annual General Meeting (AGM).",
      advantages: [
        "Ensures compliance with the Companies Act, 2013.",
        "Maintains the company's active status and avoids penalties.",
        "Creates a public record of the company's financial health and activities.",
        "Improves transparency for shareholders, investors, and authorities.",
        "Facilitates good corporate governance and timely reporting.",
      ],
      eligibleCriteria: [
        "All companies incorporated under the Companies Act, 2013, or any previous company law.",
        "This includes Public Companies, Private Companies, One Person Companies (OPC), Section-8 Companies, and Producer Companies.",
        "Filing of specific forms like ADT-1, AOC-4, and MGT-7 is mandatory for all applicable companies.",
        "Listed companies and those with high turnover or capital must also file in XBRL format (AOC-4 XBRL).",
      ],
    },
    content: {
      overviews: [
        {
          title: "An Overview of ROC Compliance",
          description:
            "A company's Annual General Meeting (AGM) must be conducted once a year. The first AGM must be held within 9 months from the end of the company's first financial year (i.e., by December 31st). Subsequent AGMs must be conducted within 6 months from the financial year's closing (i.e., by September 30th).<br/><br/>The ROC (Registrar of Companies) operates under the Ministry of Corporate Affairs (MCA). As per the Companies Act, 2013, specifically Sections 92, 129, and 137, all companies must file their audited financial reports with the respective ROC. Any delay or failure to file these returns can lead to significant interest and penalties.",
        },
        {
          title: "Pre-Filing Process for ROC Compliances",
          description:
            "The process of preparing for the filing of audited financial statements and annual returns with the ROC involves these key steps:",
          content: [
            {
              type: "process",
              title: "Preparatory Steps for ROC Filing",
              steps: [
                {
                  step: 1,
                  title: "Organize a Board Meeting",
                  description:
                    "A meeting of the Board of Directors is held to:<ul><li>Authorize the auditor for the preparation of financial statements in accordance with Schedule III of the Companies Act, 2013.</li><li>Authorize the Directors or Company Secretary to prepare the Board's Report and the Annual Return for the financial year.</li></ul>",
                },
                {
                  step: 2,
                  title: "Hold a Final Board Meeting",
                  description:
                    "A second Board meeting is held where the Directors formally approve the draft Financial Statements, the Board's Report, and the Annual Return.",
                },
                {
                  step: 3,
                  title: "Conduct the Annual General Meeting (AGM)",
                  description:
                    "The Directors convene an AGM of the company's members to pass the necessary resolutions. The Financial Statements are only considered final once they are approved and adopted by the members at the AGM.",
                },
              ],
            },
          ],
        },
        {
          title: "Documents Required for ROC Filing",
          description:
            "Each company must attach several key documents during the ROC filing process:",
          content: [
            {
              type: "h4",
              text: "Document Checklist",
              bullets: [
                "Adopted Financial Statements (Balance Sheet, Profit and Loss Account, Cash Flow Statement) with notes, filed in e-form AoC-4.",
                "The Board's Report along with all its annexures, also filed in e-form AoC-4.",
                "A list of all members as of the end of the financial year, filed in e-form MGT-7.",
                "The Cost Audit Report, if applicable, filed in Form CRA-4.",
              ],
            },
          ],
        },
        {
          title: "Process of ROC Filing on the MCA Portal",
          description:
            "The step-by-step process for filing ROC forms on the Ministry of Corporate Affairs (MCA) website is as follows:",
          content: [
            {
              type: "process",
              title: "MCA Filing Steps",
              steps: [
                {
                  step: 1,
                  title: "Download Forms",
                  description:
                    "Download the required e-forms (e.g., AOC-4, MGT-7) from the official MCA website by navigating to: MCA Services → E-filing → Company Forms Download.",
                },
                {
                  step: 2,
                  title: "Fill the Form",
                  description:
                    "Fill out the applicable form with all required details. Attach necessary documents in PDF or XML format as specified, recheck the entire form for accuracy, add the digital signatures (DSC) of the director and a practicing professional, and then perform a pre-scrutiny check.",
                },
                {
                  step: 3,
                  title: "Register on MCA",
                  description:
                    "Register on the MCA website as a 'Business User' or 'Registered User'. Once registered, log in with your User ID and password.",
                },
                {
                  step: 4,
                  title: "Upload E-Forms",
                  description:
                    "After logging in, navigate to the 'Upload E-forms' section and upload the signed form from your computer.",
                },
                {
                  step: 5,
                  title: "Fee Payment",
                  description:
                    "After uploading, a Service Request Number (SRN) will be generated. Proceed to the 'Pay Now' option, where you will have two choices:<ul><li>Pay using internet banking, debit card, or credit card.</li><li>Choose 'Pay later' to generate a challan, which must be paid within the specified due date.</li></ul>Save the payment challan for future reference.",
                },
                {
                  step: 6,
                  title: "Track Status",
                  description:
                    "Once the process is complete, you can track the transaction status of your filing using the SRN under the MCA services menu.",
                },
              ],
            },
          ],
        },
        {
          title: "ROC E-Filing Forms and Due Dates",
          description:
            "The following table details the various forms required for annual ROC compliance, along with their purpose, attachments, and deadlines.",
          table: {
            title: "Annual ROC Compliance Forms",
            headers: [
              "Form Name",
              "Purpose of E-form",
              "Attachments",
              "Due Date",
              "Applicability",
            ],
            rows: [
              [
                "ADT-1 Form",
                "Appointment of Auditor",
                "Appointment Letter, Confirmation Letter from Company, Consent Letter from the Auditor",
                "Within 15 days from the date of the AGM.",
                "All types of Companies",
              ],
              [
                "AOC-4 Form and AOC-4 CFS",
                "Filing of Annual Accounts",
                "Board Report with annexures like AOC-2, CSR Report, Secretarial Audit Report, MGT-9, etc.",
                "Within 30 days from the AGM date. (For OPC, within 180 days from the close of the Financial Year)",
                "All types of Companies",
              ],
              [
                "AOC-4 XBRL Form",
                "Filing of Annual Accounts in XBRL mode",
                "XML report of the company's financials",
                "Within 30 days from the AGM date.",
                "Listed companies, their Indian subsidiaries, and public companies with paid-up capital ≥ ₹5 crores or turnover ≥ ₹100 crores.",
              ],
              [
                "MGT-7 Form",
                "Filing of Annual Return",
                "List of shareholders, debenture holders, details of share transfers, MGT-8 (if applicable).",
                "Within 60 days from the date of the AGM.",
                "Private, Public, and One Person Companies.",
              ],
              [
                "CRA-4 Form",
                "Filing of Cost Audit Report",
                "XML report of Cost Audit documents",
                "Within 30 days from the receipt of the cost audit report.",
                "Firms covered under The Companies (Cost records and Audit) Rules, 2014.",
              ],
              [
                "MGT-14 Form",
                "Filing of resolutions regarding the approval of Board statements and Final Accounts",
                "Certified true copy of the resolution.",
                "Within 30 days from the date of the concerned Board Meeting.",
                "Public and Listed Companies (Exempted for private companies).",
              ],
            ],
          },
        },
        {
          title: "Important Points for ROC Filing",
          description:
            "To ensure a smooth and compliant filing process, companies should adhere to the following key points:",
          content: [
            {
              type: "h4",
              text: "Compliance Checklist",
              bullets: [
                "A notice for a board meeting must be sent to all directors at least 7 days in advance, and acknowledgements should be recorded.",
                "As per Section 134 of the Companies Act, 2013, financial statements must be signed by the company's chairperson (if authorized by the board) or by two directors, one of whom must be the managing director and CEO.",
                "In accordance with Section 101, a notice of 21 clear days for a general meeting must be sent to all members, auditors, directors, and legal representatives of deceased members, either physically or electronically.",
                "The company must maintain its books of accounts at its registered office. If books are kept at another location, Form AOC-5 must be filed after passing a board resolution.",
                "When uploading forms, ensure they are the latest versions available on the MCA portal.",
              ],
            },
          ],
        },
        {
          title: "Conclusion",
          description:
            "All companies registered under the Companies Act, 2013, must file their Audited Financial Statements and Annual Return on the MCA website within the prescribed due dates. Failure to do so will attract penalties and other charges.",
        },
      ],
      features: [
        "Board meeting notice must be given 7 days in advance.",
        "Financial statements must be signed by authorized personnel as per the Companies Act.",
        "A 21-day clear notice is required for general meetings.",
        "Books of accounts must be kept at the registered office or declared via Form AOC-5.",
        "Always use the latest version of e-forms provided by the MCA for filing.",
      ],
      tables: [],
      faq: [],
    },
  },
  "gst-return": {
    title: "GST Return Filing",
    hero: {
      title: "Online GST Return Filing",
      description:
        "With the aim of “One Nation One Tax,” Goods and Services Tax (GST) was introduced in India on 1st July 2017 to unify different indirect taxes. The commencement of the GST regime brought with it the concept of the GST return—a document in which the taxpayer under the Goods and Services Tax (GST) must file the details of his/her income with the tax authorities. All business entities need to get registered under the GST Regime and file their GST returns online or offline.<br/><br/>As per the 37th GST Council Meeting, a new GST return mechanism has been in place since April 2020.",
      advantages: [
        "Consolidates multiple indirect taxes into a single tax system.",
        "Enables seamless claim of Input Tax Credit (ITC).",
        "Provides a clear and transparent system for reporting sales and purchases.",
        "Different return forms cater to various types of taxpayers.",
        "Online filing portal for ease of compliance.",
        "Avoids heavy penalties and interest charges through timely filing.",
      ],
      eligibleCriteria: [
        "All businesses and dealers registered under the GST regime.",
        "Regular taxpayers (filing monthly and annual returns).",
        "Taxpayers under the Composition Scheme.",
        "TDS (Tax Deducted at Source) deductors.",
        "Input Service Distributors (ISD).",
        "E-commerce operators.",
        "Non-resident taxable persons.",
      ],
    },
    content: {
      overviews: [
        {
          title: "Eligibility for GST Return Filing",
          description:
            "All business dealers and entrepreneurs who are registered under the GST mechanism must mandatorily file GST returns in the relevant GST form, either online or offline.<br/><br/>The types and number of GST returns to be filed depend on the taxpayer’s type, such as a regular taxpayer, TDS deductor, composition dealer, Input Service Distributor (ISD), e-commerce operator, non-resident taxpayer, etc. In general, a regular taxpayer must file two monthly returns (GSTR-1 and GSTR-3B) along with an annual return (GSTR-9/9C) for each GST registration, summing up to a total of 25 GST returns to be filed in a year.",
        },
        {
          title: "Types of GST Returns",
          description:
            "There are various types of GST returns applicable to different categories of taxpayers.",
        },
        {
          title: "1. GSTR-1: Return for Outward Supplies",
          description:
            "GSTR-1 is a monthly or quarterly return that details all outward supplies (sales) made by a normal taxpayer registered under GST. It contains information about invoices, debit notes, credit notes, and revised invoices related to sales transactions.<br/><br/><b>Who Must File GSTR-1?</b><br/>Every normal taxpayer registered under GST must file GSTR-1. This return reflects detailed information about all sales transactions for the period.<br/><br/><b>Due Date to File GSTR-1</b><br/>The filing frequency for GSTR-1 depends on the taxpayer's annual turnover. The due dates can be extended by the commissioner through official notification.",
        },
        {
          title: "2. GSTR-2 & GSTR-2A",
          description:
            "<b>GSTR-2A: Read-Only Document</b><br/>GSTR-2A is a read-only document that is auto-populated with data from the supplier's GSTR-1. It allows the recipient to view and verify the details of their inward supplies (purchases). The recipient can check for any discrepancies between their records and the supplier's data.<br/><br/><b>GSTR-2: Return for Inward Supplies</b><br/>GSTR-2 was a monthly return for detailing inward supplies of goods and services. The information in GSTR-2 was auto-populated from GSTR-2A, and the recipient could make corrections if needed. The filing of GSTR-2 has been suspended since September 2017.",
        },
        {
          title: "3. GSTR-3B: Summary of Inward and Outward Supplies",
          description:
            "GSTR-3B is a monthly self-declaration and a summary return of inward and outward supplies. It is used to declare and pay the net GST liability for the tax period. It is an irreversible form, and both suppliers and recipients must file it separately.<br/><br/><b>Who Must File GSTR-3B?</b><br/>Every normal taxpayer registered under GST must file GSTR-3B, even if there is zero tax liability for the month (a Nil return must be filed).<br/><br/><b>Due Date to File GSTR-3B</b><br/>GSTR-3B must be filed by the 20th of the month succeeding the tax period.",
        },
        {
          title: "4. GSTR-4: Return for Composition Dealers",
          description:
            "GSTR-4 is the return that must be filed by taxpayers registered under the Composition Scheme. Previously a quarterly return, it is now filed annually.<br/><br/><b>Who Needs to File GSTR-4?</b><br/>Every registered taxpayer who has opted for the Composition Scheme.<br/><br/><b>Due Date to File GSTR-4</b><br/>The due date to file the annual GSTR-4 is the 30th of April following the end of the financial year.",
        },
        {
          title: "5. GSTR-5: Return for Non-Resident Taxable Persons",
          description:
            "GSTR-5 is a monthly return for non-resident taxable persons. It includes details of inward and outward supplies, interest, penalties, fees, and any other amounts payable under the GST Act.<br/><br/><b>Who Must File GSTR-5?</b><br/>A non-resident taxable person who occasionally supplies goods or services in India but does not have a fixed place of business in the country.<br/><br/><b>Due Date to File GSTR-5</b><br/>GSTR-5 must be filed within 20 days after the end of the calendar month or within 7 days after the last day of registration validity, whichever is earlier.",
        },
        {
          title: "6. GSTR-6: Return for Input Service Distributors",
          description:
            "GSTR-6 is a monthly return filed by an Input Service Distributor (ISD). It contains details of all invoices on which credit has been received and distributed. The details furnished in GSTR-6 are made available to the credit recipients in their GSTR-2A.<br/><br/><b>Who Must File GSTR-6?</b><br/>Every Input Service Distributor.<br/><br/><b>Due Date to File GSTR-6</b><br/>GSTR-6 must be filed by the 13th of the month following the tax period.",
        },
        {
          title: "7. GSTR-7: Return for Taxpayers Deducting TDS",
          description:
            "GSTR-7 is a monthly return that must be filed by persons who are required to deduct Tax at Source (TDS) under GST. It contains details of the TDS deducted, TDS liability, and any TDS refund claimed.",
        },
        {
          title: "8. GSTR-8: Return for E-Commerce Operators Collecting TCS",
          description:
            "GSTR-8 is a monthly return filed by e-commerce operators who are required to collect Tax at Source (TCS) under GST. This return includes details of supplies made through the e-commerce portal and the amount of TCS collected.<br/><br/><b>Who Must File GSTR-8?</b><br/>Every e-commerce operator who is required to deduct TCS.<br/><br/><b>Due Date to File GSTR-8</b><br/>GSTR-8 must be filed by the 10th of the month following the tax period.",
        },
        {
          title: "9. GSTR-9, 9B & 9C: Annual Returns",
          content: [
            {
              type: "h4",
              text: "GSTR-9: Annual Return for Normal Taxpayers",
              bullets: [
                "Every registered person must furnish an annual return in Form GSTR-9 for every financial year, except for Input Service Distributors, casual taxable persons, non-resident taxable persons, and those paying tax under Section 51 or 52. A Nil Annual Return must be filed even if there were no transactions. The due date is the 31st of December following the end of the financial year.",
              ],
            },
            {
              type: "h4",
              text: "GSTR-9B: Annual Return for E-commerce Operators",
              bullets: [
                "Every e-commerce operator who collects tax at source (TCS) and files GSTR-8 must also furnish an annual statement in Form GSTR-9B. The due date is the 31st of December following the end of the financial year.",
              ],
            },
            {
              type: "h4",
              text: "GSTR-9C: Reconciliation Statement",
              bullets: [
                "Every registered person with an aggregate turnover exceeding ₹2 crores in a financial year must get their accounts audited and submit a reconciliation statement in Form GSTR-9C, certified by a Chartered Accountant or Cost Accountant. The due date is the 31st of December following the end of the relevant financial year.",
              ],
            },
          ],
        },
        {
          title: "10. GSTR-10 & GSTR-11",
          content: [
            {
              type: "h4",
              text: "GSTR-10: Final Return",
              bullets: [
                "GSTR-10 is a final return that must be filed by a registered person whose GST registration has been canceled or surrendered. It must be filed within three months from the date of cancellation or the date of the cancellation order, whichever is later.",
              ],
            },
            {
              type: "h4",
              text: "GSTR-11: Return for UIN Holders",
              bullets: [
                "GSTR-11 is filed by persons who have been issued a Unique Identification Number (UIN) to claim a refund of GST paid on goods and services purchased in India. The due date is the 28th of the month following the month in which the supplies were received.",
              ],
            },
          ],
        },
        {
          title: "Penalty On Late Filing of GST Return",
          description:
            "Filing GST returns is mandatory for all businesses registered under GST, including those with no activity (nil returns). Filing after the due date results in late filing fees and interest penalties.",
          content: [
            {
              type: "h4",
              text: "Late Filing Fees for Intra-State Dealings",
              table: {
                headers: ["Governing GST Act", "Late filing fee per day"],
                rows: [
                  ["Central Goods & Services Act, 2017", "₹100"],
                  [
                    "State Goods & Services Act, 2017 or UTGST Act, 2017",
                    "₹100",
                  ],
                  ["Sum total", "₹200"],
                ],
              },
              description_after_table:
                "<b>Note:</b> The maximum late filing fee is capped at ₹5,000 for each monthly or quarterly return under CGST and SGST respectively. For the annual return (GSTR-9), the maximum late fee is 0.25% of the annual turnover.",
            },
            {
              type: "h4",
              text: "Late Filing Fees for Inter-State Dealings",
              bullets: [
                "According to the IGST Act, the penalty for late filing of IGST returns is the sum of penalties under the CGST and SGST/UTGST Acts, resulting in a fine of ₹200 per day. The maximum late fee for a monthly or quarterly IGST return is capped at ₹10,000, and for the annual return (GSTR-9), it is 0.25% of the turnover.",
              ],
            },
          ],
        },
        {
          title: "Consequences of Not Filing GST Return",
          description:
            "Non-filing of GST returns within the prescribed time can lead to penalties and the cancellation of the GST registration. Registration cancellation may occur if a registered person fails to submit returns for a continuous period of six months. Once canceled, a new GST registration cannot be obtained until all outstanding late filing penalties are paid.",
        },
        {
          title: "Process of GST Return Filing",
          description: "Here is a step-by-step process to file GSTR-1:",
          content: [
            {
              type: "process",
              title: "Filing Steps",
              steps: [
                {
                  step: 1,
                  title: "Login and Navigate",
                  description:
                    "Login to the GST portal and navigate to the GSTR-1 filing page.",
                },
                {
                  step: 2,
                  title: "Select Filing Period",
                  description:
                    "Choose whether you are filing a monthly or quarterly GSTR return.",
                },
                {
                  step: 3,
                  title: "Generate Summary",
                  description:
                    "Generate the GSTR-1 summary to review auto-populated details.",
                },
                {
                  step: 4,
                  title: "Fill in Details",
                  description:
                    "Fill in all required information for the current tax period, including any amendments to previous periods.",
                },
                {
                  step: 5,
                  title: "Preview GSTR-1",
                  description:
                    "Preview the draft GSTR-1 to ensure all details are correct before submission.",
                },
                {
                  step: 6,
                  title: "Verify and Submit",
                  description:
                    "Verify the information and submit GSTR-1 to save the entered data on the portal.",
                },
                {
                  step: 7,
                  title: "E-File the Return",
                  description:
                    "Complete the filing process by e-signing the return with a Digital Signature Certificate (DSC) or an Electronic Verification Code (EVC).",
                },
              ],
            },
          ],
        },
      ],
      features: [],
      tables: [],
      faq: [],
    },
  },
  "tds-return": {
    title: "TDS Return Filing",
    hero: {
      title: "TDS Return Filing",
      description:
        "TDS stands for Tax Deducted at Source. As per the government’s TDS Scheme, tax needs to be deducted at the time of making payment to the person. The person who makes the payment deducts & deposits TDS with the government. TDS is usually deposited to the government by submitting an ‘Income Tax Challan’ along with the payment. Besides depositing tax, as a Deductor, you must also file a TDS Return.",
      advantages: [
        "Ensures Compliance with IT Department",
        "Facilitates Claiming of TDS Credit",
        "Avoids Penalties and Higher TDS Rates",
        "Systematic Quarterly Tax Reporting",
        "Provides Valid TDS Certificate for Records",
      ],
      eligibleCriteria: [
        "Any person or entity making payments subject to TDS.",
        "Deductors who have deducted tax at source.",
        "Entities required to issue TDS certificates.",
        "Individuals/Companies holding a valid TAN.",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction to TDS Returns",
          description:
            "A TDS return is a quarterly statement that must be submitted to the IT department. It is compulsory for a Deductor to submit a TDS return on time. The details required to file TDS returns are:",
          content: [
            {
              type: "h4",
              text: "Required Details:",
              bullets: [
                "PAN of the deductor and the deductee",
                "Amount of tax paid to the government",
                "TDS challan information",
                "Others, if any",
              ],
            },
          ],
        },
        {
          title: "Types of TDS Return Forms",
          table: {
            title: "TDS Return Form Types",
            headers: ["Type", "Particulars"],
            rows: [
              ["Form 24Q", "Statement for TDS from salaries"],
              [
                "Form 26Q",
                "Statement for TDS on all payments except the salaries.",
              ],
              [
                "Form 27Q",
                "Statement for TDS on income earned from dividends, interests, or any other amount payable to non-residents.",
              ],
              ["Form 27EQ", "Statement of TCS (Tax Collected at Source)."],
            ],
          },
        },
        {
          title: "Due Dates for TDS Payment and Return Filing",
          description:
            "The due date for Payment of TDS deducted is the seventh of the next month. For Example, TDS payment for April will be made on or before the 7th of May.<br/><br/>The due date for TDS filing is as follows:",
          table: {
            title: "Quarterly Due Dates for TDS Return Filing",
            headers: ["S. No.", "Quarter Period", "Due date for Filing"],
            rows: [
              ["1.", "Q1 (1st April-30th June)", "On or before 31st July"],
              [
                "2.",
                "Q2 (1st July-30th September)",
                "On or before 31st October",
              ],
              [
                "3.",
                "Q3 (1st October-31st December)",
                "On or before 31st January",
              ],
              ["4.", "Q4 (1st January-31st March)", "On or before 31st May"],
            ],
          },
        },

        {
          title: "Failure to Furnish PAN",
          description:
            "Any person eligible to receive a payment for which TDS is required to be deducted must obtain a valid PAN and furnish the correct PAN to the deductor. Care must be taken to furnish the correct PAN so that the tax deducted can be credited to the correct account. Furthermore, non-furnishing of PAN or furnishing an incorrect PAN would result in the deductor incurring a higher TDS at a 20% rate and a penalty of ten thousand rupees.<br/><br/>Hence, before furnishing PAN for TDS, the deductee must check the PAN status (it must be active) and number. The PAN status and number can be checked through the 'Know Your PAN' website of the Income Tax Department. Before furnishing the PAN, ensure that it is in an active state. If the PAN status is inactive, the deductee must contact the jurisdictional Assessing Officer to change the PAN status to active.",
        },
        {
          title: "TDS Certificate",
          description:
            "While deducting TDS, the deductor should furnish a TDS certificate to the deductee. The deductee can cross-check the tax credit by viewing the certificate. A valid TDS certificate is one downloaded from TRACES (http://www.tdscpc.gov.in) bearing a 7-digit unique certificate number and the TRACES watermark.<br/><br/>All TDS certificates must be preserved by the Deductee. TDS certificates for payments other than salary are issued on a quarterly basis, and the TDS certificate for salary is provided on an annual basis. If the TDS certificate is lost, the deductee can request a duplicate.",
        },
        {
          title: "Claiming TDS & Prerequisites",
          description:
            "TDS credit can be claimed by the deductee. To claim the credit, the deductee has to mention the details of the TDS in their income tax return. The deductee should take due care to quote the correct TDS certificate number and details while filing the return. If any incorrect detail is provided, a tax credit discrepancy will arise during the processing of the return, which can cause problems. The NSDL e-Gov has prepared a software solution, the e-TDS/TCS return preparation utility (RPU), to ease the preparation of e-TDS/TCS returns.",
          content: [
            {
              type: "h4",
              text: "Prerequisites to Upload TDS Return",
              bullets: [
                "E-filing Registered and Valid TAN",
                "Return Preparation Utility (RPU) must be used for preparing TDS statements and File Validation Utility (FVU) for validation.",
                "One can also prepare the return using Gen TDS software.",
                "A valid DSC must be registered for uploading with DSC.",
                "A Demat account or the principal contact’s bank account must be provided, or the principal contact’s PAN must be linked with Aadhaar for uploading via EVC.",
              ],
            },
          ],
        },
        {
          title: "Process for E-filing of TDS Return",
          description:
            "To simplify the e-filing of TDS, the government of India has introduced a return preparation software solution, the e-TDS/TCS return preparation utility (RPU). Let's go through the steps to use the utility available on NSDL for the e-filing of a TDS return.",
          content: [
            {
              type: "process",
              title: "TDS E-Filing Steps",
              steps: [
                {
                  step: 1,
                  title: "Registration of TAN",
                  description:
                    "Register your TAN on TRACES using a token number and the challan details of a previously filed return, followed by registration on the E-filing portal.",
                },
                {
                  step: 2,
                  title: "Download Utilities from TIN-NSDL",
                  description:
                    "Download the necessary utilities from the TIN-NSDL website. The two main utilities are:<ul><li><b>RPU (Return Preparation Utility):</b> For the preparation of the TDS Return.</li><li><b>FVU (File Validation Utility):</b> For the authentication of data in the RPU by matching it with the CSI File.</li></ul>",
                },
                {
                  step: 3,
                  title: "Download CIN File",
                  description:
                    "Download the CIN (Challan Status Inquiry) File, which is needed for data verification. Steps to download:<ul><li>Go to the OLTAS portal on the TIN-NSDL website.</li><li>Click on 'TAN BASED VIEW'.</li><li>Enter the required details to download the file.</li></ul>",
                },
                {
                  step: 4,
                  title: "Prepare the Return in RPU",
                  description:
                    "After downloading the utilities, open the RPU. Choose the relevant form number, select 'Regular', and click 'Continue'.",
                },
                {
                  step: 5,
                  title: "Enter Details",
                  description:
                    "Fill in all the relevant details for the TDS return accurately in the utility.",
                },
                {
                  step: 6,
                  title: "Create and Validate File",
                  description:
                    "Save the file and click on 'Create File'. A dialog box will appear; select the CSI File you downloaded earlier.",
                },
                {
                  step: 7,
                  title: "Generate Statistics Report",
                  description:
                    "In the next box for the 'Error and statistics report file path,' select the folder to store the generated files and click 'Validate'. This will generate and save a file.",
                },
                {
                  step: 8,
                  title: "Use File Validation Utility (FVU)",
                  description:
                    "Open the FVU. In the dialog box, select the file with the .txt extension generated in the previous step. Then, select the CSI file and a destination folder for the output files.",
                },
                {
                  step: 9,
                  title: "Validate and Correct Errors",
                  description:
                    "Click on 'Validate'. This will generate a few files. An error file will be generated if any mistakes are found. Correct any mistakes, recreate the file, and revalidate.",
                },
                {
                  step: 10,
                  title: "Create ZIP File",
                  description:
                    "Convert the '.fvu' extension file into a ZIP file.",
                },
                {
                  step: 11,
                  title: "Log in and Upload",
                  description:
                    "Log into the E-Filing portal using the registered TAN. Navigate to TDS and select 'Upload TDS'. Enter the details, upload the ZIP File and Signature file, and submit the return.",
                },
                {
                  step: 12,
                  title: "Check Status",
                  description:
                    "Check the status of the filed return on TRACES after 2-3 days.",
                },
              ],
            },
          ],
        },
      ],
      features: [],
      tables: [],
      faq: [],
    },
  },
  "gst-audit": {
    title: "GST Audit",
    hero: {
      title: "GST Audit",
      description:
        "GST Audit refers to the examination of the returns, records, and other important documents which a taxable individual maintains. Besides confirming adherence to the provisions of GST, other motives behind a GST audit are to verify the fairness and accuracy of the turnover notified, input tax credit availed, and refunds claimed.",
      advantages: [
        "Ensures Adherence to GST Provisions",
        "Verifies Accuracy of Declared Turnover",
        "Validates Correctness of Input Tax Credit (ITC) Availed",
        "Confirms Legitimacy of Refunds Claimed",
        "Identifies and Rectifies Discrepancies to Avoid Penalties",
      ],
      eligibleCriteria: [
        "Registered taxable individuals with turnover exceeding ₹2 Crores in a financial year.",
        "Taxpayers selected by the GST Commissioner for a General Audit.",
        "Taxpayers ordered by the Assistant/Deputy Commissioner for a Special Audit.",
        "Businesses required to file GSTR-9 and the reconciliation statement in GSTR-9C.",
      ],
    },
    content: {
      overviews: [
        {
          title: "Types of GST Audit",
          description:
            "<b>Note:</b> As per the notification dated 23 March 2020, for businesses having an annual turnover of below 5 crores, the filing of GSTR-9C for FY 2018-19 is not mandatory.",
          table: {
            title: "Comparison of GST Audit Types",
            headers: ["Types", "Conducted By", "Circumstance that mandates it"],
            rows: [
              [
                "Turnover based Audit",
                "Cost Accountant or Chartered Accountant appointed by the taxpayer",
                "When the Turnover exceeds 2 crores the taxpayer needs to get his records & accounts audited",
              ],
              [
                "Normal audit/General Audit",
                "CGST/SGST Commissioner or any official empowered by him",
                "On commissioner’s order after the issuance of 15 days prior notice",
              ],
              [
                "Special audit",
                "A Cost Accountant or Chartered Accountant, authorised by Commissioner",
                "On Deputy/Assistant Commissioner’s order after commissioner’s approval.",
              ],
            ],
          },
        },
        {
          title: "Threshold and Requirements for GST Audit",
          description:
            "If the turnover of the registered taxable individual during a financial year surpasses ₹2 Crore, they must get their accounts audited by a Cost Accountant or Chartered Accountant. They shall electronically file the below-mentioned alongside the respective attachments:",
          content: [
            {
              type: "h4",
              text: "Documents to be e-filed:",
              bullets: [
                "Annual Return in the Form GSTR 9 on or before 31st Dec. of the next FY.",
                "A Certified Reconciliation Statement in form GSTR-9C, for reconciling the values as declared under the respective return with the audited annual financial statements.",
                "Copies of the Audited Annual Accounts.",
                "Other particulars (if specified).",
              ],
            },
          ],
        },
        {
          title: "General Audit",
          description:
            "A General Audit is conducted under Section 65 of the CGST Act by officers authorised by the GST Commissioner, who issues a general order to conduct an audit of the registered taxable individual. This Audit is performed at the business place of the registered taxable person after a prior intimation is sent to the auditee in Form GST ADT-01 at least 15 days before the audit.<br/><br/>The General Audit must be completed within a period of 3 months from its initiation. However, in a few exceptional cases, the tenure to complete the general audit can be extended by 6 months by the GST Commissioner. On the successful completion of the Audit, a report is submitted by the auditor to the registered person, along with a summary of findings discovered during the audit process in Form GST ADT-02, within a period of 30 days.<br/><br/>During the process, the registered taxable individual must provide complete cooperation and details, including records, returns, and the facility to verify books, statements, deductions, inventory, the amount of input tax credit availed, GST rates applied, etc.",
        },
        {
          title: "Special Audit",
          description:
            "A Special Audit is conducted by the Assistant Commissioner when they find any incorrect value, declaration, or amount of credit availed at any phase while conducting scrutiny or investigation. Based on the case’s nature and complexity, the special audit can be conducted even when the books of the taxpayer have already been audited. A special audit may be initiated in writing by the Assistant Commissioner with prior confirmation from the Commissioner. To carry out the audit, the commissioner appoints a Chartered Accountant or Cost Accountant.<br/><br/>The report for the special audit must be submitted by the auditor within a period of 90 days from the commencement of the audit. However, the period may be further extended for another 90 days by the authorised official upon request from the taxable individual or the auditor. The expenses incurred on the audit, including the remuneration of the auditor, are calculated and paid by the Commissioner.",
        },
        {
          title: "Post-Special Audit Actions",
          description:
            "On the completion of a special audit, an opportunity to present justifications is given to the taxable individual regarding the findings of the audit. If any unpaid or short-paid tax or wrongly availed input tax credit is discovered, recovery actions are initiated.",
        },
        {
          title: "Due Date to Submit GST Audit Report",
          description:
            "The due date for the submission of GSTR-9 and GSTR-9C is December 31st of the subsequent financial year.<br/><br/><b>Note:</b> The due date for filing GSTR-9C for Financial Year 2023-24 has been extended to September 30th. The filing of GSTR-9 and GSTR-9C for businesses with a turnover of up to ₹2 crores was made optional for the Financial Years 2023-24 and 2024-25.",
        },
        {
          title: "Penalty on Non-submission of GST Audit Report",
          description:
            "A general penalty of ₹25,000 is applicable for the non-submission of a GST Audit report. However, no specific penalty in this regard has been laid down by the law.",
        },
      ],
      features: [],
      tables: [],
      faq: [],
    },
  },
  "bank-audit": {
    title: "Bank Audit",
    hero: {
      title: "Bank Audit Services",
      description:
        "Banks are the foundation of our economy. They handle a huge amount of deposits and savings of the public, so they have to be closely monitored and reviewed. A bank audit is one important process of this monitoring.<br/><br/>‘Audit’ or ‘Auditing’ refers to an activity that is carried out by any business entity on its own or to fulfil a compulsion laid under any law to evaluate the transactions, accounts, and documents of the business and to confirm its accuracy and legitimacy. This examination is conducted by internal or external auditors.",
      advantages: [
        "Evaluates daily transactions to ensure regularity",
        "Detects and rectifies irregularities and frauds at an early stage",
        "Ensures smooth, accurate, and secure information flow",
        "Verifies compliance with statutory norms (PSL, SLR, CRR)",
        "Confirms the accuracy and legitimacy of financial statements",
      ],
      eligibleCriteria: [
        "All banking institutions regulated by the Reserve Bank of India (RBI).",
        "Banks requiring evaluation of internal controls and information systems.",
        "Branches needing continuous monitoring of daily transactions.",
        "Banks mandated by law to have an annual statutory audit.",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction and Categories of Bank Audit",
          description:
            "A Bank Audit is an essential evaluation of a bank's accounts, transactions, and documents to ensure accuracy and legitimacy. It can be divided into three main categories:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "Concurrent Audit",
                "Internal Audit or Information Systems Audit",
                "Statutory Audit",
              ],
            },
          ],
        },
        {
          title: "Concurrent Audit",
          description:
            "A concurrent audit is the examination of transactions at the time they are actually taking place. The primary purpose is to ensure the smooth flow of work in bank branches and to rectify any mistakes immediately, preventing the cascading effect of irregularities. It helps to detect fraud at the formation level, which leads to the protection of public funds.",
          content: [
            {
              type: "h4",
              text: "Features of Concurrent Audit:",
              bullets: [
                "<b>Continuous Audit:</b> It is a continuous audit that takes place throughout the year.",
                "<b>Monthly Basis:</b> It is usually carried out every month by external auditors (typically Chartered Accountants).",
                "<b>Evaluation of Daily Transactions:</b> It involves evaluating and checking daily transactions, which assures regularity.",
              ],
            },
          ],
        },
        {
          title: "Internal Audit or Information Systems Audit",
          description:
            "Internal Auditing is when any organization, including a bank, constitutes an audit team within its own organization to cater to its auditing requirements. An Internal Audit may focus on any specified area or cover every aspect of the branch, depending on its audit programs and requirements. The Internal Auditors visit branches one by one and carry out the audit process.",
          content: [
            {
              type: "h4",
              text: "Features of Internal Audit:",
              bullets: [
                "<b>One-by-one Visit:</b> The internal auditors visit branches one by one at the place and time when auditing is to be done.",
                "<b>Aspect-centric:</b> The audit may concentrate on any particular area/aspect of the branch or the whole spectrum of the branch, based on the audit program and need.",
                "<b>Conducted by the Organization Itself:</b> An internal audit is conducted by the organization itself.",
              ],
            },
          ],
        },
        {
          title: "Purpose of Internal and Information Systems Audit",
          description:
            "Internal control audits aim to ensure the smooth, accurate, and safe flow of information within the organization through its channels, focusing on security.<br/><br/>With the rapid advancement in computerization in the banking sector (core banking, ATMs, mobile banking, internet banking), it has become necessary to have a periodical review of these systems. An Information Systems Audit looks at the information flow, channels, and security. It also checks and reviews the workability of new banking software and their rating on security and access.",
        },
        {
          title: "Statutory Audit",
          description:
            "A Statutory Audit is an audit that is mandatorily conducted by a Statutory Auditor as required by law. In the case of Banks, a statutory audit is a mandatory requirement prescribed by the RBI. The Statutory Auditor is appointed by the RBI in association with the Institute of Chartered Accountants of India (ICAI).",
          content: [
            {
              type: "h4",
              text: "Features of Statutory Audit:",
              bullets: [
                "<b>Conducted Annually:</b> A Statutory Audit is conducted every year at the end of March or the beginning of April, marking the closure of the financial year.",
                "<b>Concludes NPA:</b> It is a very important audit as it concludes the status of Non-Performing Assets (NPA), which affects the bank’s profits, its Balance Sheet and Profit & Loss Account, and ultimately the dividends of the shareholders.",
                "<b>RBI Appoints Auditors:</b> The RBI appoints the Statutory Auditors in association with the ICAI to appoint Chartered Accountants for conducting the audit.",
              ],
            },
          ],
        },
        {
          title: "Purpose and Summary of Bank Audits",
          description:
            "The purpose of a Statutory Audit is to focus on loans & advances, adherence to Priority Sector Lending (PSL) requirements, SLR, CRR, and so on, along with compliance with other statutory norms according to the latest notifications by the RBI.<br/><br/>Banks carry out numerous transactions on a daily basis, which leads to voluminous documentation and other formalities they have to comply with. A concurrent audit helps to identify any irregularities and non-conformities quickly and rectify them readily. This prevents the accumulation of irregularities, which can become a major issue for any branch during the year-end audit. Concurrent Auditors check for adherence to daily maximum cash balance, KYC norms, proper documentation for loan disbursement, and income leakage, with such details furnished in the concurrent audit report.<br/><br/>The concurrent and internal audits take care of the fundamental working of the banks, whereas the Statutory Audit focuses on loans & advances, loan disbursement as per RBI rules, and compliance with PSL, SLR, CRR, etc. Therefore, a Bank Audit is a crucial activity conducted by both internal and external auditors to confirm compliant and fair banking practices.",
        },
      ],
      features: [],
      tables: [],
      faq: [],
    },
  },
  "ngo-audit": {
    title: "NGO Audit",
    hero: {
      title: "NGO Audit Services",
      description:
        "A Non-governmental organization (NGO) refers to an organization established by a group of people to render services not with the intention of profit but with the sole purpose to help society. An NGO is described as a non-profit making organization in which funds are raised from members, donors, or contributors, in addition to receiving donations of time, energy, and skills for accomplishing social objectives such as imparting education, providing economic assistance to the needy, offering medical facilities, and managing disasters and other emergent situations.",
      advantages: [
        "Provides proof of authenticity for financial statements",
        "Enhances credibility with donors, trustees, and the public",
        "Ensures proper utilization of funds and legal compliance",
        "Offers access to valuable advice on financial methods and controls",
        "Helps in securing additional funding from donors",
      ],
      eligibleCriteria: [
        "All registered NGOs (Trusts, Societies, Section 8 Companies).",
        "NGOs receiving government grants, subsidies, or foreign contributions.",
        "Organizations required to file Income Tax returns.",
        "NGOs seeking to enhance transparency and credibility for donors.",
      ],
    },
    content: {
      overviews: [
        {
          title: "Introduction to NGO Audits",
          description:
            "NGOs are formed to serve the nation and its people. Their main source of income is donations, subsidies, and grants from governments and other donors. NGOs must maintain books of accounts for all incoming and outgoing funds. For their own interest and to assure donors, NGOs can have their books audited by an independent external auditor. NGOs are also required to file necessary IT returns as they are legal entities.",
        },
        {
          title: "Forms of NGO",
          description: "NGOs can be constituted in various forms:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>Trust:</b> Organized for philanthropic and religious purposes, a trust is established by a Trust Deed. The Charitable Endowment Act, 1890, and the Charitable and Religious Act, 1920, govern the establishment of charitable trusts.",
                "<b>Society:</b> A society is an organization of people who come together by common assent to act jointly for mutual purposes. It must be formed under the Societies Registration Act, 1860.",
                "<b>Section 8 Company:</b> Governed by the Companies Act, 2013, a Section 8 Company is formed with charitable objectives to promote arts, commerce, education, charity, environmental protection, sports, science, research, social welfare, or religion.",
              ],
            },
          ],
        },
        {
          title: "Audit Procedure for an NGO",
          description:
            "Non-profit organizations operate with public donations, making it crucial to prepare financial accounts and statements to showcase the authenticity of their performance. When these accounts are audited by an independent Chartered Accountant, their validity is enhanced. The general audit procedure is as follows:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "Similar to other business audits, the auditor first checks all books with previous data, followed by checking accounts and the trial balance.",
                "Checking receipt & payment accounts and income & expenditure accounts is a vital phase. The auditor checks the amounts received, the sources of funds, vouchers, and the nature of expenses (revenue or capital).",
                "The auditor prepares an audit report after thoroughly verifying all financial statements, including social accounting.",
              ],
            },
          ],
        },
        {
          title: "Key Steps an Auditor Takes",
          description: "",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "The auditor must understand the memorandum of the NGO, including its activities and operational field.",
                "They must check the legality of the NGO and its compliance with various acts like the Income-tax Act, Labour Law, ESIC, etc.",
                "Auditors verify that all income (grants, donations) comes from legitimate sources.",
                "A separate bank account must be maintained for government grants for proper recording.",
                "The auditor verifies the investment and expenditure of funds, ensuring transparency.",
                "The NGO must keep an updated record of all expenditures to ensure funds are used for the NGO's sole motto.",
                "Auditors confirm the applicability of Sections 12AA and 80G and verify that receipts issued to donors match the donation register.",
                "A background check of all NGO executives, officials, and connected people is also carried out.",
              ],
            },
          ],
        },
        {
          title: "Types of Financial Audits for NGOs",
          description:
            "There are four main types of financial audits for NGOs to independently examine their activities and ensure adherence to laws:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>External Audit:</b> Executed by independent auditors to provide a professional opinion on the credibility and fairness of financial statements. This provides proof that financial reports are true and can be trusted by stakeholders.",
                "<b>Internal Audit:</b> Can be executed by the NGO's staff or hired professionals. It includes verifying that the NGO's policies and procedures are in consonance with the law, offering updated information to trustees.",
                "<b>Donor Audit:</b> Performed by the NGO’s external auditors or by the donors themselves. This builds confidence among donors that their contributions have been utilized correctly. A successful audit often leads to additional funding.",
                "<b>Investigative Audit:</b> Performed when an NGO suspects a particular issue, usually related to fraud. The auditor's role is to uncover all relevant facts and provide evidence for any next steps the NGO may take.",
              ],
            },
          ],
        },
        {
          title: "Purposes of Different Audits",
          description: "",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "An <b>external audit</b> examines the authenticity, accuracy, and fairness of the financial statements.",
                "An <b>internal audit</b> examines the policies and procedures followed by the NGO.",
                "A <b>donor audit</b> examines compliance with the terms and conditions of a grant.",
                "An <b>investigative audit</b> scouts for evidence related to a specific suspected wrongdoing.",
              ],
            },
          ],
        },
        {
          title: "Benefits of an Audit for an NGO",
          description:
            "There are plenty of benefits when an NGO is audited. The two main advantages are:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "<b>Proof of Authenticity:</b> Audits help an NGO provide proof of its authenticity and honesty in its financial statements and practices.",
                "<b>Auditor’s Advice:</b> Auditors are updated with the latest government amendments and can provide valuable advice on financial methods and controls. An audit allows an NGO to apply the knowledge given by auditors and get help in investigating particular issues.",
              ],
            },
          ],
        },
      ],
      features: [],
      tables: [],
      faq: [],
    },
  },
  "tax-audit": {
    title: "Tax Audit",
    hero: {
      title: "Tax Audit Services",
      description:
        "An audit refers to an official inspection or unbiased investigation of a firm's or company's financial statements and reports, typically by an autonomous body. While there are various types of audits under different laws (company audit, statutory audit, etc.), an audit conducted under the Income Tax Act is termed a 'Tax Audit'. A tax audit is an inspection of the accounts of any business or profession, which helps in the proper assessment of income for filing Income Tax Returns (ITRs).",
      advantages: [
        "Ensures proper maintenance and correctness of financial records.",
        "Facilitates accurate income estimation for ITR filing.",
        "Verifies compliance with various provisions of the Income Tax Act.",
        "Aids in the timely and accurate claim of deductions.",
        "Reduces the likelihood of scrutiny from tax authorities.",
      ],
      eligibleCriteria: [
        "Businesses with total sales, turnover, or gross receipts exceeding ₹1 crore in the financial year.",
        "Professionals with gross receipts exceeding ₹50 lakh in the financial year.",
        "Taxpayers under presumptive taxation schemes who claim profits lower than the specified limits.",
        "Businesses incurring a loss where the total turnover exceeds the prescribed threshold.",
      ],
    },
    content: {
      overviews: [
        {
          title: "Objectives of Tax Audit",
          description:
            "Tax audits are conducted with a few predetermined objectives which are as follows:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "To ensure the proper maintenance and correctness of the taxpayer's books of accounts and to have them certified by an auditor.",
                "To report important information such as tax depreciation, compliance with various provisions of the Income Tax law, and so on.",
                "To report observations or discrepancies identified by the tax auditor after a methodical examination of the accounts.",
                "To assist tax officials in verifying the accuracy of the income tax returns filed by the taxpayer.",
                "To properly estimate and verify the total income and facilitate the claims for deductions.",
              ],
            },
          ],
        },
        {
          title: "Mandatory Applicability of Tax Audit",
          description:
            "A tax audit is mandatory for certain categories of taxpayers based on their turnover or gross receipts.",
          table: {
            title: "Tax Audit Threshold Limits under Section 44AB",
            headers: ["Category of Taxpayer", "Applicability Threshold"],
            rows: [
              [
                "Business",
                "Total sales, turnover, or gross receipts exceed ₹1 crore in the financial year. This does not apply to those who opted for the presumptive taxation scheme.",
              ],
              [
                "Business under Presumptive Taxation (Sec 44AE, 44BB, 44BBB)",
                "Applicable if the taxpayer claims profits or gains less than the specified limit under the respective presumptive taxation scheme.",
              ],
              [
                "Business under Presumptive Taxation (Sec 44AD)",
                "Applicable if the declared taxable income is less than the limit specified under the presumptive scheme, and the total income exceeds the basic exemption limit.",
              ],
              [
                "Profession",
                "Total gross receipts from the profession exceed ₹50 lakh in the financial year.",
              ],
              [
                "Profession under Presumptive Taxation (Sec 44ADA)",
                "Applicable if the taxpayer claims profits less than the specified limit under the scheme, and their total income exceeds the basic exemption limit.",
              ],
              [
                "Business Loss",
                "If a taxpayer incurs a loss from a business where the total sales, turnover, or gross receipts exceed ₹1 crore, they are subject to a tax audit.",
              ],
            ],
          },
        },
        {
          title: "Tax Audit Report Filing Process",
          description:
            "The Chartered Accountant appointed to conduct a tax audit must file the report online using their login credentials.<br/><br/>The taxpayer must also provide details of the appointed Chartered Accountant in their own login portal.<br/><br/>Once the tax auditor uploads the report, the taxpayer must either accept or reject it through their portal. If the report is rejected, the entire process must be repeated until the taxpayer accepts the audit report.<br/><br/>The tax audit report must be filed on or before the due date for filing the income tax return, which is typically 30th September of the assessment year (or 30th November for taxpayers with international transactions).",
        },
        {
          title: "Rules, Penalties, and Waivers",
          description: "",
          content: [
            {
              type: "process",
              title: "",
              steps: [
                {
                  step: 1,
                  title: "Important Rules for Tax Auditing",
                  description:
                    "Taxpayers should note the following:<ul><li>If a taxpayer is engaged in multiple businesses and the combined turnover exceeds ₹1 crore, an audit is required.</li><li>If a taxpayer is engaged in multiple professions and the combined gross receipts exceed ₹50 lakh, an audit is required.</li><li>If a taxpayer is in both business and profession, the turnover and gross receipts are considered separately. For instance, if business turnover is ₹90 lakh and professional receipts are ₹40 lakh, no audit is mandatory for either.</li><li>Gains from the sale of fixed assets are not included in the turnover or gross receipts for calculating the audit threshold.</li><li>Tax audit reports are generally not reversible, but can be revised if there is an amendment in law or a change in interpretation after the accounts have been adopted at an AGM.</li></ul><b>Forms Required for Tax audit:</b><br/><b>Form 3CA/3CB:</b> Audit report form.<br/><b>Form 3CD:</b> A detailed statement of particulars to be furnished along with the audit report.",
                },
                {
                  step: 2,
                  title: "Penalty for Non-compliance",
                  description:
                    "If a taxpayer who is required to get a tax audit done fails to do so, a penalty may be levied. The penalty will be the lesser of the following:<ul><li>0.5% of the total sales, turnover, or gross receipts</li><li>₹1,50,000</li></ul>",
                },
                {
                  step: 3,
                  title: "Waiver of Penalty",
                  description:
                    "A penalty may be waived if the taxpayer can provide a reasonable cause for the failure to comply. Reasonable causes may include:<ul><li>Delay caused by the resignation or withdrawal of the tax auditor.</li><li>Delay due to the death or physical disability of a partner responsible for the accounts.</li><li>Delay due to labor issues such as strikes or lock-outs.</li><li>Loss of accounts due to events beyond the assessee's control, such as theft or fire.</li><li>Delays caused by natural disasters.</li></ul>",
                },
              ],
            },
          ],
        },
      ],
      features: [],
      tables: [],
      faq: [],
    },
  },
  "tax-audit": {
    title: "Tax Audit",
    hero: {
      title: "Tax Audit Services",
      description:
        "An audit refers to an official inspection or unbiased investigation of a firm’s or company's financial statements or reports, as well as the production of reports, typically by an autonomous body. There are various types of audits under different laws such as company audit, statutory audit, cost audit, and stock audit. Similarly, an audit compensated under the Income Tax Act is termed a ‘Tax Audit’. A tax audit is an inspection or study of the accounts of any firm or trade executed by taxpayers, which eases the income estimation for filing ITRs.",
      advantages: [
        "To ensure total maintenance and correctness of records of tax accounts along with the approval on the same by the auditor.",
        "To report important information such as tax shrinkage, agreement of various provisions of income tax law, and so on.",
        "To report the observations or discrepancies caught by the tax auditor after a methodical examination of the records of account.",
        "To enable tax officials to ensure the accuracy of income tax returns filed by the firm or business.",
        "To estimate and verify the total income and ease the claim for deductions.",
      ],
      eligibleCriteria: [
        "Business with total sales, gross receipts or turnover surpassing ₹1 crore.",
        "A profession with total gross receipts surpassing ₹50 lakh.",
        "Businesses under presumptive taxation (e.g., 44AD, 44AE) claiming profits less than the specified limit.",
        "Individuals with income surpassing the basic threshold limit who have incurred a business loss.",
        "Taxpayers opting out of the presumptive taxation scheme within the lock-in period.",
      ],
    },
    content: {
      overviews: [
        {
          title: "Objectives of Tax Audit",
          description:
            "Tax audits are conducted with a few predetermined objectives which are as follows:",
          content: [
            {
              type: "h4",
              text: "",
              bullets: [
                "To ensure total maintenance and correctness of records of tax accounts of the party along with the approval on the same by the auditor.",
                "To report important information such as tax shrinkage, agreement of various provisions of income tax law, and so on.",
                "To report the observations or discrepancies caught by tax auditor after a methodical examination of the records of account.",
                "To enable tax officials ensure the accuracy of income tax returns filed by the firm or business.",
                "To estimate and verify the total income and ease the claim for deductions.",
              ],
            },
          ],
        },
        {
          title: "Mandatory Subject to Tax Audit",
          description: "",
          table: {
            title: "Tax Audit Threshold Limits",
            headers: ["Category", "Threshold Limit"],
            rows: [
              ["<strong>Business</strong>", " "],
              [
                "Engaged in business but not opted for presumptive taxation scheme",
                "Total sales, gross receipts or turnover surpasses ₹1 crore in the Financial Year",
              ],
              [
                "Engaged in business qualified for presumptive taxation u/s 44AE, 44BB or 44BBB",
                "Claims gains/profits less than the specified limit under presumptive taxation scheme",
              ],
              [
                "Engaged in business qualified for presumptive taxation u/s 44AD",
                "Notifies taxable income less than specified limit under the presumptive tax scheme and has income surpassing the basic threshold limit value (TLV)",
              ],
              [
                "Engaged in business but unqualified for presumptive taxation u/s 44AD because of withdrawing from it in any of the FY of the 5-year lock-in period.",
                "If income surpasses the maximum amount that does not attract tax in the just next 5 consecutive tax years from the FY when the presumptive taxation was not chosen.",
              ],
              [
                "Engaged in business which is notifying profits in accordance with presumptive taxation scheme u/s 44AD",
                "If the total sales, gross receipt, or turnover is less than ₹2 crore in the FY, then tax audit will not be applicable to such businesses.",
              ],
              ["<strong>Profession</strong>", " "],
              [
                "Practicing a profession",
                "Total gross receipts surpass ₹50 lakh in the FY",
              ],
              [
                "Practicing a profession qualified for presumptive taxation u/s 44ADA",
                "1. Claims profits less than the specified limit under the presumptive taxation scheme<br/><br/>2. Income surpasses the maximum value that does not attract income tax.",
              ],
              ["<strong>Business loss</strong>", " "],
              [
                "In the event of loss from conducting a business and not choosing presumptive taxation scheme",
                "Total sales, gross receipts or turnover surpass ₹1 crore",
              ],
              [
                "If the total income of the taxpayer surpasses basic TLV but suffered a business loss (not opting for presumptive taxation scheme)",
                "In the event of loss from business when sales, gross receipts or turnover surpass ₹1 crore, the taxpayer is a mandatory subject to tax audit u/s 44AB",
              ],
              [
                "Engaged in business (opting presumptive taxation scheme u/s 44AD) and suffered a loss but with income below basic TLV",
                "Tax audit does not apply",
              ],
              [
                "Engaged in business (presumptive taxation scheme u/s 44AD applicable) and suffered a loss but with income surpassing basic TLV",
                "Declares taxable income less than the limit specified under the presumptive tax scheme and has income surpassing the basic TLV",
              ],
            ],
          },
        },
        {
          title: "Report Filling Process of Tax Audit",
          description:
            "The Chartered Accountant who has been selected to conduct a tax audit of an individual or a firm has to report online for the tax audit, using his/her valid login credentials.<br/><br/>The taxpayer also has to specify the details about the Chartered Accountant, appointed by him/her, in their login platform.<br/><br/>Once the tax audit report is uploaded by the auditor i.e. the CA, it has to be either received or declined by the taxpayer on their login portal. If the taxpayer declines the tax audit papers, the complete process has to be revised until the tax audit report is confirmed by him/her.<br/><br/>The tax audit record has to be filed on or before the pre-stated date of filing income return i.e. 30th November of the subsequent evaluation year for taxpayers who have engaged in international business and 30th September of the subsequent evaluation year for other taxpayers.",
        },
        {
          title: "Key Aspects of Tax Audit Compliance",
          content: [
            {
              type: "process",
              title: "Audit Rules, Penalties, and Waivers",
              steps: [
                {
                  step: 1,
                  title: "Rules for Auditing Tax",
                  description:
                    "The following points should be noted by taxpayers during a tax audit:<ul><li>If the taxpayer is engaged in more than one business and the total turnover of all the businesses is more than ₹1 crore, he/she is liable to get his/her accounts audited.</li><li>If the taxpayer is engaged in practicing more than one profession and the gross receipts from all the professions surpasses the limit of ₹50 lakhs, he/she is liable to get his/her accounts audited.</li><li>If the taxpayer is engaged in carrying out a business as well as practicing a profession, then tax audit does not rely on the summed up turnover from both. If the business turnover is more than one crore then an audit is mandatory for the business accounts and if the gross receipts from the profession are above ₹50 lakhs then an audit of the profession accounts is mandatory. However, if the business turnover is ₹90 lakhs and gross receipt from profession is ₹40 lakhs, no audit of either of the accounts is mandatory.</li><li>If the turnover of a business or profession is less than one crore or ₹50 lakhs, but there is a sale of fixed assets like vehicles or immovable property, the gain from the sale of assets will not be treated as business or professional gain and will remain excluded from total turnover or gross receipts of business or profession.</li><li>Tax audit reports are irreversible. However, in case the accounts have been revised after due acceptance at the AGM due to amendment in law or interpretation of law, the filed audit report can be changed.</li></ul><br/><b>Forms Required for Tax audit:</b><br/><b>Form 3CB:</b> For tax audit reports prescribed u/s 44AB of the IT Act, 1961.<br/><b>Form 3CD:</b> To report Form 3CB and the specified details.<br/><b>Form 3CA and Form 3CD:</b> Form 3CA is the appropriate form when a taxpayer wants to get the accounts audited under any law except u/s 44AB; the prescribed information needs to be reported in Form 3CD.",
                },
                {
                  step: 2,
                  title: "Penalty for non-adherence to Tax audit",
                  description:
                    "If any taxpayer who is required to get the tax audit performed but fails to do so, the least of the following may be levied as a punishment:<ol><li>0.5% of the total sales</li><li>0.5% of the turnover</li><li>0.5% of gross receipts</li><li>₹1,50,000</li></ol>",
                },
                {
                  step: 3,
                  title: "Waiver in Penalty for non-adherence to Tax audit",
                  description:
                    "A penalty is waived only when a taxpayer is capable of showing a reasonable cause for non-compliance.<ul><li>Delay caused due to the withdrawal by the tax auditor</li><li>Delay caused due to loss or physical disability of the partner liable for accounts</li><li>Delay caused out of labor concerns such as sit-ins or lock-outs</li><li>Delay caused due to loss of accounts because of robbery or attack, or events that are not under the assessee's control</li><li>Natural disasters</li></ul>",
                },
              ],
            },
          ],
        },
      ],
      features: [],
      faq: [],
    },
  },
  // Add more services with the new structure...
};
